/**
 * Content data - generated from Mux CSV.
 *
 * 642 drills across 3 sections.
 * Generated: 2026-04-15T13:47:49.747Z
 *
 * To regenerate: node launch-prep/scripts/csv-to-content.js
 */

export const PD_ITEMS = [
  {
    "id": 1,
    "title": "Angle Recovery 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:34",
    "muxPlaybackId": "sKAXrMREhF7kiSsK001uew2WQ6QubqWlayFpSb01tL7qM",
    "muxAssetId": "6jDZAyE5hwtR3ZkM023d00GmDpoXCNqKfuVR8oIAnX7cY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 2,
    "title": "Ball Overhead 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "ozX00XKfWCz4pWk2E4nxk6p8U4U7IRX00ASZkw2tnz2TM",
    "muxAssetId": "1Cet007qIw7h01NULJnLaN8yk1bHRsvURElQcs00T3jn3g",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 3,
    "title": "CLA Defensive Drills",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "lbKldiK3YxmnhohJ813fYlxYUTE8X9VydvwVvspEtjk",
    "muxAssetId": "I3Cq02sExBfZKQ8O1iFd1QDe5p7Mm2FG68sVOI3bjkI00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 4,
    "title": "Floor Touch Recovery",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:09",
    "muxPlaybackId": "PIQ3vJKGj00DbM3zofGTf4r5Opu1oJFaDmCsV4f2WGZM",
    "muxAssetId": "HKUn02FEqSNvNC21DKiVA27X700Lqr7wDB79grv7xb9HA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 5,
    "title": "180 Turn Closeout Series",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:33",
    "muxPlaybackId": "MHG1a7F3OG5Ur00tJwdSR57d01Y801sAIapThDH0001VagLc",
    "muxAssetId": "Pr6KhYUqAJXPXTNMn6aQCkhrlv003oVRhd1OknitnqjU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 6,
    "title": "1v1.5 Attacking",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:47",
    "muxPlaybackId": "SPZXTyb7qpJ5vPeMEBfESwlRV02JAZize7Dwe7n2nHfo",
    "muxAssetId": "IxOH4vgvUsDM6HDbmHbNGxF02rD1fHO8NFsd5yLcmrsM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 7,
    "title": "1v2 Fly By Closeout",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "l6QWnhNGBnAj001Zs02fEMz9QRUSeF8HaclTj98S4gfGk",
    "muxAssetId": "7lp7MGmDXAz5OATF8dqS5O029fubw9CMQMl02qLPL4Egs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 8,
    "title": "1v2 Jail Into Help",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "2:28",
    "muxPlaybackId": "nIuTZC1DGxkdACGW9U1rSCkZmb4018VcX3aqVxd5atU8",
    "muxAssetId": "2fvRZyxJVoJDCbJ5WGDM008bd64gU7leBA6Fpz1r8nR00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 9,
    "title": "1v2 Advantage Contact",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "bPBt4sbnO4ClyZ9lEDisBxDc2vRlB26a02jvhKtEpNOI",
    "muxAssetId": "3AOpwiJKu02RBw6RXoIB3ylB9102qcl3ou413fF3KFR00Q",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 10,
    "title": "2 First Step 1v1s",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "X4X3Pzhh1NF8TOH00dpCZ01s6aurkAXkdBnb7pfLtZekY",
    "muxAssetId": "zp02iicF6gVogSPQEQlJSjy2IPZrLzS8bJZvfSQb02Vyc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 11,
    "title": "2v2 Pressure",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:01",
    "muxPlaybackId": "2IqIL02IYl66MQQr021wpcZlU7HF6pZN00XpckD2Rt2Vo4",
    "muxAssetId": "uYc2HaCmAMUSLcA3i1Bn1aMSIsPBEa4PjRdPWnXQ6g4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 12,
    "title": "4D Advantage 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:14",
    "muxPlaybackId": "hbRITmS6vsjOZE7ZB4HxNq1WCgTKPmmaMVMMy5rV62s",
    "muxAssetId": "62loZW01qI8uEDA668VXq00EnSSL0295S1nIH7Zg00CjV9k",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 13,
    "title": "Advantage 1v1 Variations",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:14",
    "muxPlaybackId": "xM87G4EGrDyE6t9r01Wxf3eijr9T8nSUE02dJbZz00mLF00",
    "muxAssetId": "GzWOtcsX5Icw02Glt00bCVgjgZRF6eCn4fJJkyfiX1mps",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 14,
    "title": "Advantage Lateral 1st Step",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "ykV1ygT2W004eVwkw02TF9qkoWaLIdqKHwTu00AJocNKAw",
    "muxAssetId": "GMfjA4X6NXefk95AFQs2tiRmi6rFJuk1IcW7xsfLRxY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 15,
    "title": "Alley Stack & Release 2v2",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:35",
    "muxPlaybackId": "PG100mLX8smOJWEOHmcQxrH2yq4Y25qrO6P8J5M3z01xw",
    "muxAssetId": "TquNO8ZPU3w4t8EKKz6pgjBKRdRr9Gft8V33009zBJeQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 16,
    "title": "Angle And Space Attacking Game 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:40",
    "muxPlaybackId": "4J024H3gj9AMQ4Vua200Nb3s2MBfglfiJmziOneAIwpqQ",
    "muxAssetId": "ru6JaCceV77mMN8SIKO74Ph8tf0155W2YjhzIl00VFIcw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 17,
    "title": "Angled Closeout Attack For Efficiency",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "q3j3WgS200XmCLw02RXhhEQ01XioGGrrLeffDMRQwkMix8",
    "muxAssetId": "yN7H6hcqc01C2NxDxMJDSMaDhjzWNvwQhO023humeIsj8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 18,
    "title": "Attacking Through A Shoulder",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:40",
    "muxPlaybackId": "00eQcZvMXRnFBLJGq4DfX02n9tk2egi65vW8nDsc3r6fg",
    "muxAssetId": "EOx4fJx6o01NqOaQS1HFRmH1Vs6bIEY02dDbm2hZEHKPU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 19,
    "title": "Attacking With Space",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:15",
    "muxPlaybackId": "AAsblNseFiMWuT01RQJUaW3iTdRh00ohCjrhS9AiVx00Vs",
    "muxAssetId": "y4ET1Wb01Lj8kRfYyjq5VbkuY3tk2foTxLlMNgxAupiY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 20,
    "title": "Backpedal To Explode And Finish",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "5zfkizFu302mCZ02SjuRvO00Niq1KiSKJDiKbOdEhM00dAw",
    "muxAssetId": "543Q3DjV02SSqVD8J9RRFeGsmy3B94GpYHjQMmfNZ2Vk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 21,
    "title": "Ball Push Finishing 1v1",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:20",
    "muxPlaybackId": "NmfvNAk4eiEl8q01fFVtv3wCAm5pVX00NxW22DA00014Ef8",
    "muxAssetId": "02aQZkrwnumuDph4M5ztImIYqpWUIDs64Tn01elflv53E",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 22,
    "title": "Ball Push Gap Drill",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:44",
    "muxPlaybackId": "yvtHexxLeH3kpsp6SZFIOHU8ZME69TTPy8EceAESkQ00",
    "muxAssetId": "wcpN9f00xqAUPXdU029Gv3XRF9ubQ7faBH56Sjuy3ReOU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 23,
    "title": "Ball On Back Beginners",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "NeTHh9BcWrUBDnetm7m2ZYetL013y2ztXOVpC5yv3Jy8",
    "muxAssetId": "rCpSzcIMHHBcsjdkfpiuaLAZ3vGQOxjYBMkMebgIdNs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 24,
    "title": "Big Turn The Corner 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:54",
    "muxPlaybackId": "E1r00leNYESpp01ZrkAVY13ZIkM83sznVl7007TCfSEWZk",
    "muxAssetId": "dblmY77TfWD9uJGKX800wd9I3jAUv4VDQ4PI6LUoD5rs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 25,
    "title": "Boomerang 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "tnpn02k8LwGFPkBnvzuZMkCX1YgcCmQvRbtO00S8B2fxI",
    "muxAssetId": "5mh8LWTqNHF500Klgcmd0201NecCHKTL01ihiiSEj9PKeNQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 26,
    "title": "Bounce To Closeout",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "6t00MNI101mQMiL5ZHUNWZ7tap4hy2QkgcHO5iFAVVCW00",
    "muxAssetId": "2M5Bds00yK00BnX39lBMrAt01Fascx02y4TB02MMmTcs5Z00o",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 27,
    "title": "Bump Middy Work",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:06",
    "muxPlaybackId": "eJJ3xJyLAvwy00zTO01fD1PAwAi00r6L66KfpnpCVTwiLk",
    "muxAssetId": "02e9p00fIVB6a7IYOkTypee8Z4r8abHU3WHa9LmZWpN4I",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 28,
    "title": "Contact Spin 1v2 (Or 1v1)",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "2:22",
    "muxPlaybackId": "l87i01y7U8RuYXxS4UuNh5jPLsvNEJOfIj1CBrXgX9NM",
    "muxAssetId": "SW7waV0200EKvuQ3hmgGXsGpIARq005l1gYw6filt52Fkk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 29,
    "title": "Creativity 1v2",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "7TrwtNPArObJgY8n00t2Y2FtJjwGRkZ2SaY9yFXxqoO00",
    "muxAssetId": "Cmzybwhu7f1lbW00ZiQP3B9RSUEF9GiHdwydKz01HiRVI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 30,
    "title": "Downhill Transition Drill",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:47",
    "muxPlaybackId": "5uEfGCnE7CIbArE7jDTnJ1UU9qY5wHFXp2GWRE7G5x4",
    "muxAssetId": "uuzTnVZhfmOonWThWbFC5isyF57c9f3Ie7B3HS7018i8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 31,
    "title": "Drive To Barkley",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:45",
    "muxPlaybackId": "gc7m02g9ztj388O23AVbGIj2hqlbq8UKfRkasd12WpyY",
    "muxAssetId": "PNmDvgLDXAqTik6NkrLNAVCwBzNx01pej93r66dGLtGg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 32,
    "title": "Early Contact 1s",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:35",
    "muxPlaybackId": "1jLya5lP02o00FWhsapkcOK2vc3YuFoujGjsEKhL5qvLs",
    "muxAssetId": "HjomUKkw011ihE5DY8q9M02IbtSjgqy3U4p3UmPv9JOuU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 33,
    "title": "Exaggerated Reach Problem Solving",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:41",
    "muxPlaybackId": "IyVpvXo01irA00Z00M9kC5iurTrPUs8C01O9jqdXka9x5ts",
    "muxAssetId": "RArXeak9TU202D017eMk1AsJ1GugFiF5RDB7BCpB01sBjE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 34,
    "title": "Explosion From Knee 1s",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:49",
    "muxPlaybackId": "QqEsU1fMJpzQwtcaVOnu01LZtSxXsncjdI3Kfu6rlE1A",
    "muxAssetId": "GQy8xRR8802fixzHnOFJfRY6LGkBVTFJzVprql6erNLg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 35,
    "title": "Eyes Closed Open And Go 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:36",
    "muxPlaybackId": "bc2FwMkgDrVJ701yfBPi8QpbV95h02NlfIjHjQbD400P2s",
    "muxAssetId": "02CuNtqzMS7iUywvOoMj02mVqDmOWdW01k3hTngh4yfQVA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 36,
    "title": "Flag Grab 1v2",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "lZPfi7DGv9X7n777buMB8KxxP02DeOv9KgE8Our2S4Ok",
    "muxAssetId": "iURwfiYNONvxdsCIuc02DR7Iol501G49ZN02OwymTgoOeY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 37,
    "title": "Flipping Defense 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:09",
    "muxPlaybackId": "bX502FOzs1DLBZ5sB23006FlXZ8M01gDLVZxiBPgUqYiDg",
    "muxAssetId": "oYpBYisK02SMrie68I01qhoYh4uzDTdC00j2KADR336NFw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 38,
    "title": "Fun 1v1 Warmup Starts",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:58",
    "muxPlaybackId": "p9nd8023FI3exSZ013IUs01VBdOAAcno02ZHgOuv4q01f59M",
    "muxAssetId": "02t00yxpsObxMsLCoylOI01VADnS3fy2Co01oFb00HLFTLmw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 39,
    "title": "Go Get A Bucket Drill",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:45",
    "muxPlaybackId": "ZMZ8R5LJwBPh4ykgX6aI4obvL5cXeB7BPo15UDH0201Ts",
    "muxAssetId": "g01iirMsiikrR02tA8R02sHjd01opC8Fh2SF00Ry67wdbKCs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 40,
    "title": "Half Closed Perimeter 1v2",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "C01299RDyFnHan003q8ZPqh3bfeLtJ6NWjzBwzE01xjzJs",
    "muxAssetId": "v4jC2102Fk00fyrub7B01bfk8OqhWfi1OXjVpfG65NFkPI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 41,
    "title": "Head Of Steam 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:42",
    "muxPlaybackId": "a89ZwaZBOFOjzu01ru1UK00iWoylOmrFfK1HiVkg8XE7k",
    "muxAssetId": "HHVHTXeNPQDQWuEgDphXUedU6Gwa89rrJU1I1siXcrw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 42,
    "title": "Including Gaps In Training",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "wgtrdcCJO01R8wC2U02PBejk9m4v1763gwP4KmSynKTKA",
    "muxAssetId": "7P3kSFlkfI29ap3WEW02sJhI5YwpllqE00WWUJpsxqGCw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 43,
    "title": "Iverson 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:39",
    "muxPlaybackId": "AmzZbhSQay2vuap9vzAyTJe9ZkDoOuNiC01Eq8n29HUs",
    "muxAssetId": "TZmscrTzsTe5ske029vMCihiZBkmHWpZuhfmFjJJrwxY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 44,
    "title": "Jail Into Release 1v1 With Pass",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:48",
    "muxPlaybackId": "QbO1bHVOZkcV6Z4xXvpJs7ko571lrL3bNhhkWNCklrc",
    "muxAssetId": "tugxLjCb4ybY01cYcEdpt9qUCGfvr01vsfKtxnFbjE714",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 45,
    "title": "Lateral Float 1v2 With Reaction",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:55",
    "muxPlaybackId": "i02Onngy3pYjDcOaqs16zsrJ8y6ENxfhr2iMTfFxVl3E",
    "muxAssetId": "hpjuBHXQ01H6V4sHN011o3kfmrD3N71GWPBtZZGTtxQx8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 46,
    "title": "Must Take 3 Hold Your Advantage 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:35",
    "muxPlaybackId": "i5EItCoDITiQqa00UAqeaIhaJbsGtLre8FY02fWuGbqr4",
    "muxAssetId": "5q9kNp1V52413MnL1D9C5M7T9Df02CwC2u015vsElWAco",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 47,
    "title": "Off Ball 1v2",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:56",
    "muxPlaybackId": "5uk8CbTls7p01iQPCzHQdDNzqDJdOxScj2x1zbCC1PQU",
    "muxAssetId": "wpV4N7kjxwRxnf9aFrqtYAo5Iu009z7qX202PXPcBgUM8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 48,
    "title": "Oh Sh*T Push Drill",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "eJncqRZptMIERyXdIbdiaOybResuyQKVBjvu3BRd2DI",
    "muxAssetId": "y7oRjpGJmR574qVJZmlI2uB02Zs8eaNtM9HSv9z3wsak",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 49,
    "title": "Pivot & Go Series",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:29",
    "muxPlaybackId": "uyZB02kHmqmJlZIVXFllddxeN5mQEPd6C5LOUkQEpcKM",
    "muxAssetId": "4GXSXHuTwirTMVWFEQ6nsB1cyWDjsiblHRhL7mykciI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 50,
    "title": "Pull Up Or Hesi 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "wTdwZfDNzSfy1w015xrkEJ2WJzVxPice86YeHEyWQL1c",
    "muxAssetId": "fqFKTrylwanEhrb01XHrmPcyUElwQ7VUSlWthvoH8wWA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 51,
    "title": "Retreat Dynamic Start 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:14",
    "muxPlaybackId": "FDaBC1eceqS2XZ2IhL01UfY5KKAadUhxgo5Twj5iz2ls",
    "muxAssetId": "YeO4B9T00g01JQZ3pWdjR00M02ORh7eLAuLHDFLzTXjhwds",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 52,
    "title": "Sandwich 1v2",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "UZgGkFC3cACbeb2jJgTtRFUSxYw4Vesaaf9JedkDqjE",
    "muxAssetId": "G1qWXJ5QWcwgaSsINgGRWqN602Bj7uJAMaoQo2rVkCSQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 53,
    "title": "Side On Pass Attacks",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:44",
    "muxPlaybackId": "01t029v4FgcUeCWwLFlhG51pJYUiZoY3rINeUELnI7eMI",
    "muxAssetId": "1rOiMISN5lPShOsx4ry1TnJsAi7hoEvEpOO3oJEHAPk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 54,
    "title": "Slice Attacking",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:08",
    "muxPlaybackId": "hOlryz4MlAPxHYijLLaOF201DuNIAvKbzSIacFk1RRME",
    "muxAssetId": "y7tvRph1r3LXt9fbyywFs15ssRXekDAryju8Unn798c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 55,
    "title": "Slow 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:50",
    "muxPlaybackId": "1j9zcJYfZw01g8N6Gk2STmLbRiOZR5b00iLJfquyj00602k",
    "muxAssetId": "RQLuV9apaVksIEcIBZ01MYuygiFkHOtMYZvM1IJ5hozU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 56,
    "title": "Slow Advantage 1s",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:13",
    "muxPlaybackId": "W9MSxXQ32DsD44psS009WXbG9JOkfLq3gu9cjf01V2CKQ",
    "muxAssetId": "I013VhI11DMYBT1WqRXKAjhkZgsVxx6oR5SzYytJs28w",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 57,
    "title": "Slow And Fast Attack Head On 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "2:08",
    "muxPlaybackId": "cB8cXv6IO01fKP61qlZ2j5u3TLnay025e00OPBtzGdtJjc",
    "muxAssetId": "LrU89023EhkESiWUQkX01hrdSZj02PdYNRL6GKEmPUWf7M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 58,
    "title": "Specific 1v1 Variations",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "wqBj1E3B84lNNPdylu2kLvn3S02AztcgnqhRvYkoPyGs",
    "muxAssetId": "yjJTQYGgfPxTM01nk00f3Ve01oRaMrEU9kptIt9DTG9Y9M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 59,
    "title": "Spin Safety 1v2",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:18",
    "muxPlaybackId": "AxtG4S6oGaFoRxILuIm9ySf2uhcZedrbC02Xw2TCD61c",
    "muxAssetId": "HMqxSlekq4fpl9yJXLJwvlWJ87SLgg5NLI3gFOXu1xs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 60,
    "title": "Spin Or Straight Line 1v2 (Or 1v1)",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:07",
    "muxPlaybackId": "BcmBADRdwmS88URW5SLAB8k7CsGB4Me00t005WpEM7Hf4",
    "muxAssetId": "me102yHzfgNcTLpUYU7r43mxVbfm013FFNBp1eMvNCtcw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 61,
    "title": "Stampede Tweak",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "2:46",
    "muxPlaybackId": "PSFfQ009stApCUVb01iY8ZMY6OKz8XghsmzotuF4f2uEA",
    "muxAssetId": "sPM01eAl8Q00A4P7601l19ywrOxvks02y3s2eetntouL1QY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 62,
    "title": "Steal 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "M8EPcALAd02ZxGO7LSRldZ7P9800cGkIFFHRHY9rDrU6A",
    "muxAssetId": "Y5OjYavqoDKr3CqSUkBslYLQsvvDxWS6JmbLHn6sSl00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 63,
    "title": "Straight Line Attacking",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "2:07",
    "muxPlaybackId": "OHYV3thxQn92BLJYCyFHBw402AU02oxTDK6W244S401vq00",
    "muxAssetId": "N3o4Vx01qxA8IHJvzlBP5UPcHpKvoXarQkl00WbEEb6T8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 64,
    "title": "Tag Into Help 1v2",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:09",
    "muxPlaybackId": "CQ2nIjlU4yjrwmC01Z7E01aEW1SeOki4SJb01600601LTjBM",
    "muxAssetId": "SuuMc02sZgIN3kUMvCUIU02x9p01gUrGkshzYfPn02CYTtw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 65,
    "title": "Tight Curve 2v2",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:13",
    "muxPlaybackId": "iL00tErf6XlCNgANrPB6m8S0000Do8FoPE02dhH4J8QqDIo",
    "muxAssetId": "IYTXJBfOBexibhN3sFY8vRhK01sju8cVMW8D201QjznAs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 66,
    "title": "Trailing Defender Fast 1v2 Series",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "2:18",
    "muxPlaybackId": "fSEyAat1MJXloc012bg1p8oamekzAIjh00u6ENICieKLk",
    "muxAssetId": "4blsStwyvmXHGIDqKKqe7LMsj6QqJ2S013kxwfFV01A8U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 67,
    "title": "Transition Corner 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:23",
    "muxPlaybackId": "01y51AAlnoWibHtIvUtA600WQIpZIgfbvcrT6CfJK4AIE",
    "muxAssetId": "qP1ApjZh6ubOHeodHSFzHmnJQr2uUWSt3caYlE6f4m4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 68,
    "title": "Transition Early Contact Scoring",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:33",
    "muxPlaybackId": "K02EoaUkV59AZuCzjxI100sYQtxVf72t92qEa7vtMdSKw",
    "muxAssetId": "S0118Sad9eRsbethVLpsqdVNNDUK00KI00Vx01uoS7ADmow",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 69,
    "title": "Turn And Go 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "eYmNVksSSFe7y8azTIkOcu4HbO8DNB01bTwzkJ3FSvNE",
    "muxAssetId": "dRj6RcSkBo23Z9lgasahb00Yoi00xsVhjw37RdtYq00BEk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 70,
    "title": "Wide Setup With Cone Touch 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "Tb00Oek900FdxokI202dsbmblAr4EBCyis1kchZCGDmjd4",
    "muxAssetId": "y5aC3iuj7sdrNhD00P01khWYQK1iA8P70000FV5vhWvQVws",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 71,
    "title": "1 Hand Taps For Control",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:41",
    "muxPlaybackId": "rd3jznasbwaW8UjQtmMyg1ljTAylNCosNy6dkRuj1pM",
    "muxAssetId": "9vudBVheVgDz029nvVepvqZtTEEzjt00syRiBwqB3bCIE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 72,
    "title": "180 Turn To Explode",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:11",
    "muxPlaybackId": "6wWHxRg68ZfWYzmWCiKz01PjKj2cRsLAwv01hGbV9sXf4",
    "muxAssetId": "MYXBalsjXhnt5BHm003FuGcJ02kS9iHtYO3nW3AhQkm01o",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 73,
    "title": "1v1 Ballhandling Drills",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:50",
    "muxPlaybackId": "eXQqnghpGNS02potoTkbVJWoP1LxCGuJMwutK4sEnxKo",
    "muxAssetId": "wbX7OZe02x8VVi00gqqjJLLynp02a2bqfJY9N015qXO4MYo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 74,
    "title": "Against The World",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "1AAEGoGo5fY01j9bBOH02Zlc3UDo7wp02V4BauPsE9iO4Q",
    "muxAssetId": "tnjM0201DUdPW02o76aZvrVR01v4qPBIz01WLhTQfPVsvC500",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 75,
    "title": "Back Turned Pressure Handling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "02ACipQd0281ygwKbPToZ3nU61R32MlhgWtJDzoYLJqvM",
    "muxAssetId": "1aZpgNaH1msgjCJajrHWVF00G5em98WYaClw8WaD01v3A",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 76,
    "title": "Ball From Ground Low Handling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "OkqwvBN4IzbsdREx1iJDyDBz8dqxKDcd01BXznMpsMXw",
    "muxAssetId": "goOMPRc301tzkeVikRRp3hFp024L56hHBa8qIgye1wuzM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 77,
    "title": "Ball Roll Handle Fight",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:33",
    "muxPlaybackId": "HYCqvW2a00uBfI7fnv1rFScRIn4yk001dCO56024leHr02o",
    "muxAssetId": "tedAJdQSUbesRhaacPYaWoBl5Fd6nE66HR005wiHUKhE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 78,
    "title": "Behind The Back Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:41",
    "muxPlaybackId": "4RWlwyXyM8U2rJNvuT6ZhNIgULbgo7jDIg7U9nixAII",
    "muxAssetId": "IkjnK02FYX00Q3MBnMge8eK902XqQOb02rNdW02GVGE6tc700",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 79,
    "title": "Both Dribbling 1v1",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "e1dEmPaSwUF2AVOHz5kfRsMViCvoA7IiSlKAQOZyWps",
    "muxAssetId": "NzS8qNG7AbkvFFpTQPX2is3FkSHESYRRV9nVkKxYUYc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 80,
    "title": "Calm In Chaos 1v1 Pressure",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:10",
    "muxPlaybackId": "ZM68GUOXbz5U4cg6ayaPDYbgj77BiFhIzsglhU2HJt4",
    "muxAssetId": "HppphbdlAvpAQs02IpKvswI6NkYrEQ9IiOTZ5yXQAQEw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 81,
    "title": "Change Of Pace Workout",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:47",
    "muxPlaybackId": "7IAYLNB701qtLGg6NEsVWktNZxRmq3z1nhd4vY293jrE",
    "muxAssetId": "VhXiX3TkFvyBCziP4TMN3Q11uqGTRrxUa2VuG1h7vjM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 82,
    "title": "Change Of Speed Series 2",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:22",
    "muxPlaybackId": "QjxNpIfjMC2lmaiXM4P4U8FjKCItULahVsBG3zsKBVI",
    "muxAssetId": "md5nJYARdgAjaobMrk1DTdYEC00T1dcfzfWS11F4F3pE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 83,
    "title": "Change Of Speed Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:58",
    "muxPlaybackId": "yPxib3LISjldWTvcKIiB5MyxNJuIZoMb7VRhXbYsooI",
    "muxAssetId": "E2LKV3pg6ed02CQj3tKm9zdHV00OjotDzDTdYJdlNSDXI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 84,
    "title": "Circle Tag Handling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "TohSZE5ZB00AhAZvpAAY9mAHYc97j7CSqkxC13cSynQI",
    "muxAssetId": "IiFyZNfHjhhNA6jafwBFZyQpmud7Ib2ZkzjbqDW93QE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 85,
    "title": "Curvilinear Races",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "02WDMEIyNmHqyo02Uflgl39DMG9SX9y2OxcCYvBScOki8",
    "muxAssetId": "402U471all6dAz46FGI2Sz0019x9P7J4RhPyvJs21ipsg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 86,
    "title": "Dribble Box Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:24",
    "muxPlaybackId": "d9oiakJYnLbkUeZJBKIzogwSPX1Zf4Ick6Xt2J4YSfE",
    "muxAssetId": "kHRAu8InDdAldKulgC00Iefyq3HwAIWAgzn1S1P025Ux00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 87,
    "title": "Dribble Knockout",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:18",
    "muxPlaybackId": "r6TxWH2cvpCjZkAWKGOEvDMQvGQ01Pg2RdmZEkG02tSIY",
    "muxAssetId": "vKT4Om4enUlJ00eDOHgct7piF2NaR01rQozJmmhZIMye00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 88,
    "title": "Dribbling Stationary Vs Circling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "PFrRzgTcF00vrXLcjg4eiMiPlTmO23VtwIG202iIoOGkU",
    "muxAssetId": "nOXS00ViLmceRDgCW5ZFwAhx5RdjTvtHkAqcQRazU01pg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 89,
    "title": "Efficient First Step Progression",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:45",
    "muxPlaybackId": "oM2cgxzLu026AuyYo01m6s7MnI01yHwaHt6GPRqHGmsxDs",
    "muxAssetId": "yA02dYXTpqiyVkWo4XydKav012vPNwcLMyBXXiaBbpOW8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 90,
    "title": "Elbow Touch Ballhandling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:51",
    "muxPlaybackId": "2o2mX02B9DOjRIU00EQAOHVcXMgPwoKOWtJwkoUNkwLoc",
    "muxAssetId": "8HfezbC7gRJAMd9zpvOwIH0101a1k00w3McRlRMPt9OCIQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 91,
    "title": "Elbow Touch Physicality Handling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:51",
    "muxPlaybackId": "qV9Jd5TEQSGYjoP00ex8a8p02PLbpaG01VT9nsLNCQ01z3s",
    "muxAssetId": "KncuZ1WikxyzYQgu02KDolR25GP3yTDY01Q2D026RwJg02c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 92,
    "title": "Float Dribble At Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "2:09",
    "muxPlaybackId": "LKEnSfM01e2ILXL02F1SatfXKo439HdPIabfRHt0038l3A",
    "muxAssetId": "cOwkGPRXJO017QSYwCq02qRUO35101qChxtquk9aRJ1C400",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 93,
    "title": "Footworks To Experiment With",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "ElDoKvgAYtCEfYU18LsGT02q01UHFz7vR2AdfKIVpz4Ws",
    "muxAssetId": "toWwL98D7tPxNHJR7XwTGH8sGBGfIexWeYuX53r5zdI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 94,
    "title": "Handle To Quick Attack Warmup 1s",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:11",
    "muxPlaybackId": "G95vnCrxEatvyORo600OsME6jm02vZfyD02DnTLFjy6juY",
    "muxAssetId": "E9Vu9Xhmd00taQ7jXrtJEWTwTDlCiTMx8E9WIIn7tX7M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 95,
    "title": "Handling Pressure & Chaos Passing",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:54",
    "muxPlaybackId": "SYnKjqg8kjw5mxcTlHoXr6Pj2q9DantMp65BA8UDrL00",
    "muxAssetId": "vXX4jLhgJU4FgEn5JH301Yg8wmjfQS7gfxdUMaCpzOuA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 96,
    "title": "Inside The Box Pressure Freestyle",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "q2aBTfKng4orA4Mdm2VKkVhaapDdMYjH5zaJmW02Q02PY",
    "muxAssetId": "UBhggp9cLb00aUrV00igo02025j6MsRM9q4y1SuhQVUtH3A",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 97,
    "title": "Lateral Quick Move And Pass Race",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "qi00hmOVVV2XI2r26XmJ3xzJlQUniawwn900ku3QPUlF8",
    "muxAssetId": "UOQQ7zBuYp2VFl02JejucWjCFLi6WssTw02mXLvQEwNLc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 98,
    "title": "Least Amount Of Dribbles",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:58",
    "muxPlaybackId": "rrsbIGCt02weBTH8EM8cb9iBTEoUOjyxSXOjCNP32jyo",
    "muxAssetId": "CHRP3S1Ytd01cCJ00BlNLkKJ02p3UIFa7ckniJ3im9YMgU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 99,
    "title": "Live First Step Reps",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:18",
    "muxPlaybackId": "XH7AeiNrn5rQyHuQtBImZ01k1e8AtE00gt02wsgsj3f9Uw",
    "muxAssetId": "aGbJKoF4bWEvMoHsQa602wDOvjDj2ws7hVfH01eBnco4E",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 100,
    "title": "Mirror Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:49",
    "muxPlaybackId": "J01vkbaDsW01yU6zYIOAt00zycsES4bqjyv4ydtqAuir2w",
    "muxAssetId": "KlBXdB7kl8twZ0000EgsvLwdCO8eFu2YYmdFmrSXKZDvg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 101,
    "title": "Narrow Dribble Burst",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "WWp7h1c01VSHA4hPiyxqpz2WqEXlMhwzhCiE3OMd5qoM",
    "muxAssetId": "D3imI66640200wrr4uT01VKd4we3wkQHPwon3pc5csMu004",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 102,
    "title": "One Fast Dribble Pace Work",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "XTQmneda96Kv0172S2jo62UU9EMz5iZp7Syp1RxqbZec",
    "muxAssetId": "T1DetefDgJYnt00mqm2V13bOcDCDTAh1ETK02YT65woks",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 103,
    "title": "Opposite Mirror To Blow By",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:51",
    "muxPlaybackId": "ehBiKhw98tiApfiy1Vow8fpwiq024KuGNfj1YZzgR7jg",
    "muxAssetId": "kjVpGpLfIJ302A9zUVSZ02l00bXt5r9HRZ1lauXZL02htPE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 104,
    "title": "Opposite Pace And Direction",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:08",
    "muxPlaybackId": "wOm02GUrvcFwFiYUzc1QqKFZwNIRNhXmuOkgdhXkM02kM",
    "muxAssetId": "vo231tHsxjoPi5ARlng01zUoix8rGfVbsfo15O7eMHSk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 105,
    "title": "Over Hurdle Handling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "00YuJ6saLjW5tIyyBw7ptFUggwXZUmRz4cShjnOQ1gYs",
    "muxAssetId": "Wk4FYFdQQAA883FIQKubmqx602CGbhs01wLadoxn1Poto",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 106,
    "title": "Percentage Speed 1v1",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "2:16",
    "muxPlaybackId": "thPXX01L7hnH02QknrgyebHLCfsBWwaVv8801CcJyqOlkc",
    "muxAssetId": "94CMatwBE013c1Q501cSIDkwdWfNa00Eb68IECedQY011Tw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 107,
    "title": "Point Per Second Pressure Handling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "I7SHVbd9A6188MAiaQDW3TnZ02WIwHbiAfy7jpejRlHo",
    "muxAssetId": "rFbTZWo1GvLLzIPjOwA5MwB00013KUbpgQbZyDrbokyN00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 108,
    "title": "Pressure Drills",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:47",
    "muxPlaybackId": "mLH1vw5Qn1SI3tAnfhC4zWZ9zcaN2uvLGnDz74Lg02o00",
    "muxAssetId": "qSJX6IFqyCGc9J9wfSmJQUpJ02TUBrVnS3eJ1qmL4yWM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 109,
    "title": "Quick Move And Pass Race",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:58",
    "muxPlaybackId": "yUeMY4z7wmDjMK8zOxYMaQmd94YqMmW4wBy791j4iBM",
    "muxAssetId": "Wgd02BbYttljVNDHTZnootunqS0101uTNOTmeqhZrNUmIs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 110,
    "title": "Reactive Passes From Dribble",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:39",
    "muxPlaybackId": "p9ra02SuR007DS8CDE4kj7GP00OkOkn6mVJDN9RyQmcGvg",
    "muxAssetId": "4v7Zq01HFB02mxxekFgJKe3SLSAiirtd366jEN2qNSZNI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 111,
    "title": "Retreat Freestyle Chase",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "WPgOGnriGH8qpRjz9g02DH3AUG6UnPIHAYzxZjcsRp1E",
    "muxAssetId": "Un63omEogKyTBag00pkV2GX1ubTUFBK9YFiU5UJa8vX4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 112,
    "title": "Shiftiness Movement Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "T02ifs7zpOuXZSQ6adEgKCml01rg8omR5cJZHqKbLehuw",
    "muxAssetId": "mkgt02JvwXSp02lpIqwbjp01ccenvOikXmT1B5WkDm2Azs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 113,
    "title": "Two Ball Protection Drill",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:12",
    "muxPlaybackId": "mdG00zipJfb8an28De4h6vmrCb02Y1wdAqus79oDxa01Zc",
    "muxAssetId": "KpJUmDMDuybaJqM8JH00m3zLQ00mrDLkpAtdGEfYWdIMA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 114,
    "title": "1v1 Turn And Go Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "Kv7l81wOW02bPJ1ycE1dKN3PsSbY02ImcFzvxPFd00f9PQ",
    "muxAssetId": "01tOa5wA8ahntr2DzRGDpv00k7s01j4Nx1TKx00wtQIGvKE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 115,
    "title": "1v2 Constrained Defense Gap Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:59",
    "muxPlaybackId": "02MqePCNzdth00007Q389XiO4LN5CZvQD01oWa5iGb8jl5A",
    "muxAssetId": "a31Z3t988leoshqem1pFqeAt33CMFlB02VnavC8SmXvI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 116,
    "title": "1v2 Finishing Moderate",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:13",
    "muxPlaybackId": "gb02GF2EIl5KU3Zy7w7WiNz7eI7hxDiiQgv7bSZ9Dclk",
    "muxAssetId": "wXYuZJbYD1N1ZCURRNQvKK600dBvIJ02WwzM4JWDc2JPo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 117,
    "title": "2 Part Under Basket Close Contact",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "37CQLm6OIByj1ae7GjT28lHNapioRRDw1Api00qOpHRc",
    "muxAssetId": "4sFlw00eNmmAK02gKH00biDoCOkDDEfsDmsa1z7yjQ02mcM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 118,
    "title": "2v1 Attack The Rim Or Space",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:11",
    "muxPlaybackId": "yym01CK4pLhiVgtGSdzBRXikpWWO01Tej7lEDctpWpdRE",
    "muxAssetId": "lceLF2i02trguHT7A700SJvNw01aBVnGRVMjN9eVZQKkXI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 119,
    "title": "2v1 Layup Reps",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:15",
    "muxPlaybackId": "2Wi5h2I5QS9FDasjQS6401tG159kcPsq02iSUYVBJBaq8",
    "muxAssetId": "ADxgycNOhNQmmMLkLshByFAWcSP8n2014c9c6C5D6GbE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 120,
    "title": "3 Part Close Defense Finishing Series",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:34",
    "muxPlaybackId": "01MUukjp7WAIY01u18iKAjf1XGCz5EHJqzmoxyTom900qI",
    "muxAssetId": "g23O4De4sE759MQ65uGmqbmPjdgx02101Vkqr4L9uaQDo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 121,
    "title": "30 Seconds Of Hell",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:50",
    "muxPlaybackId": "eToMgVYkYUZ29xLqALCDrbM00dwGwqMAKeISA8zaOimA",
    "muxAssetId": "SrK1MC22X02vaIfvRTw6n00mAzoPUGC3z00Yq0202fkFK01yU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 122,
    "title": "Acrobatic High Speed Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "Gx3QtQRPkIBl5Io2zKQaE7rRzqCDj0025A7dGEe5Ib1c",
    "muxAssetId": "EFQTpL8Rq8DF2902Xvc01f2RRbkOs01gMsnkISq00SNgmyM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 123,
    "title": "Across Lane Finishing Series",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:55",
    "muxPlaybackId": "bEZppaN5lBshOxE3J100rukhSJXdblynZjcp57JckDfg",
    "muxAssetId": "qN1yJx4uvoRBqTTvuhyHMh0102AcXnlvqbqG1sHhkCAws",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 124,
    "title": "Advantage Slow And Fast Finishing Contrast",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "2:56",
    "muxPlaybackId": "RXr7QCCYpeC202UT3NdZhZ00wxDQ011w0174kC5aRg02ysBo",
    "muxAssetId": "KUYEvqw2NgahLrHcUMo9faMPs6tnD5BOUtfEv02sBsjc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 125,
    "title": "Arm Hold Drill",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:07",
    "muxPlaybackId": "JtXz42veMeTP2ScrloSURXTlP01EAwDjrBEiMn9LUrB4",
    "muxAssetId": "mg00NNZXYFoqNzb2FCeGAgT1DBtviWauSxtKhJykrNNQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 126,
    "title": "Attack With Momentum 1v2",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "MC5DPIeIYJojr302V64UmYdsyEex3tXwD8LNWZ9BKm01Q",
    "muxAssetId": "TmzBGxpaIyp02Rauz4HiqDZdzo63Xidkay2Cbf4N7MGY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 127,
    "title": "Back Defense 1v1",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "jm1i501Hg5MM00ZsnAM8hIXrv3c1N2lyET1hbTwl3yvyI",
    "muxAssetId": "F6wOezD2xkrTBUap6deRGycaRQKTjdqA7eBRLwIfp3g",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 128,
    "title": "Back Start 1v1 Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "Esf00xY9CqrnLxgC01r4xCXMnR5Dx4Kih4OhENCpdi2YI",
    "muxAssetId": "02pp4tgRBDB1l7Oyj01IxciQ28CQuQd2mMGRLwOivsQt00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 129,
    "title": "Ball Protection Pickup Series",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:55",
    "muxPlaybackId": "Q332gfERNXSO00C2kd6PWr4futYm5YXHxjSvh00FsziGg",
    "muxAssetId": "M00kg01O01V005bLQZuEQytbj8UmeaoBe7SQNEQERLiluPo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 130,
    "title": "Ball Throw Contested Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:36",
    "muxPlaybackId": "1auyCh8YH1T6PO9K4cjHselMAh2FBOkQIWfbURILHyQ",
    "muxAssetId": "6NNNWvUMyDXYbr9zeEgs00GC3l471r9ZAoK5cy8crWJo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 131,
    "title": "Baseline Recover Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "wXmrEMoCs15i34Q00G00IcjRs02KN5kkw8kl01c5S6G6c8Q",
    "muxAssetId": "LspTIAlUvntwJedpf02skMrtPG7c9ffM01tcL0202fG77tA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 132,
    "title": "Beginner Lead Passes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:41",
    "muxPlaybackId": "W5eYCAlTUOBUCBqnVi2XxqRTCtxj4cNDqqSmrcKOpSw",
    "muxAssetId": "vRg8u9X9TUSwLmhwLBRju7ykasQagjXJrxGPd6NgGGw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 133,
    "title": "Blind Defense Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "KCQiUcM0201Wq9cvz3R8F1fu2WbuPVbs880101aJ94Tg7Ig",
    "muxAssetId": "rLkkVqa2H01C3Z602N01pIH00Hx159lYOrXiU01lNnKwlic4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 134,
    "title": "Body Touch Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "I5GeMSQKjg02qz35vQMSmQiCQ00O8Mj2gZ4GWJMKP01Vnw",
    "muxAssetId": "gT2Fdj7vJ3qh7FYid3nYwdHB9J4TmFzMTTJdTwGX8WY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 135,
    "title": "Bump Pause Warmup",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "yMH6U02e5QBnUzFt2ajjmoCnF00kH36khnZudkNwEd01ms",
    "muxAssetId": "ZdiWTo3aH4fwBTUcamWXkEq7ZSBI01QS01a5SzcFBBZxs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 136,
    "title": "Catch & Pivot Warmup",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "02UsPRVB5Ob014bTvpfv7JTdpteioq3acEuvHNL6YkYqw",
    "muxAssetId": "1o62rQPgaYgaYpVnAY5OpBcZbC3mNqnIGcZxg02spd6I",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 137,
    "title": "Chaos Finishing With Pass",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:56",
    "muxPlaybackId": "C1ZyWa625HTi7NF4CfaWBhgFlBGkZ95yaUVFja9vQPA",
    "muxAssetId": "wkXY8Uvu2nY601kIfCuL2wDnn02fnqTO3TyKbIShtGN01M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 138,
    "title": "Circle 1v2",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "1sqs3004pix39E4lWsWfRHhFWdDDa463MIuM5Q3sat6U",
    "muxAssetId": "OUzfLHKUk6j33BkI2zgck1yLBl2VQh02DNWs6011w2K01g",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 139,
    "title": "Close Range Post 1v2 Warmup",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "lEWNuyv7iejmf01eg8UWggTwXFv01kifNBcpymaPOYA01c",
    "muxAssetId": "w02sU024vQDiJ933pFFo1PywlSDgrO1s3zqCOUMtF5uHQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 140,
    "title": "Close Space On Back Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:41",
    "muxPlaybackId": "Cyxm1WOgs6X1oTvRroKpkqX01eB53YtHwU35OeX00imEY",
    "muxAssetId": "k1SPVd8cmp012R00RfqM2uiKAnYPshoYJXr6Np7MvgoJo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 141,
    "title": "Close Start Contact Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "s6nT9901JF2P014t6v5dIJ00PNRCTkrv00CPOESqZJf01U3o",
    "muxAssetId": "VsQIeYAxtuiGzeY4j00ONUi9tQMfzR7aac01M02Up9AcxI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 142,
    "title": "Close Up Finishing Warmup Series",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "Y96QqZBDRsIbbLpkITgH7icbMTTOH9jkeeDX01xfkGrE",
    "muxAssetId": "MVHK2Srfi52CBdlsVqJdA42JloyWfngwCdXux02ZJSwk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 143,
    "title": "Constrained Gap Pickup",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:34",
    "muxPlaybackId": "AhRj9Kmc6aRJbmGSB9JrsjPiCj00IsUE91n6YUiNU9uM",
    "muxAssetId": "01rO02VzNx5IukwGPe02lLQeM2fdmSfaZcZGyT8Fw9TC5M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 144,
    "title": "Creative Finishing Ideas",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:39",
    "muxPlaybackId": "1Wu5L8fa3fAvWeHuP4wu1VIN4PC73JDk01Htm202bbJtM",
    "muxAssetId": "L8NKStNjrALJm19H2uaL9qykJQ2LRkxu7AUwKng7m01E",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 145,
    "title": "Dexterity 1v1 Side By Side Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "uhKHLCpoSmNieq3JqoWYb1ibvMpUcm1ZFjjgBwNdRMU",
    "muxAssetId": "yqa702HyEJNbznnoan01xfifooFt6AdjaJDla1yb77I4k",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 146,
    "title": "Double Cross Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "AB5VU302OmLPAOux8nE1a8Pd84sDMgz83rZjPhK6YsIA",
    "muxAssetId": "6ovCv00GM00Ebc5hqiaMWbM3qcwG8s5aMPPQtigpBHpWI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 147,
    "title": "Driving To Help Finishing Game",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "G22c8cNGmDAIQLCaP8NkMpYVKyae4kdmOwXmnqry01aA",
    "muxAssetId": "D9nzZmKJkOn01XqxZQEpTnLX8s9nbt2rYit2cCvHgLxs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 148,
    "title": "FT Line Turn To Finish",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:33",
    "muxPlaybackId": "hCzZQlXktsCqQBTtM4yRQicAK00z3mw68u2g28G9Dj9s",
    "muxAssetId": "f3r1XOxj5KiQpE01GGxyfUN400nHBxrrA02oOQp6012krEI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 149,
    "title": "Find A Side Finishing With Stick",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "9S4cpWEhLqmT1zxW4RjNa02BDljKqSEMQhSbkK8eNdjk",
    "muxAssetId": "NP2702O9L8Qhgso02tJ8pQ53KtdC00ErpR5F4NPV02LIAlY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 150,
    "title": "From Ground Deep Corner Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:11",
    "muxPlaybackId": "EKk86aQ802OWl00WwqZuT02gsOSjDMN7DdJtBYyHKnY7GA",
    "muxAssetId": "iDAlJ9q3lUO5jH3jXSJgY2UyU313NieEfnNUPuAWZ00k",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 151,
    "title": "Full Advantage 1v1 Slow Constraint",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "2:56",
    "muxPlaybackId": "Mx2GCJSKNqAX4LIvtmY1v00s6hrFbi34ZKY02vQpOk8gg",
    "muxAssetId": "9SAbjgR02Aw026xtYO5F00sCzcHDZFvxiWW3LGomfnDpZQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 152,
    "title": "Gap Progression",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "T6N3EDJRdx302mPD600K1Rv7oyNDvuEpu7gvADMqwsV7k",
    "muxAssetId": "fYfeOTp8uHsGOGKezqXJ5VAkOgEr9ps1MEAtJO4J7PY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 153,
    "title": "Grab And Go Floaters And Middies",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "KIe7KUbAcSZkgp2bZ2lRx502P8KBQi3LHnDCg9ch02cMk",
    "muxAssetId": "e00Og02UMxsH9Oeb2lBYQXx3NVqM8UuzdE01yazT1vsNg00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 154,
    "title": "High Speed Curling Layups",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "4KxPjfb3DKFud400bd002mRo2jnYdMvXb568YizkmT1Zg",
    "muxAssetId": "a3j9Zr3I2PSFiti1ZyuBX4tn9k8H6xaWbgZNdqSh3Gg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 155,
    "title": "In Air Ball Touch Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "zlwGKlclpejLWSpZ00NrIaOV02uUYXzvaypFGHfBK4UbY",
    "muxAssetId": "WupRRtFbmmhdOjbQvUnf6eXPFH00zpxNKtaotm0201x1QY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 156,
    "title": "Intermediate 2nd Layer Progression",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:33",
    "muxPlaybackId": "x2TlGUGP5Yn9tLJFR601ipN378th1pSyYiYslz32cfyg",
    "muxAssetId": "v97Mi3OeDQhPKe7RYNuGoKjO3SpTk01bTIBDRBoKAFM8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 157,
    "title": "Intermediate Turn And Chase Layups",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "7xP2fAhrh7z402UrhxrpUIbLr5mDX2VBAehUpIgELwbE",
    "muxAssetId": "A63c9Hvsxvq00X4DFkdebH01Y02it4oN00dfhDCkku01aJUw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 158,
    "title": "Jokic Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "Z9hcKs02RhllN9QnCh1BSXMNFPDuHDMFcp02liLTuFfGQ",
    "muxAssetId": "Vzr87aCOqF01AClJ8gPdzf9P6T00jWYHW01I8Oh14jT301Y",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 159,
    "title": "Last Step Baseline Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "QbxjdxrctDfTSukux00E548oEYmV0201hF3epwkRdM6vWE",
    "muxAssetId": "YTRulUFXsgicuTuWPSiRqDyMyllBZEXaUurtPDzYjXE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 160,
    "title": "Low Intensity 1v1 Coach D Finishing Warmup",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:50",
    "muxPlaybackId": "i5Njvx5xECFQaM00IXSQkUA4SldGGnf7mq6FYIrSjie8",
    "muxAssetId": "cJsKbXa5hTlFI7h8WFwNkyooCROTQhwFktr9T2I9I8A",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 161,
    "title": "Luka Vs Ant Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:39",
    "muxPlaybackId": "cg6OnkpyjFCXHoILY3RceSTtMb7atsD01k7SL2HG02zP8",
    "muxAssetId": "UqiYpkCPfOq9BtbBF2QIWHzmiVgHPgXBaND6npItEwg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 162,
    "title": "Messing Around Blocking Pad",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:15",
    "muxPlaybackId": "eoNttewYwaLyY4YwQ8zwTrML9RVQ02USJrLzfpQ23aic",
    "muxAssetId": "zCQij9pb74Ts00XnFsK7gph3RIrvD4gOexy3v4MdK2zc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 163,
    "title": "No Dribble 1v1",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "SmkmgdX1Rs5a9j101Ru49OLnhboy3o7u02Cqmn6rQoFIk",
    "muxAssetId": "zkzaIk46baRF3DAXOzTVeoU5oZ026r8qY3502p019kaJsQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 164,
    "title": "Oop To Contest",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:50",
    "muxPlaybackId": "shAniwyij4P8OAumluAixjs38sVVszzv900djBKUNj4w",
    "muxAssetId": "BsGAu9idxvhTy6JF7FpxeoSCD60273K02RnT5tVEb7uc00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 165,
    "title": "Partner Finishing Drills Moderate Level",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:52",
    "muxPlaybackId": "THwibgI1bFA02gSmZvwaIYJqGN8iKxJEfSy01X3WLE2r00",
    "muxAssetId": "njuNc6uwL2q18a9FiwZi9QS00SZJNBGVITDUGS5ZsJuo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 166,
    "title": "Push COD Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "WwUhIT003DCxmaz8kJ829fgxU6tJowpDiKle0259CQe5M",
    "muxAssetId": "fsgFuvH8bwH6qJB00M5TY1AE2rdZnjj7WAExwCYoVa9w",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 167,
    "title": "Quick Trigger 1v1 Stationary Floaters",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "mVoc011qS4OLxBJ01GV9QepB43UAC2F9a91rj5rbx1gdw",
    "muxAssetId": "87uPki02XHjaFHftd8QOheS00BcYAM8zMGZom7YiUjXaI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 168,
    "title": "Race To Basket 1v1",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:40",
    "muxPlaybackId": "C5KArOUMDt3Qtal8QY01A7dIm5GV4021Lv3aBtuxY01jDk",
    "muxAssetId": "ehG5pdmFeX25wxTUXykP2olDSnkrZvsBl01kyLzUup2M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 169,
    "title": "Random Elbows Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "fjznUbk7yu6kvxTzuR8YIlkK9zkkC5Ce7KrcN02bfZa8",
    "muxAssetId": "JAXNhRidFbbQnE5REprx7PixLOX2z5KHzdHEsfIWN2E",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 170,
    "title": "Reactive Floater Or Reverse",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:45",
    "muxPlaybackId": "eOgY501yLYwGKPPiO2h96l01VIvhJVJmup00rk54K7Ua02k",
    "muxAssetId": "eDSHW1lxmuaH3hH3FlRnfioMJkwHhLzZr8bh2UZIUsc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 171,
    "title": "Rebound 1v1",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:45",
    "muxPlaybackId": "yEETJjwyCbTeAQmm9E2N9DQwYlbfcxtCLPVHSHpccQA",
    "muxAssetId": "nn02rMx02I91IzhM85jy3ybY6nmwyoPjo9MdrRu9i01Yeg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 172,
    "title": "Rebounding To 1v1",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "CYaruAURhUN02wkZdFbcbLMgJ1IE601WDqZLfy4m1iDRM",
    "muxAssetId": "mrZv1m02Zpm97j7GyToIdXCBPOiZptuR8vnX5B01GcNx00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 173,
    "title": "Seal Dexterity Warmup For Bigs",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:38",
    "muxPlaybackId": "nljN3HlKq8SfgPcqzSC94F2jq0160014ufrbMmsesY00HI",
    "muxAssetId": "cQfKRgWJCy6dFPo4Jioo2k3WnsehFtos57Hix5QC4zY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 174,
    "title": "Simple Contested Finishing Warmup",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:35",
    "muxPlaybackId": "gaUb018uiPmdGtWkcYHB301sKC7JVWeFO00lzUZMT9vo01I",
    "muxAssetId": "wXlV7RJ8ZIFKxv1no00HUCM8pAkzndopzj93v4ZiWlX4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 175,
    "title": "Skip 1v1",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:33",
    "muxPlaybackId": "b8v800XpazH7dBZX02epm7V97ARXYgNU6egLUa01bbt29c",
    "muxAssetId": "JckVRhXako01LHisA01JCwzqViHM7dCWwag3MneUjEPjQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 176,
    "title": "Slide By Drill + Emphasis",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "BkNGiO5ouDJn4jpEoroMFwEwEPoakOVltZvoZFMFUg4",
    "muxAssetId": "m01JuwCs01bbu6K5s1pZOOmLuRJkS0102RpPbeEK8yn2fy00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 177,
    "title": "Smile Help Athleticism Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:36",
    "muxPlaybackId": "ihnYDNKH1TlZSEFaaxJpc8N02nGevA2rVNLWRFymfk3I",
    "muxAssetId": "ozTCzqtLVkMFiGu3ZWeJ01d0282EkiRb2B73zZLJazdT8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 178,
    "title": "Speed Advantage Finishing 1v1",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:14",
    "muxPlaybackId": "kM3KPj1jq00bb4KZTxLUSXn00k47bBIE7jT902TWw4dzbY",
    "muxAssetId": "AVyX02sOLMxykj8mdfPzUso11T02JK1wWgo00QVQlaX26c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 179,
    "title": "Staggered Feet Bump Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:59",
    "muxPlaybackId": "sH00OUGPy3x02mWldsjCBntZZB02vttTro9UZlOl01Zikjk",
    "muxAssetId": "oqcxMogKWaYLQKzMkDeORxa3Mr01p011FZK7Xa5thPjzk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 180,
    "title": "Staple Ball On Back 1v1 With Varied Constraints",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:18",
    "muxPlaybackId": "rcYK9YckC02Z9WFHpVPLcwxxxoLCuWVtv9t7vXQf8xcg",
    "muxAssetId": "aiBMMI2UQyG02J52AWSG3zouLjsrimwLE55302AXMQ0100g",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 181,
    "title": "Strides In Lane 1v1",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "Po9VeKihqmNF7q3rJiNDa6vfdN8OEizfyB8mnbtQ02IU",
    "muxAssetId": "98HIqRefWwQybP1wRffTVv3rJ1G26ENVV5afBauOvbs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 182,
    "title": "Throw From Behind Finishing 2 Feet",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:58",
    "muxPlaybackId": "4uCA1G027202lnUa45qwlYijxvqz101XyKz8SCm00pd9JMs",
    "muxAssetId": "A1t1Xn6X6tABNwB3FNpROOcUYxzVNSiZvv6nZW9p3Rc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 183,
    "title": "Turn Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "Npu9sjRMg4uGmiwVnkHwJfWUnm9awKUZ2n1grBq02faE",
    "muxAssetId": "wy02dqpwY00kLEALB6aqQkfiaLE8xKC00mO34qobM8hFEk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 184,
    "title": "Turn To Contest With Ball",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:12",
    "muxPlaybackId": "QZsjkGAcweKz2BSeXuLpAXvElJkB6lPN1SrpNQr8QS00",
    "muxAssetId": "XPqAzUl5ZuvReE7QyjfN59pClsQXk01oIpm02Xa7HQSbo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 185,
    "title": "Under Basket First To Finish",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:11",
    "muxPlaybackId": "kPqHsOHSfdRooir2slfmeFchf52Tfm5FnZxR5OUy00Ck",
    "muxAssetId": "c9E4vxUin9pTRM7ihI6ogqDeJ6UIv00XaFBCvkOSD02Ms",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 186,
    "title": "Variable Spot Full Advantage 1v2",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:40",
    "muxPlaybackId": "cMSw923ShARQjVh9tzX9L3injojFYeayRfrDAHimDlo",
    "muxAssetId": "BUrE202Yr7EY85NgnSTvPhKnlXdRi0100fxY00Q7UNM02l2E",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 187,
    "title": "Weak Hand Advantage 1v1",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "oeTWxbPYHi6dJSBd3bqky3cVa8w01sKb6xpHVX2keu7s",
    "muxAssetId": "Lew2yvMxd5RJHxzwD02y7cSmSEK8ZdK9ldUqK3m2hn5M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 188,
    "title": "Wing Start From Behind",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:13",
    "muxPlaybackId": "AmXmMMt6YdFXbbUxjc7XKv6MO02f2jKXyBLKgL77wxRg",
    "muxAssetId": "A5kQG4CHqoaqOjQ5845bGcLhaFVqSGt02yk3GQGRR954",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 189,
    "title": "X Cross From Wing Chaos Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:10",
    "muxPlaybackId": "oTLOBpQkmAqO8gXVTZLeBa00QyQCQhdmiTGpr89rdrFA",
    "muxAssetId": "KKGOF8pOg17IiioShhK4KPFHBFWffZz00uIygC4iJlPk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 190,
    "title": "2 Dribble Pull Up Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "XDaejoeu54bPvMgRXtyIHsi01xYOWbLiwOq6spJfMQlc",
    "muxAssetId": "VTZCcf5jNd02DDcXsCTXZ5ay79mqmbTniGzRBXAeBlsw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 191,
    "title": "2v1 Freestyle Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:59",
    "muxPlaybackId": "uFK5OGBBAZ9QAleBkWr02LQHWAcZJ4O4JVNyNm9ik5QE",
    "muxAssetId": "fovuAJLRYVacEkrvrJyKVHdq4oyPWvsr4j4J9vU01q8E",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 192,
    "title": "2v1 Full Advantage Find A Three",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:15",
    "muxPlaybackId": "dAeQOn017N01jRZ1JL7J012rfbN6d9YSoKgzSI02KTYWJgQ",
    "muxAssetId": "tY1EJO4i2feg00y02ikOjjASWBN9pCVQcyIOBCaxhzLrc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 193,
    "title": "2v1 Shooting Variations",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:55",
    "muxPlaybackId": "1McZEAeEHNyfbveai3xcX02FKv2kct5XScsnncymOgNc",
    "muxAssetId": "s82YUQtEeBISqRHL2400CwIVNlTPKVjclLpC1VWZOXgY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 194,
    "title": "2v1 Shooting  Static Relocation",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "gjCG801w2SrK94puChDJvXMTz5V96y4spSmztkzKcOhs",
    "muxAssetId": "ukU00rryv1bd3gWUfmTj8XWvobPTgUJRONbbm71S7NxM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 195,
    "title": "2v1 Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "CPTQrhMAenidvp001201jAmNzsECzqeCLgv1bI00EXc8e00",
    "muxAssetId": "02tnKToaxTZZS3D8vVWZFSw6o4s02lXe6GuIw3PAaucuo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 196,
    "title": "2v2 + 1 Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "zwMlWtXeQsCgWORxs6Ai93AvNTlRmMLFmfmkPYXCSTA",
    "muxAssetId": "wr2pTJX017v7s01fZNFRnMtc8BthMqjB7201b1fqQXqc00s",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 197,
    "title": "2v2 Threes Only",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:44",
    "muxPlaybackId": "tWn6MhPjn1cT4lxSXSi2lkbWtIhjOcWeVmsWvMSwyn8",
    "muxAssetId": "8iuH1kmrZRKmej6ACE24LaAZS4XWpxsZlc6013NMcR6A",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 198,
    "title": "3 Person Shooting Series",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:53",
    "muxPlaybackId": "jQW26RPuv6I1phMow3vTbBeKxcttN2ZUMVamvXHbwkE",
    "muxAssetId": "9i23l3BN73Ytm02T2a301eWceNt7GFgIPwMq7ujGaAIA00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 199,
    "title": "3x3 Threes Only Copy",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:58",
    "muxPlaybackId": "wK3d0101GUscp027KyS92XF3bqr7gqnPNwWPBM1HF8ih2c",
    "muxAssetId": "l5xg3d68iEyOQ1BuXguMmO8PZsl1urraULhOgmGnHbI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 200,
    "title": "3x3 Threes Only",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:58",
    "muxPlaybackId": "p6Akm7znB02t1sf8O5Jkuv5kRE9agxL6N9nZG902K00QE8",
    "muxAssetId": "Kr8fnThNMM6R02JQcuPdzU8g65h1tQc0235D5E3h8kZts",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 201,
    "title": "Across The Lane Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "4uCYvMxxYUYc01NmI5CRJyQGtzlRKFL6jMbKDETBL1A4",
    "muxAssetId": "3ScaTje4WfQscC2GQ00bSqwXY00bwsXdpb022jXI4Ci8cQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 202,
    "title": "Advantage Cross Court Pull Ups",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:35",
    "muxPlaybackId": "vk0200cGu00PW9Tv7eLQdJ3upqo01wm4cUKpkg437Z01CB2E",
    "muxAssetId": "WPtF01DTaZ022nz01Y0202mOeG9m4dFXJ5owCzgefmXXFYz8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 203,
    "title": "Ball Toss Mid Range Pullup Series",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:49",
    "muxPlaybackId": "FsQO3m3Lbypj00fsxlARtJdlUElPT1OSTnNEtBHsItRo",
    "muxAssetId": "2VgrH9V5oEyhw2zRRWtcTDQNIX7AKgA9t2KAk74BBpA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 204,
    "title": "Basic Contested One Dribble Pull Up",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "g3iSPfGgSdV4004g33IAaUbXvfOHMIrrr7bJ01uMnbBU8",
    "muxAssetId": "Lktbv7jbxMu5XnYc7jIGeATp5MknhYyugJEJOaAFCk8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 205,
    "title": "Change Of Speed Separation Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:14",
    "muxPlaybackId": "wCHc2gvDhAmf2BgqnwIYSVPbiJcdrwNn2500kRznqvzk",
    "muxAssetId": "Keo01hWP1UDxsyoWfNUhgYsgChWfXkOBn6ys8ajGBih8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 206,
    "title": "Chase Down Corner Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:13",
    "muxPlaybackId": "QUrBGMg4VfmZjzqNOuyiiFVAmCgG27BKK4brMBxj9sI",
    "muxAssetId": "4HDQKjcbN52tgeGwF01fLJWoHc02zJDiyI3AS9aLtgWKI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 207,
    "title": "Chase Down Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "CJXTEJhAyfnGGLdoCRCxPGZ8hxS5D22RDghSSuBa1a4",
    "muxAssetId": "iH01euLt1ftJoeAt9mKub91xVWIVGynqFwGd9p3LrB3I",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 208,
    "title": "Closing Space Decision Making 1v1",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:34",
    "muxPlaybackId": "L3Nde3ho24NXmOJmCSAZX7mAdEzLkPESzwjS6uzyIdM",
    "muxAssetId": "Q28008WI01S4zAlPkH8V1ySdthnqWXLx7mzgiEkmMgs0000",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 209,
    "title": "Condensed Steps Short Pull Up Drill",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "00fgOhE002RlJNEh5PO68G3TMAmMlo4GYkDnaebj3qM2c",
    "muxAssetId": "DIUjzpZkGcwyymsV2SFJbDDcrSt9uxqMqE8Yh7Bms01A",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 210,
    "title": "Constrained Space Pick & Pop 2v1",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "SHu3vS8yZbrTEidSwT2UBpGXD02cJwJfF28xsLj9F8o4",
    "muxAssetId": "9PGUsNCkGxj6irk02xfGS9UhAQwLD0215x9IwcxmhCLAQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 211,
    "title": "Cross Court Athletic Pull Up",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "52MkM6w2HWt1ctoHdRvAxf86BZCebE7rZQre9Xrwx5o",
    "muxAssetId": "asRAOorf2zv401iR74u5WbmfXX00yuEtpR016by021jwqqY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 212,
    "title": "Curvilinear Chase Pullups",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:09",
    "muxPlaybackId": "str4jkq25siF9XpF36Zue7XtTkMbUtH00mFaapItR2Bw",
    "muxAssetId": "eXA01n1uBxyFBt1aOhcBzbhrffGxUY700UHKXsewUukN8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 213,
    "title": "DHO Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:55",
    "muxPlaybackId": "A1FI6QIjY81JX1m5PPoTsOnqIV7MGzlyYkGUZd9SV2Y",
    "muxAssetId": "TvRY7n8WEgUhICyw02wTlB52es3sGC3z4M9j01qwkJpZQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 214,
    "title": "Drag Screen Shotmaking",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:14",
    "muxPlaybackId": "fqn01B00izZ2wBlRk801kXcyFvgc02EcsI9C8RFnFPUjjvo",
    "muxAssetId": "e7S21Tn6x7YfDIhrqk4gHOfVz5T004vc3mJKhxWYGWn4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 215,
    "title": "Dynamic Shooting Workout",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:49",
    "muxPlaybackId": "Exp6Wbwr4WLpjDqLpBoeP8hcN2hKY00vwe6Adn8YIlWg",
    "muxAssetId": "TzgVI7YSBb23Ln01fJ00t00k599mCyGEonKgNKmMt74sxs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 216,
    "title": "End Of Clock Finisher",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:46",
    "muxPlaybackId": "S02b7OC6eqggB4N6jae3S2k02pzkKqUyuMesuQ5M2ZVKc",
    "muxAssetId": "jf7aIrigFqbw74n67f5o029T01rfsCiaFsQ6axCoFENDQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 217,
    "title": "Flip Away Contested Threes",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "SIzuhZChWUlIIZFH5Vv7CYp9U3pYznJBO5sI02svgesE",
    "muxAssetId": "l00Q5lyk02SBLlqZcf5RWtgk4FOAA7ANNk4UTgcAdvOH4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 218,
    "title": "Float Into Swipe Pullup",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:46",
    "muxPlaybackId": "84nB4TIDMV6WO3sI00WFZK2SMzmW6IiPSiXexAcJubE00",
    "muxAssetId": "PdvjcC9d2ASZIle0021JdukHpc2digipB00Jl02NGOISiQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 219,
    "title": "Hands Down Contact Middies",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "ym5mYxwGr5qiqrEUvM01iKYjHhF7FyzwdWpOo9X3knpg",
    "muxAssetId": "TSH5aSaCE02wXhLftaLgwasdnZm1kXuWYq02r5kYRj02sc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 220,
    "title": "High 5 Short Jumpers",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "esbpet01VIKX6njUyijPLnR6JWNnFLp5eRrzT9ttB2zw",
    "muxAssetId": "s6soZ1ddEbWSz24G9Ji00IeFbhWrkd00KqQSRi00y4kWt8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 221,
    "title": "Inside Spin To Pull Up",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "01WixmOUDY3KHeigdgW008y028NWr1cmQ8NkPsBXPMSrDs",
    "muxAssetId": "MD11QKbFX00252jOhTyiW369w853UBkU5T9B00sggiThk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 222,
    "title": "Inverted Flip Contested",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "IxTi74N400vIZe7y7bL2qlyZ4d01WSUOBV1V3TxqRRqs4",
    "muxAssetId": "iJEy7aVECEeMMTG74E01hRkQdQJYLwWqjUay00bVZEGoU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 223,
    "title": "Off Ball 1v1 Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:20",
    "muxPlaybackId": "uf00q00nh8An3Tdtgkn1YG8n01U19oOzNtBQ01sGXso6OX8",
    "muxAssetId": "BI01u02m00O01kEMfqqVdQWwVeGjNOSDyt9zFJsRHUO4qrE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 224,
    "title": "Over The Shoulder Contested Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "MKxupj02Jrh00e0162CHy01NgwaDukC75EtBfl8Q2LEZT5s",
    "muxAssetId": "WCHQw02VU00MzEaQG9SpIyDeDMejPL019dmiS9AHhd7Or8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 225,
    "title": "Pass Back Quick Trigger Drill",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "nDizYhrsKWeQOF3mLrNgNIFccdKl2D02uZMge00PWDpak",
    "muxAssetId": "OV402IgQmOMWXuFE9wV6XXfSZaPFMCN2xZ7J8ugK94Xc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 226,
    "title": "Pivot & Go Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "pH3dZHWWxdpWWQlywz00Royj4Ho5PQFlC7YpEzliSr4Y",
    "muxAssetId": "ok01LbJ431Oa202uIGLFDcPmTjONYS9FtGfRSLyFljeKA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 227,
    "title": "Push Or Lift With Drible Option",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:40",
    "muxPlaybackId": "uAJpnfDHx39LrA4gBiCThWUnxVgJfNnP5DerTF01fvtg",
    "muxAssetId": "9BxeT9d2zMC1vZBrJh2A1i82MSVFSrEHfJDxkFNmh5A",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 228,
    "title": "Quick Trigger Advanced",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "U2LaPnU02bDoiYkBrQK01IS014lCvFEVUXf8f400D3gaIBI",
    "muxAssetId": "kWSp1dnA1XK3YDscfWaGKTMoNAOJA88txlQgILgDbec",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 229,
    "title": "Run From Behind Off The Catch",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "nhZeTuAd12XvBkeSR1O7kcA38TkXy00J7ixFB3gNnLPU",
    "muxAssetId": "rtp2RSMr8S00ZmMSpMcG23F1rjT6xqEwTHaOQpDOyZR4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 230,
    "title": "Speed Shooting Off The Dribble",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:39",
    "muxPlaybackId": "Cov02Q3zPduV3GqdYchM2V0202kASgm7YTTzvBl1uG800sY",
    "muxAssetId": "X7x2Fks02EmhuMcyqDnr2vOHNcPZeuqyEm3DFv002pbv00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 231,
    "title": "Tag Dynamic Shooting (Before The Jump)",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:05",
    "muxPlaybackId": "602kK02d7vr01Vqw1c2k402GbLIeLZUH2Yr9swl6NT5Yk02c",
    "muxAssetId": "XIWtWMZ2udE00l4islM4UocM01I3bN01EK003U6Ml8o7tMg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 232,
    "title": "Tag Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:51",
    "muxPlaybackId": "Fb8Pf1iNtZe1DOMO4qJILjlv2I3dBBgPV6lltYeXQjI",
    "muxAssetId": "NegtT9DgSIF81CWsh5dHC02WqCsDFaEgI3JYdE42Qvo00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 233,
    "title": "To The Corner 2v1 Best Shot",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:16",
    "muxPlaybackId": "oJzskZBuKUknQw16ziIbgb018wtNyubZlEBie101DI7kQ",
    "muxAssetId": "qJ1oyDDwMkrfOiLx32K42eIEG3rm6FS5NyvONjT01KzA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 234,
    "title": "Touch Hands Down Constraint",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "IZqggfFCFnXIHsrYOV02kzTb01Ir8ZYX6crcKCctNNFDo",
    "muxAssetId": "rmicX3b7on01ouS7WQX4EMW4kKlpg4ZaMOaWa4Q00Aj02I",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 235,
    "title": "Turn And Find Rim Contested Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:52",
    "muxPlaybackId": "7DerxWjXKnQAnGLORQRRdG02FRePVZ5L00u6LYqltgHcw",
    "muxAssetId": "TsCkE02SGRHRLLh1ShPLG62W02vlYS025VelPy7jl4uDXA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 236,
    "title": "Turn To Pull Up With Chase Down",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:05",
    "muxPlaybackId": "WzhqxOqPWFqQ6KYGtwQSkji5dwVndEIE5NBEsgJTEEM",
    "muxAssetId": "UoVv5vlBa6s3s7RfCngvliG7F00yTgxSWcvAaWiEIeps",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 237,
    "title": "Two Person Hold Off Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "bh102ytU2fC15nhqU1DzSxgKQ8mBEB4IjkVDjHgemg8E",
    "muxAssetId": "02Zr4nOpguw9ajFK13oj00B00gS9UGUAxjMx1wYarTnf3o",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 238,
    "title": "Warmup Contested Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "cc5t9q4aMwoyUrTAic14i4CEKSX6Ws01O4wtwBvhJ5M4",
    "muxAssetId": "lwJZ9lak6ZWeFkMOCnXH932MTTvpaDfv7VIxsBLcM8s",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 239,
    "title": "Warmup Opposite Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:11",
    "muxPlaybackId": "Ktdw3g9v2BSKrkbHAG8LXdN97NuCI01rPQSM01d6f54U8",
    "muxAssetId": "sH7dLQdYmKxJws3IatawOMQemG7bnXQxtAdIpAApZwo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 240,
    "title": "1 Dribble BTB Passing W Defense",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:48",
    "muxPlaybackId": "od4Pt5vIFtJEJZjogrufDDUVqp73ihfe59JNwY01DxFo",
    "muxAssetId": "JqhfJ502faHpy01ZwwG732oUb5s1vNS6QUNa1jxQQwhpI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 241,
    "title": "1709730229173",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "hwvT49Mc4KkMB01vDnMCONxA6Rvqr6QjbDD435emqB9Y",
    "muxAssetId": "D3500StpEgbiohTSMn2VhITrXXfJ25CwahRx00zs02BwHU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 242,
    "title": "2 Ball Jump To Quick Decision Drill",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "OmP019vg47qQ00dPFD7YmxupPUHbHKdLDJstH71EuQ3KU",
    "muxAssetId": "dUatS02ZTr00RpfgjYglpxhe00hjtJdszsjrDg7qay1HIM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 243,
    "title": "2 Part Transition Precision Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:46",
    "muxPlaybackId": "G25DcKBqOi6KXGdidI016urVYWFzKXKMDm4qHz9TsyxM",
    "muxAssetId": "fJComg69RCL65u3Bp01gBWKuu6pXkzxkw7ocojAfdbqk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 244,
    "title": "2 Side Transition Drill And Concept",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:44",
    "muxPlaybackId": "2pOaQZ02EQJ6CjxtXDQMQe4AqF8rkzHwWBX7X7501pVhY",
    "muxAssetId": "jAYwk1VV11Qkw7sJTijHXxMMGmaWn1En8sj00nIba1s8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 245,
    "title": "2v1 DHO",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:47",
    "muxPlaybackId": "00fZn98f02x61x5WuN00gPRwE1he7BykASNFrg3GFN00JS4",
    "muxAssetId": "8H8Zgja00Ym1Iy99CBgm01CAE003YEnJNbIKDCvB6BkdiI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 246,
    "title": "2v1 Passing Progression",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:35",
    "muxPlaybackId": "EflkKwWpCzI6hloQ8rdElDLGPp00JtpRi3RZLUJtA02bI",
    "muxAssetId": "p2Qf8201ZppIj00tE6paUSbnDQWHHhNJyiNBSJs99sQuk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 247,
    "title": "2v1 Stack Dump Off Or Finsh",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:01",
    "muxPlaybackId": "N9683qMDvw1659b8YupE1QRfUbLaWJdpjubYCnUsDzs",
    "muxAssetId": "SYbN028q37GZQU8YBJBepa8MhWfdHArMeNKSkMNLJeo4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 248,
    "title": "2v1 Transition Oop Option",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:22",
    "muxPlaybackId": "M0092TFycNLiN6SfZqkybRGltAmtO7kFR602V7GzmsK0200",
    "muxAssetId": "JR00uG16w702j02y2HAvoPFG01t01dynFSzOe024yM0201SIjLY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 249,
    "title": "2v2 Blind Shooting And Pass",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "HDeVgv6Ov19f53IiOt01DLWCFwsToas75BYJDAs1kr00c",
    "muxAssetId": "rnC5QcqqsxAheCD5kIGq9mD02Xb3UBDiLlJuNM16nntw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 250,
    "title": "2v2 Chase",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "00ClkO2B86ax5Qp7R61Tiij02fwxFNftsrI4MdNqTw004o",
    "muxAssetId": "ntH4dQ45aUVasr3HkCX9YbR00kp0102S4d02zUV00j01bp00vQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 251,
    "title": "2v2 Get",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "LWX77100UrceGFJ6SH7pqYVNd13dnRKlsJdjujdDFuaM",
    "muxAssetId": "fG1U1QyzLWELnWrpBNQQfTzDDlOUEJgXODFnbKrUbAk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 252,
    "title": "2v2 Give And Go",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:15",
    "muxPlaybackId": "niKn2gNfcbD301wKgw8t802F01woG93hOyEm43sMzuQV800",
    "muxAssetId": "CGF1S601dPo5HaICljYqCS7PhX8GMRp3lHzrnatuli3I",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 253,
    "title": "2v2 Push Pull",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:18",
    "muxPlaybackId": "wLHjR9n1QaU01hnrnWDV01aY3x02sOY1MYk201hDKn5SkfY",
    "muxAssetId": "t3Kh9F6KaebasxE62CMroa3bxAtPDWo67ZFr1C7ENM00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 254,
    "title": "2v2 Switch With Big Simultation",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:42",
    "muxPlaybackId": "h01Sv02TRmQvJxdCz6dReo201NIJE02EOQsUuhJhAeDarE8",
    "muxAssetId": "ZT9ET42vjLFqstvcdXgWOYUwSY38rFTot4xYNwKvRbE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 255,
    "title": "3 Random Actions",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:01",
    "muxPlaybackId": "Si00CvlDKo2FmN0001HL602NZKlyyn2YUQJJyA2ygmNYT2s",
    "muxAssetId": "Gata5SnrE01nLx01AZ2d1TYCSpsBsP2ibQR958NF5h5uc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 256,
    "title": "3 Screens To Score",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:16",
    "muxPlaybackId": "l3WFl7nCeKt01xtlkbVnMnxY02oVS4c1keeEx5XWA202hQ",
    "muxAssetId": "B2oXfoQV8ewiiQFmAHbC9jKHPJQoMY02DqkcA6LPBy98",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 257,
    "title": "3v2 Attack Touch 3pt Line",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "egqeaWwuJ8K1Wx7gSX5dDxO28XmalM1020015WlVc600Sk",
    "muxAssetId": "XPZaOIEYfZFhFuYBVB2LudazPi60041cTLrHtgsTxtXo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 258,
    "title": "3v2 Circle Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:02",
    "muxPlaybackId": "lllFVGyRnQQN57frqGo6KpYmtCx16ukpt1nTMLlG2qY",
    "muxAssetId": "B1wUSRcWU4x3eaTDWdM0202Wy2TaxniQ95CKSSEJaGvB8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 259,
    "title": "3v2 Relocation And Passing Fundamentals",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:53",
    "muxPlaybackId": "02K2E02prMILdyagOtcY7AwcgbpK2uYnF8Ow00n9orFWfk",
    "muxAssetId": "Qy8vMEpUpKd2yejfC5Oy8ho101RqJWHiGmRQMVm42OsQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 260,
    "title": "3v2 Scramble",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:59",
    "muxPlaybackId": "NbtVz3i4ImYrUUG7ogOnWEz4hwFcXCeXl2zwaWcI1Mo",
    "muxAssetId": "JJ4Ks00ASF9jeBroo3sxXkLwfxhgAJJ6965dPCV8NNk4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 261,
    "title": "3v3 Exchange",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:21",
    "muxPlaybackId": "b3VlZ00KYtr7v7aRq78P0254FmbOyYCz14G5OCWiByuIU",
    "muxAssetId": "NLvU7wWt26zLJfzYBZ01019yuohpb7HkaIg9YIeh9gETQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 262,
    "title": "3v3 Horns",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:54",
    "muxPlaybackId": "Y4BPN00S2BQ9M86dFB502jdYCZjMRTT8aTH11MGQ2WNPI",
    "muxAssetId": "QclTWm1003sE019h3pTHvi5cofzmPq8nhdC8QPGEZqCH8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 263,
    "title": "3v3 Pistol",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "agmf2hqylocP00fW7vIT1GWdEhtzNp004kwd6nx5NciLs",
    "muxAssetId": "HoDIc9FQbM3yAzOoJMKsmEO1QyTw99BeLQME93HG6b00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 264,
    "title": "3v3 Screen Constraint",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:36",
    "muxPlaybackId": "xcXi645Q01700wPJJunCpLXumZQAt4KJGO02WWw6GuK81M",
    "muxAssetId": "S00Q2GqCeuTl6qlQot5pTJz6etMs3ZKlEUVWscsACQdY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 265,
    "title": "3v4 Paint Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "bHyFVqa9jcob7rVhiHI1vc01MDUe2gJCSRE200CRu7eUU",
    "muxAssetId": "nXvBTUzzJrsm3GLBlGGgbIPsErYXsH801EGomMYCZOAc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 266,
    "title": "4 Corners 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "xixSOoniK2rOTk5ochEQIdp1vxyPCkM6Lqtfp3PQKhI",
    "muxAssetId": "2KMpCynq02PIbDyJ3IVZNK1lJkDSHdnFqZtsYbh4VhaI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 267,
    "title": "45 Cut 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:23",
    "muxPlaybackId": "kYSDUvivQyLpvVamghzdY02CKBE4JahsJvekRVZReEMY",
    "muxAssetId": "fXOL2027X6DpknhN00ZQokhUZ0188WsawlKRYrb7LKW2Rc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 268,
    "title": "45 Cut Basics",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "To9LvXzU9wmDAFD16lrb006lg02qjAphoxcE1W6QQmORI",
    "muxAssetId": "5hJ45Kxo5YlDDR9o4o7kMlRW3e99Y01AxUJXSMVUkP00o",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 269,
    "title": "4v2 Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "so9dzsiD2U3q9oeYMNdEsENtn7FwIGFB011jyCpFFV4A",
    "muxAssetId": "CzFq3FwoV1FkY5fgSdU5FfUoPE98GcUvS74WxoMP201U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 270,
    "title": "Advantage Ball Screen Reps",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:53",
    "muxPlaybackId": "QddxguWDF4IsWkI9atiOygD019eUSw53owZQWvSPwMYc",
    "muxAssetId": "NYq6LEVhGhGqxyUYnn7CQs028ZqzycX4yEH2azl02cb7g",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 271,
    "title": "Advantage Scoring Out Of Trap",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:52",
    "muxPlaybackId": "BOARZbvNv7QYKavp9aRuuD3rkAos3nR02JiXBRTmjj00o",
    "muxAssetId": "XL5DI9N00H01RGnISjdsGVLC00k3GbrPnotdWh02S6ceJOc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 272,
    "title": "Advantage Start 4v4",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:47",
    "muxPlaybackId": "a9NN9ogk2QUP02YEvsI01zsjNEMP9ngQ5ElaulbYZz02IU",
    "muxAssetId": "502018d23Rz9BKI7YAt7vuv2FlWuGfudjoE01icwPAweRg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 273,
    "title": "Advantage Transition 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "gYNHGXC2ISMHxY7NEH9FOMkDdzpMradn7kI48HARqSk",
    "muxAssetId": "T8tPT1Ek1Fn8gmyyhdifHKq201v4qSgEuf7ogKH9fUFo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 274,
    "title": "Basic 2v1 Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:18",
    "muxPlaybackId": "01DIkDTs02BbQ6PxP2qGn02ESgvsGvzv3xJ1P5AovywEfo",
    "muxAssetId": "3p00sNxOMcL01yUOxs009tTinYe8WtrgglrmZCaukuUDd8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 275,
    "title": "Basic One Hand Passing Warmup",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:56",
    "muxPlaybackId": "jEsOvljzpZZVLgW00FP8SpF7mVq6lK1KiMDyrda25HAg",
    "muxAssetId": "ND42P1WJ1GQ02NRIUla1bA00z5FVdutHb0102LEDI4jFjWQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 276,
    "title": "Basketball Futsal",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:35",
    "muxPlaybackId": "5yCOpupV8wS7HwC00BdHUg1wjJ3HW3xQ89WxALZgN202s",
    "muxAssetId": "SEza01uZ019HwY9VG00PonNKI2sXVHM00Az4BU13ZXl7I00c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 277,
    "title": "Blind 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "5r026bvo7oiQVT4tYEgVDvk00JxzeX8XXrCar02pdxRdVA",
    "muxAssetId": "4p01F00YD3KwdmRCtSqQyMRJbGwDZ00xRLumoEfuySPAuc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 278,
    "title": "Bounce Chaos 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:45",
    "muxPlaybackId": "BddWYxqOW5Rybfq01Ep5EpZqEq021HJwBuNqyr00NPhGNg",
    "muxAssetId": "C2Y4wVgaq5xQik00wMUcI1JqyT5QvSOlUD02U5L2QuyN4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 279,
    "title": "Call Out 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:54",
    "muxPlaybackId": "KEM5mVf6ZDkNUQh75I6aZqVAZ1x1webO7dtJeHnxXYQ",
    "muxAssetId": "uB2501FBLj6v1Ks34igjF7FI8vSPHiXCWwA65d8mM8lk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 280,
    "title": "Close Quarters Transition",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "tDMWTCI7kb8WaKsz76dy9QrP79dDxMQTszPki5ZFvy00",
    "muxAssetId": "CfMV00npjK62vI02WRS8hsVbw5LHHVX3x00abbDRWskW9U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 281,
    "title": "Cont Handoffs To Find A 3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:33",
    "muxPlaybackId": "t01zMtWNvwUrv01wbuAQ5MSC5HaGZa3RpT4Wi7PQwurAU",
    "muxAssetId": "bcSalx3njMO2xm14n00JBOEKn4q00EM6K02kDqH01LlC94M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 282,
    "title": "Contested Catches Drill",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "sFrOhST00tJ02t9vxm2MK7ImckurjMYqLLYsLRFkKOJAE",
    "muxAssetId": "CftYWJc2hYCWOf5oo74QqqJXn1cDXSGft00lRVZ2U9fg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 283,
    "title": "Continuous Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "xOMvmvZHPbjlcMSuj6SUDIQbmoJztTqK62bvW6zdTsU",
    "muxAssetId": "3Yc5T02piF6B6qqofHCJBlb8XeeOw1HNesqNA6H66r500",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 284,
    "title": "Corner 2v2 Attack",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "rlQptDCUROUCmRpLq55CnJ3PNJ01UvfJky2FDVe12Q400",
    "muxAssetId": "BbM6VpLrJChYFpaqVGLfVRg502nzluSRsX433yf01NQ600",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 285,
    "title": "Cut And Spot Up Off Baseline Drive",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:26",
    "muxPlaybackId": "RSjgn2qTbgwrqv2c7Grhaz01FTVcwPiXze00RAteUPAeU",
    "muxAssetId": "i00HoB02R92UCOot02C200OpzF4Gn9snv017D8DNTmTgD9jU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 286,
    "title": "Cutting 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "sXgyJnDWc98c00wxpifVnteggLF4HznSfSXcdKlj00ZLA",
    "muxAssetId": "f7QxAxpiIeo02s00kX4I02xSWlzS300BNdSP6GdIH00Pl9AA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 287,
    "title": "DHO To Trap",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "97EF2W13nvgSm4cawvLWVpdjhXfr8MCRFhn3CYbCyoE",
    "muxAssetId": "zIOLLe0101T8cH7nA9nwcgbrkyHEEF62zKOEaTzJNGoxE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 288,
    "title": "Dealing With Traps",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:34",
    "muxPlaybackId": "z5EDGzzLzPt57ZzrnWxNypfvQ01II9ilksd01qPKDnisU",
    "muxAssetId": "M17MAK9rStRpJjfhaOx9KQNC1J38DCXKAQQTf7AIc6U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 289,
    "title": "Deep Corner Gap 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "iLu00mtf3Jsm44arp6g02aj9z4W1YU1yFMGf005Numa5008",
    "muxAssetId": "DDjW2FijHvhp8JH2OCiYwg602gXD009qgdc9VHLvSvz02Q",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 290,
    "title": "Defense Sprint Start 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "fEvytP62D6Bp003hiKS8oqrNBEPNFxIq0166SGuOTDFLE",
    "muxAssetId": "EJ01m02f7gT1K7Or00D185027txsG7zRz2MSAEsbgpeJtq4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 291,
    "title": "Defensive 1v1 Drills",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "6Q4qLvxW4pcuetqm00RfohqDcRCmTi02A7u7UAnMBHZxE",
    "muxAssetId": "FzlXo5C0215ZeGq02zvOtfVrrybwBqR3ctuy01yJSBg8dA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 292,
    "title": "Dexterity 3 Man Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:59",
    "muxPlaybackId": "668WA9a5snBi02rNYur102kAVEjKWtiyDwUXvImhoLbdM",
    "muxAssetId": "Aqk3L33lQwKRaH3TSvMSQozX7gJ47w3dSswM00EYYpMA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 293,
    "title": "Downhill 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "3:11",
    "muxPlaybackId": "2AVM17Qa01b02c8uhDpwvk7endz7r7mr3LyE3kzSDW3Xc",
    "muxAssetId": "9tFadKS6KFpYMp2LNmx4lROtCf5BvVMQy7IqX2I5jo8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 294,
    "title": "Downhill DHO",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:41",
    "muxPlaybackId": "NC1qZn400ln00w6ccy2SCZltB9amZTRnyzCUnr8df402Qk",
    "muxAssetId": "DoFLT100qiEBtS45XJPsX9KaN9ZxYsgelgukNFOCaCFY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 295,
    "title": "Downhill Momentum Start 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "QwiPK6XgsHdIQ9zXmqIkH53uzNWx8a9YzWArpv1NtkE",
    "muxAssetId": "BEMyUNLEaO2ACnevnZmE56Og02WDO4YyZQNMYn02Goptw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 296,
    "title": "Drop Downhill Decision Making",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:40",
    "muxPlaybackId": "800501mOr4ANisqdMmPAk7MwtBl02TNv02zJq8Kqm6Y01tbk",
    "muxAssetId": "2Xe100hOOpzQeuYhRjHxOmWBiEo6jGMpAz77ZZIntY9Y",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 297,
    "title": "Elbow Catch To Backdoor",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "eDJYd023TlPog7aMRRRnJGyRqQeTNEkkGdlxxi4ukLOg",
    "muxAssetId": "brEArKxtR9ydj02UYZBPQRRjekY23u9EddnhizsIalvE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 298,
    "title": "Escape 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:44",
    "muxPlaybackId": "N1CoaIcWlwyvekebjXDZvsuKDfLgNNM7olBiwmAStL4",
    "muxAssetId": "7RvDLIeLThx02xF02hwcVtDbdE602pO01GaARydyzlcSFis",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 299,
    "title": "Exit Screen Drill",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:41",
    "muxPlaybackId": "pxcSfVG94soWHywAB9To6fvs00rlCGmp8Zr00pyZExjbY",
    "muxAssetId": "Nz00zzx49wu8CWR9IWqVeEIk7eFWg9lX00OPskpPkKS7Q",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 300,
    "title": "Face Cut Or Backdoor 1v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:33",
    "muxPlaybackId": "slExIoZZrYR4SsEY5wUMEHY95SRatuPU9Wt9M01qoyEo",
    "muxAssetId": "K9i7QeqyMexP4vntXhK12bLVHP7Vi1YR67tiRmuTk8M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 301,
    "title": "Find Passing Lane And Relocate 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "FiqRJquCOWoyYWBbF17YHqdfMXV9glPg68KF6YSYKdA",
    "muxAssetId": "3DH7pbjLs1jlJEfLy7FUY02rXlj015vEcd02fJTPAycEjo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 302,
    "title": "Flare 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "8u3Qdin5Sh3hdS014BhhTo5g02w6Dl5TX02BJW5LmhMRmc",
    "muxAssetId": "02DAIUooA3zN9XMhLw5Ak00eNVeYF4sZmaG2DeAExkoaA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 303,
    "title": "Full Advantage 3v3 With Cut Incentive",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "TwjUQlCWgAt00AGANaJmz2T00TiRnYfF502oaMQBgEumaI",
    "muxAssetId": "BMbZ003AE7f4EVtkBxfWnymeTQYadNDbnnS6BUKya7dE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 304,
    "title": "Full Court Passing Copy",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "KIO7jDwlXEgIHDQG1HXOhLOjBQa8vNoTRsaDnb0101B8A",
    "muxAssetId": "KK01A4XurGl6wdwedxkuuCk7fAo006hX94SywI8m700b4A",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 305,
    "title": "Full Court Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "s3EVBBcEabunmUhWEwEMV6tY8cGgEp2oh9RL02300hN1E",
    "muxAssetId": "nlo3qvSqCKX5oslT0102wXwaO01XAyQHens7i01RN02D00eYQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 306,
    "title": "Gap Tag",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "3:37",
    "muxPlaybackId": "EnaEozTp7mv01PWqqpq8tBHKcrVUImlJ01o02TNTslQoRw",
    "muxAssetId": "AwGkBUWRFteETTqwLPo4Ryq00oCKEbCATXT01sGZq7NBU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 307,
    "title": "Handle Pressure And Seal Warmup",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:57",
    "muxPlaybackId": "l1800pI016mOcKSUtLk35V4a2ZmXWvymjwie8gTna020202I",
    "muxAssetId": "ddWAl00AkmF02boTmumh8ADML78mEeZg2YHDEQRTBXvPo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 308,
    "title": "High Speed Gets",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:44",
    "muxPlaybackId": "w7sFRPhH8QAbbE29s7ERJchcMzSoxGHD8R5HKKuaE8g",
    "muxAssetId": "JPzILxwWJxq3cH1gEu01suujJ2rsoWSNzlPmP3wjFTRE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 309,
    "title": "Inbounds 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "rjJfNMU6EZzJgNACmhgOsE3EZRa501ZsyXtiuC00keTJ00",
    "muxAssetId": "4rzYgYZNcxheOue4ZCHA1i9qvnrsrLaF5iXj7T6RpgM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 310,
    "title": "Inside The Paint 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "00HCbr99kWYvt7O7hlPoXyET01js4qDYwdE02Y32E62Eo4",
    "muxAssetId": "vDEy2RHS1NS9tUpWectrWj01015bSwTmkx99gVRH8G3qY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 311,
    "title": "Interchange 3v3 To Scramble",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "fWipTY6yR0159wig9OgmNFhKnwjbLHHssTk5DSkxhMME",
    "muxAssetId": "mhCBeAXHfaTn8izV005Oyx00xpiGx2StaxLNDMnc2tno4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 312,
    "title": "Kick To Relocate",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:25",
    "muxPlaybackId": "moLBRYgSDGOOijV4krJpmi6K6cqg5hHcca802a202ccOE",
    "muxAssetId": "GUrFh101CuD7DzLNx5sjCUR1GgQwu3hUo16EqwDaWHJE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 313,
    "title": "Large Group Domino Setup",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:48",
    "muxPlaybackId": "p5vGtmWzTjfAF101GQ6QZJTV801gKHPJhNFm00Rh02XqHnA",
    "muxAssetId": "I2R02sKDkwxCZYzJFcrSox9nvM7uZzAwgykJDLNKAN01M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 314,
    "title": "Middle Drive 2v2 With Hook",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:16",
    "muxPlaybackId": "RawPgx5JZcYlECXp3pMhe0152kuyqRIuCoMn02k202xmHs",
    "muxAssetId": "M15WM602gEmfIphjHuc1GC01mzsL2DnDDYdr702wQtMLmU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 315,
    "title": "Off Ball Finishing Drills",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "01sUHSoeKrWVUnXXFeJt774ywh02NH02XsgzHjfRyCDHXg",
    "muxAssetId": "FCX02v9IQ3Q202nMnocIn4XoCINiy02opr21ddQWV0100aKc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 316,
    "title": "Passing Through Pressure",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "00kVvEdp4z5KnEiJTtE01r602ZoIweCntohj29PBWQYicc",
    "muxAssetId": "yZk3XIGuBkSKSZSzvme01dmJmE6qNXYQ2BmMYvvEbK1U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 317,
    "title": "Physicality Off Ball",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "A0101GX3xbcK02jLTUpymw1eU0002Aq00otHdZzRxdilqfess",
    "muxAssetId": "uKvxogMTGc6e01x5CWEbMT9xRQ01B5cdDPnL00yDFlMtxg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 318,
    "title": "Pig 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "htVOdiBKJoa7P01NIAcr84V7Wfx007KDtiFCh008yIkvyk",
    "muxAssetId": "iFpzWkzOkOZYQY5TeQLy4AvTKxTUkfyX55yLameEd00Y",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 319,
    "title": "Pindown 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "gaWan00YVdWZiaVZjl027023wiF4vT3mL9QlxYP6wXyhOg",
    "muxAssetId": "tcBQIZwx00OGzdGpzqKgAzn401ElWnY02F01BxQPNVbtFj8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 320,
    "title": "Pnr 45 Read",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "gAU355uIT9KPRU2402IV2eNvCCXsAGwd00VkWOapmq00b8",
    "muxAssetId": "s8P7WnAmwlDWKGPAMZ5bZw5w3eAmAq02f3cYXQhuEQ1U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 321,
    "title": "Pre Cued Constraint 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:02",
    "muxPlaybackId": "DKcDP13lBoTRgvdJxXP8SWz3Per5OOf2k5ngykqiZn4",
    "muxAssetId": "DOQ6Tjgc02TGNsjOX8UuJqD00Tl1KYgmO6UzyJdoO3lTA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 322,
    "title": "Relaxation Hard Hedge Read",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:03",
    "muxPlaybackId": "a00q7WN8E9zXQCsVnkW3rhHKfbnpfKe02NoVftbAqnhUc",
    "muxAssetId": "EJLbUJT2Y7VKsLIW3Vis5khFpOZdoHLBdq2nK8rmEyQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 323,
    "title": "Relocation 2v1 Copy",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:12",
    "muxPlaybackId": "hdzuAnxlfGHW0102aHJ7Mxy00tc902sgGvvTRmpF02zOToRQ",
    "muxAssetId": "02FGER6CgGXH00UuJqo01e5UCccXruJTaXqSsivRAEywzI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 324,
    "title": "Relocation 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:12",
    "muxPlaybackId": "Tn7oC00PEMOkYA89IlrGcJuR6CSyr00w02oNdhcK2n0200ww",
    "muxAssetId": "U00znVnW02n101UrDijkZcDttupYtCMrfTBY3a5xOgm01wE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 325,
    "title": "Relocation To Play 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "ZZXGiGzXAIm4hTyqXfIalbEUc79zGO22Z02e9IV4T00rw",
    "muxAssetId": "xWWr02d5014fv600kncOMs23YYDodaedGWDtvPR01RA8mHA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 326,
    "title": "Scramble Advantage 4v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:07",
    "muxPlaybackId": "Tb02BNOlNEanR8xxGzA3qRzkLc2YQNMOLHUKP01rVBy7U",
    "muxAssetId": "WWHS6gO701288PjNugw026heNAgOyt4dUXQ6kFf3X7GQE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 327,
    "title": "Seal Drill",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:18",
    "muxPlaybackId": "Q5SGYbXWIzXJ7O8Ej3cLyYYFwMHk29RAbmWRge023Yg4",
    "muxAssetId": "MCt02De2ZnvsUDuNglPsKq01L8OGsFKeQqk2R7hNp4KxM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 328,
    "title": "Short Roll FIBA 4s",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:34",
    "muxPlaybackId": "DOTgZ6F3wTefkC6YZSWebe34c4k02OMAPYIuY02DtS0001o",
    "muxAssetId": "LdoTdBt00D401xLfGjSjl01PT02pyQrDS5wXAuBrDggTn02U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 329,
    "title": "Split 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:01",
    "muxPlaybackId": "zB00MBshiiQdlmB8bCVxBotgiPr6GuOIiE6scPnP1UdY",
    "muxAssetId": "YRSay3XSV5AZuMDRKVrZfnvehLSojVjuyqrRh01DsIFI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 330,
    "title": "Stacking Triggers",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "3:10",
    "muxPlaybackId": "mkAyHLqDjvq5jorJUu02GpztNuaJsGCGBkOn44NMk7fQ",
    "muxAssetId": "y4EGsEDLRI2USR41HZxb2O4kq5eNVb6mkEf1Pd01Z8s00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 331,
    "title": "Staple 2v2 Attacking Progression",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "M02q4lqkodVGGLROBhEXlg24JXw74bdR9AtUdJAERpw00",
    "muxAssetId": "z2OWRE01oczo85orS6ltE4Nhiqov1P8PbfRnV6O475rU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 332,
    "title": "Taps W Defender",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:01",
    "muxPlaybackId": "2cJiboe5G02kysjZsYxvKGGhl6iMsfGx02h00pHt2Tghwg",
    "muxAssetId": "zLxVUjlNmumUOuxxQVb4SWn4eK8EtYLjH9wZAYkz401c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 333,
    "title": "To Half Court No Dribbles With Trap",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:46",
    "muxPlaybackId": "noHoT1X9Skc5WhHFkBvmVuXSFwfVedcLpxePNHihzPM",
    "muxAssetId": "02a4ydeZY00r00nk012uCV00K6EWaO9PfRqlDYfN4qTlpFpI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 334,
    "title": "Toss Back 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "IVldljx3vAZrAJ02bZMpN5nTefCjHSnrkDt1veKiAiVI",
    "muxAssetId": "lbMCYQ02ir2hao8pmjxQvn02YN500DWsDXNkVJKXcAlUtY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 335,
    "title": "Transition 2v2 Face Cut",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "HIN2UTeOn5j02bz01TGyQh9kkIdnO2NbCj23Dx8Qly2NM",
    "muxAssetId": "S854uQ2w00uR4aONwdg2RTyD4viSA5Bb3oLhWtGMRRPY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 336,
    "title": "Transition Runway Tag",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:50",
    "muxPlaybackId": "KxUmB7mNIaeFFz8AV0000B6r8j9SBHAdq01gXXSlpgp3Qs",
    "muxAssetId": "cX402vQGWqtIoQm9QgT8LEpmge02q7Plhg1cHRUBH8I00Q",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 337,
    "title": "Trap No Dribble To Score",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "yR3V95M8rA3xgEBDG64BUnG02ClG13GyrM1TFd7mdnRw",
    "muxAssetId": "S00BXSiijOPClfXl6WjaKTrrxepvR34ECDAr2SVM7ULs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 338,
    "title": "Trap Start Full Court",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "T2emrXRJXWaWGg8Je931R1501tZLwtFfyXjq9YFkW4zE",
    "muxAssetId": "W9nRciQeR9HmurEr4n8TaepjQVfeRgSHyH94d01ANLE8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 339,
    "title": "Turn To Scramble 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "oB01Msd027yHbGv8ajHNeNsxXwFDess76FcXkg8g8VyLQ",
    "muxAssetId": "uVvnCnlkOyI4Oryk1dLkfS6Cfaisg1MSsMkZdOjf5iY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 340,
    "title": "Weakside Distraction 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:52",
    "muxPlaybackId": "w9ccK01NHVsbRoRPf5SIB4T7U5AHRtRUlFJg6f4KwyyA",
    "muxAssetId": "Wd7vzQqgqERDIjQ757LILKTdjRCc6dd53Pz16AEWUdU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 341,
    "title": "Wing Pass Back To 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:42",
    "muxPlaybackId": "hDhyqC02q6CpVE3bYDV6ql94UeFHUQ5WC7DM1GEII4Yo",
    "muxAssetId": "hoZ00vEW3HCQjmeo2tAPwWmaDgB9289D59FW1zZDEyMk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 342,
    "title": "Zoom Advantage Focused 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:28",
    "muxPlaybackId": "WV00qEzMqntTzB9r018UFzartmjuyz1C00g60087D6CeKkU",
    "muxAssetId": "zpRsbUEbEZNcZTYnURTtlkSQ2RVybbqXiauQ8GZBgxw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 343,
    "title": "1 Hand Change Of Speed",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:35",
    "muxPlaybackId": "EvLHzlNIpzediHZjRXJcn4Kk007opnO00Hv1Hd6iO7vD4",
    "muxAssetId": "fTEV3w4HsQYuoYZ1shzFowXoo3I8SrvUEeMaEZ02400zw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 344,
    "title": "2 Ball Dexterity Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:22",
    "muxPlaybackId": "eUtjQuU006Q00KC023T6rSfrhf0001bB702SVqZpqajWtRX02g",
    "muxAssetId": "SJ01roHWo01qeglw2fX16BJ02zRe6rlRzey1d5AUkWxVrY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 345,
    "title": "3 Coordination Patterns",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "khAmn02c9wCBz29dLDF01B2KcCJHKUoQJ2op02GKmePciU",
    "muxAssetId": "tgT0000FdEnG2l302fWc9f01CQjYuLOBRhGCcw7w7qdeL6A",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 346,
    "title": "Advanced Float Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:25",
    "muxPlaybackId": "CNnO00gL00v7YIxJkNKDLGFqlqXH7MU400bRrfIJ02G701wY",
    "muxAssetId": "uzQz871fXyOcVe42zGFYZq5mPDon3nlutoI5W1004lSY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 347,
    "title": "Awkward Start Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:37",
    "muxPlaybackId": "LRSdjEf57rtUZwV8ZiNXY6aYVd57nvLmA5tGSjXdmPg",
    "muxAssetId": "Rs65Ls1ssD9mt7sGs1pVzL0102LFEqWxHUWTvUC6aKhOk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 348,
    "title": "Back Thru Legs Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "1Wz52RPtVcDR02a36rY0027vTAMqzUWahInIIw3MHrdoI",
    "muxAssetId": "rBFeChSDdFkdimqSaomjc9egryHWH6lR3KSQCKWJwvQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 349,
    "title": "Backwards To Accel Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:25",
    "muxPlaybackId": "fiVjwUJSrELzPhzWDdNi01TK8h01Z3bHfpFd89MWanYEc",
    "muxAssetId": "no5MJvnJ8n4Kb8UrwG7I1PVemWmwd01602Hf01bmoMeVv4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 350,
    "title": "Ball Control & Dexterity Warmup",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:44",
    "muxPlaybackId": "RsxbxXIhBeIkeIzWxCkilkuXdX01E4jjvYqSpdB02XkSk",
    "muxAssetId": "NOAE2u02aSvm2tMcCXJ5ELgk2KmQErIfiQpw02u1Tvyu00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 351,
    "title": "Big Man Balhandling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "3:34",
    "muxPlaybackId": "iBi018HzRMCY02aGQ2rMCDIhn9CkGKTb2fgQLCnUP3COI",
    "muxAssetId": "ps5jM1WxxJeRT9KVMgZTUAlb1E02A9ziPV2euS9MJ6Rg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 352,
    "title": "Cuff Mirror Control",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "ghzmOrg5vDr5rZEmdytDDINbkQdY5fRPcfunG01tN02wU",
    "muxAssetId": "ew6XKnKkNpVb8qxfbtF01gDVR3mHzDnrQzwsENdVkdL4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 353,
    "title": "Eyes Closed Freestyle Copy",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:48",
    "muxPlaybackId": "SkSFnWl1rLJsi3qqz33xTn2Bd6y2wyKcG7fPebeWUQE",
    "muxAssetId": "FAWrhXHMgc4iCjUJuMCEOs02ydBiEmdVGL8BQWY6euqI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 354,
    "title": "Eyes Closed Freestyle",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:55",
    "muxPlaybackId": "4QehyoRzEOVvP1TRDJE4PoCst6vYwcu4EwrT5sRjD01s",
    "muxAssetId": "CibbCLxNvejvthZFwTd86QDrZNm7vRkeI00924btEEqo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 355,
    "title": "Float To Audio Cued Back",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "fVSrt700eTqrM009JDtOdh7DmGdm161BSdHwZPflnVDfE",
    "muxAssetId": "BzmyTD9ABKsAqignKitdehSsnA4Bhu8W01Y5JMsxRIJc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 356,
    "title": "Fluid Rhythm Handling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:58",
    "muxPlaybackId": "6Tzmg1d8J4MALgmhHfxHCjHGA94bou2Wmu6hRMjIB28",
    "muxAssetId": "ItOpCjY4XUbNSOONuHb7xREjlL14Z95A008ndgEIW01Co",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 357,
    "title": "Fluidity Ballhandling Workout",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "6:32",
    "muxPlaybackId": "01Jkw02Kv3aUEaWfG02jQ01QQzl5qPKC6QJaB8tq01WvFjUE",
    "muxAssetId": "ScwLVY00K4VnHv01gIWdDSIKVi028SzmuPQH8CXC01Rh00i8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 358,
    "title": "Forward SL Freestyle",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:36",
    "muxPlaybackId": "zZiBUAIh2989qnxm8pbihILeLV00aQafy01ZxuIev66oY",
    "muxAssetId": "XDqEo01cP6BoahNwO9qfWhMhZeWTnrtJbiWZiwaxdMRo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 359,
    "title": "Forward And Back Wrap",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:48",
    "muxPlaybackId": "DHPlp1rV7q00vx9j029p7LlQpl2MozBD01TWwAAmPNIDDA",
    "muxAssetId": "7zP01LJwsR021CwMWZQwa2g7fRjtQPXTU00csg7bSIs005g",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 360,
    "title": "Gallop Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:56",
    "muxPlaybackId": "V9IuTP01PNeoPTuT9N5hNmo7UWFELL9EB6bf5OGCodBs",
    "muxAssetId": "K00v8Q4j200oZLKVny4xHcWobwgb6sED36FfXxmqtcQKA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 361,
    "title": "Ground Spin To Snatch",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:56",
    "muxPlaybackId": "901AngrLmszx51qE027Ph3bPjB1NktO0100js82VmpTa7ds",
    "muxAssetId": "aH7YGSz400GArIBvLCg7Gzfxw6G4IQJajiLgWbFAEORI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 362,
    "title": "High Tap Double Move",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "RKtUtpuy8qYy01ewOwKqFJDl6GmdJ29S3SNsOjLAr6UQ",
    "muxAssetId": "dOrznpjVLn02s02GJmUbiK3ypzMNuzuvHut3HEhgeDctE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 363,
    "title": "In Season Ball Control Warmup",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "02b00aghqZL02DMLKjOgtJp8v3M82yO02fiSB6RsYKjWSTI",
    "muxAssetId": "rR02xb00YUAfS00V014YaXX8XRQQN00wxQezJp8n9KVpUeu00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 364,
    "title": "Inside Outside Continuous",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:34",
    "muxPlaybackId": "1bKcYui6PCLjiBlf1sw7JFPVYZtmobgggEbu6DWn67o",
    "muxAssetId": "ZiSmQ01IbMHNOlap5Kz5eiG9ES2uUcGV00NBOhS5xtl2Y",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 365,
    "title": "Lateral Rotational Decel",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:10",
    "muxPlaybackId": "91tjsoO58A1jD5k58WahwVhwkXzT36NMCnMJ7F8KSWs",
    "muxAssetId": "quLJHMiFAzr71UFxv01Ooz2KPvZ9EtM5vujETsvXdkBg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 366,
    "title": "Low Positional Handle",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:48",
    "muxPlaybackId": "kUpmYVQ9cw2ZvZTmc02FV6JP006aN02AI3jPlbXsapg24Q",
    "muxAssetId": "CVyYp02Bqvw2w48eW02X8zIXmOS9F4gNUcPLR7eP01JGk00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 367,
    "title": "Observational Learning",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:59",
    "muxPlaybackId": "MLHdDGvrKf41jhaTqadBzkoEYIWBK3pzlQ8DYtJcNp8",
    "muxAssetId": "NcVxvHpbOJdc01OMW95cSBy1Qbg7jAkiVXX402qJ4df9M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 368,
    "title": "Push Out Behinds",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:50",
    "muxPlaybackId": "4OA00BUBwj016PMtIfrA8xyHJnacSY2tV7XDvVpff00QUY",
    "muxAssetId": "FeFpym00mvq6u2Pe00hhg3IJQAkwHwwXfPDpceQaBp81w",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 369,
    "title": "Rhythm Combo Partner Handling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "00VidLzWofwyn4b1z902011TSOMDEXvV02NwPXOQK9HppxE",
    "muxAssetId": "TRDPrjfv5zvpOk9701rXt4jc2BoPk4xjdd6FQjPYTmg8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 370,
    "title": "SL Pogo Freestyle",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "tYMk8BqxsqfSahYiYkkZleaWg5heseam8Zakit00ETzM",
    "muxAssetId": "D0227at6y1Rh2q6bQh77oJKcFIyjraYzxddKA9tDH0200s",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 371,
    "title": "Single Arm Between Skips",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:42",
    "muxPlaybackId": "x81Hv003d5i3j01fCRlYlVIoDWyuDReXFPwOyQeoio021s",
    "muxAssetId": "YwWSRFstuT7AhYFxNauCxjbw6Ry6WuohoIxzZ611eQ8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 372,
    "title": "Skip To Explosions",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:48",
    "muxPlaybackId": "bf6MU26rnVI6IuTN5sjF8X7tWOMGYYPDS1yEYaoY4yA",
    "muxAssetId": "c1i402024x5QtIoYugd00EcFZb0100DwmSfDWUOAMSyTwraE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 373,
    "title": "Timing Ballhandling Drills",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "z00344TXk01or4aCv1ZvtF2902VlJMYaIHOtryso02d4T5E",
    "muxAssetId": "wPPMtpifqocPnC2K019Kq35hPd11KGvSU5MvPchETyG8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 374,
    "title": "Variable Timing Drop To Combo",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "SW48V3MFgb8Ox0085m2knzuyEPES60001oPAxH6znUuP8Q",
    "muxAssetId": "kUAqZ6BkrfhOLRkCGz02g8tMCq02EqpPJ8LYvUi92aNpY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 375,
    "title": "1 Hand Wrap To Across Extension",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "FFjFpW701zEQN1rpQrAAzdElrPjQY2nCAko7e1J02SNu00",
    "muxAssetId": "jGFu3aCwyZoA4jukVwnTM02U9J9dqXgruzNtPEw9ZxF8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 376,
    "title": "180 Static Flip Layups",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:12",
    "muxPlaybackId": "C8d76Mz9i2cRQHTAX9Gbwmu2ZnGpfFWvoSnbXFNDEN8",
    "muxAssetId": "G8CsE01VyYxp00BXPZjToBXRRrVxNyUsbVOnf1WpTS02V00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 377,
    "title": "2 Foot Extension Reps",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "O00JuDBu5X02jpjq4MS00GAI7hKB3vT949PQAlvkRpL82k",
    "muxAssetId": "1IA55fghCehlBM7azBqkRjM01U26EoMiF02j7jF2qNAHY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 378,
    "title": "2v1 Floater Reps",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:33",
    "muxPlaybackId": "Mk8QYZnnBbqL8DMM5eIaxiRafGBuMFB2sdGUibTZP7s",
    "muxAssetId": "UHKFhl7h01Oi2vAEOpCzX00100I1Xs7kP2TII9jde8ChVY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 379,
    "title": "360 Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:47",
    "muxPlaybackId": "DRskUW9ktlLR00oxkae01zW00NjRf8X2lqqzjV00iiVWc9w",
    "muxAssetId": "EcVhkfCcuqLTv01zPFYX1616j900lvSGqNxepecUi00H4M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 380,
    "title": "90 Jumps To Other Side",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "hheQhxUNddGjA2mT6kCcU8qSnjpadGcFY01SrZRKAZeE",
    "muxAssetId": "NiAy7AGBbZHS1B2NhRb5CLsVtS5ovwozmvk4CsopbHU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 381,
    "title": "Above The Backboard",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "vnBydkQ68dW4w9xi7utaRWpZS00i01DKfOKWQjNFrpZXM",
    "muxAssetId": "Kn7zFPSWB01P4ZgSZkiw32SV99TMHRKFiilV6hfNWZFk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 382,
    "title": "Audio Cue Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "HbYUcwh0225LHS02XcdlLsDIGyuAb2r9KvtCTQVkff00Io",
    "muxAssetId": "41nWjYX18OoPJldJ00Rfk02ljgP4kl8vwGKplmp00TiicQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 383,
    "title": "Ball Touch Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "LUr2fg01Gs01rFaOW8DkLnOIrGJRw6ynw6Yj65JL9fNWo",
    "muxAssetId": "pZwDZfFJpzkykoTdSc4jt1ToajFyY8XXKLbx5XoxFow",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 384,
    "title": "Ball Touch  Touch Shots",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:59",
    "muxPlaybackId": "r8ZZHByMAVd1uOZUs8i9602MQow3xZh1tYrKZEIYTPr00",
    "muxAssetId": "Drinf8z01liQP2fQRSR2GxzoaxgyoPtC3LeHPVQEYpuM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 385,
    "title": "Baseline Jump Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:35",
    "muxPlaybackId": "0202TZuj6KBrdgEioUigC78knDPLQ5t6fWOXRwXkKNBdA",
    "muxAssetId": "fsaHX1dgvqML3V8AW4HBDWKtbUdLvHwV9uYJLPDSHMQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 386,
    "title": "Body Touch Layups",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:09",
    "muxPlaybackId": "YxdlJK6eulRzDLF9K7h00puHwMPy7Es1JOn2Dmh5CUSc",
    "muxAssetId": "gvp00dxiWGcAqLUrfvR2N3mHKDY3EH3nGryr01ATfgacI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 387,
    "title": "Cross Lane Jump Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "sqfNyoVHnIVOC02D02un8CFzVooo3WjL2ifSAlDyYq8wY",
    "muxAssetId": "cCs2LT00DBWchZhtMrdGALJE4Qc372weDxxbxKB02pgMs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 388,
    "title": "Distance Jumps",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:14",
    "muxPlaybackId": "3qARajOsRUZz1wKz01afS6KZinQsEg02x00WpJwwTdNjhg",
    "muxAssetId": "LEuXfzfkV2pZXLArxPrLdfT6Wni9pv4z4PHm7VAk3wY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 389,
    "title": "Double Move To First Step Lay",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "ZlouQRV56HzFStzhtbdOLUKWZRKax02EtgXba0101f00RZo",
    "muxAssetId": "AuTEVIiw6EMy5aCYzMtaMJgKhZdEXouPp8EOTmOnSxE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 390,
    "title": "Fading 2 Foot Extensions",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:41",
    "muxPlaybackId": "00HdJQ4tuQBFTjTcCuyizsF006Hg4edZABW8tvhJieJJQ",
    "muxAssetId": "5sZ01ECSPpNpspfuhcZBudIED5DtdcxdzK02svv6u4JY00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 391,
    "title": "Lane Line Low Intensity Finishing Wamrup",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:17",
    "muxPlaybackId": "Xhgk00JGwpPvQxWOR9uDYch4sVUR005ufytJHbgrrCR8I",
    "muxAssetId": "00udTiCqwgInlHKgMWhQbyLuk48q1pa02BCG02qRBUtO6M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 392,
    "title": "Lean Back Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:33",
    "muxPlaybackId": "6cKdFKTbU9O6XSkXUd6MADT3xZq8Jgrj7cuKf00K9lYM",
    "muxAssetId": "QteVBQdWjl32VEkTigWCs6vQGuuPH27UnZh6802jRfnw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 393,
    "title": "No Jump Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "9JCgVFHdlWKd9fxP01etJ028vYnjI02W2dl8RamahXnuVo",
    "muxAssetId": "PQNNeslM02X902axmEXqw015TuoK014rv8HPEvp9PjDSCbE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 394,
    "title": "On Air Finishing Constraints",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "5gG8j2JDUWiZ2ZuKmiKAQFCJrh6ssCyZDjjw7cxIi500",
    "muxAssetId": "BSi1DbnxIEC8qEhHtEHVqk02OM02122dTigeq0101ItTmYI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 395,
    "title": "Out Of Bounds Jump Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "NZ1pJ1k8y400lUDUxqLa1xS9w01ovS02sN5yndOE9kzNzw",
    "muxAssetId": "pkp5QA23qffRQT98wqNcCrabbX81rts4v373BqtXruk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 396,
    "title": "Reach English Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "bp9whZfq7NUuYrjKJ57XGchYgCSzwQMKQdkg2CLJeaE",
    "muxAssetId": "MYUqgHNVpkJq5U502v2dbmWsw2OBOHxppZYquczNS02Qk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 397,
    "title": "Super Mikan",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:39",
    "muxPlaybackId": "ofmsGG4Yjm4GjFjAu6VDLKWnPU1ET3l7RJiGAixNfmo",
    "muxAssetId": "VwwSDtwFJy3RRNLL5ETZSrsKTNfxPzQXNExR7lgD6gI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 398,
    "title": "Top Corner Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "L17hY7Gw00400HJo100e00p5uV7zyHSGtCiWVQOS4t02MC4M",
    "muxAssetId": "Vc98l01Goi01Ipx01XDiHPca1BMQyglTBWDbZG01ftFyw3k",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 399,
    "title": "Toss To Other Side Finish",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "9Z6B02WJAjkgpNfaT3fSQsh00pnQOE64GGsg9A63gAIy4",
    "muxAssetId": "Drc7vEnS2CR94zmtze7RFNquipLeBoWWu2bT5uJEGg8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 400,
    "title": "Weak Hand Drills And Approach",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:56",
    "muxPlaybackId": "01hLp5z00Zs3RZxxO9ZAkLJdIzFshpUh9J9FYUTFheQxA",
    "muxAssetId": "kZJFbF50040100BsC5SEX9VWkuKU38h4023Zx1grYofLSlQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 401,
    "title": "Weak Hand Fnishing Series",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "016kJUBfXGJCu4lbls5DUrt3006KLyN4OLReDS3BRam3Y",
    "muxAssetId": "vnXnViT7PWoW8U4GQ6HFPydTfer01h9QIephqgaQcs5w",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 402,
    "title": "2v2 Around Two Passing Warmup",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:05",
    "muxPlaybackId": "MK02lMY7eug4Yl00ZatccagqgQkr29u28Lv7WCWLfB502w",
    "muxAssetId": "K6lrX1RJRCOCpLexjxPe7vcqJSUkl3DG5hQQG7okQVE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 429,
    "title": "3 Move Flow To Corner 3",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:39",
    "muxPlaybackId": "t79ZY3DbuNcLUchXvmA7a6Q2801UFPGZhl02PMzc7ZXHQ",
    "muxAssetId": "yl685XWChqYmTEKmknLQqKckkSY1QjgibQ9v5Y7015hE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 430,
    "title": "Audio Cued Curvilinear 3s",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:40",
    "muxPlaybackId": "oJmtPe5QCysQJd5EHhbsFr4fGMulM00tsNfDcPlGn8wI",
    "muxAssetId": "4023cvwtt2brJ1caRhSRY02St902CEJ89gHg00ysNng1wnA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 431,
    "title": "Audio Cued Fade Over Hurdle",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "AMFbc5o00UGUbmukrCYhLLh018FcWVYwSQbATZCbB02oPs",
    "muxAssetId": "nsnVhnFHBmFKo01pSd8wcrbea7GQjn0025O7NS7JW1IoA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 432,
    "title": "Back Pedal Into Reactive Shot",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "gmRsbzBaFc026wTRI3y0276cSYjgsWenVo2kux00pwCBeA",
    "muxAssetId": "mnAsCHvY200yvrh4NHcQU7TwlekAJSfwgcUGfwv97vYU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 433,
    "title": "Backpedal To Rhythm Creation 3s",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:01",
    "muxPlaybackId": "8yePQqUH7wvShc01qfhZ1nvuBIJ2fl5mzKlVskh9Nx4w",
    "muxAssetId": "MU7fm3kgtXA01QroyQs5CGF7KkwnNqSNfpFXOVQ00sQi4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 434,
    "title": "Ball Wrap Variable Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "fwLYhcR8reakg9y5bFWySXzSxbRK5l6IvSaJJfF02kvE",
    "muxAssetId": "rrRX7Lj020201JWnWYVssknIFcoJLWYeYgUs4yTfioBtt00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 435,
    "title": "Bounce Jump Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "Ihr1O849wMZK6HMKxpyqic4BKvI4zCVwR7WUGQS9Hxk",
    "muxAssetId": "yrkEC02hdLGGmI9XPf6ag4SYR9gp2dTt00w5Ur5N8fnNM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 436,
    "title": "Bounce Retreat Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:13",
    "muxPlaybackId": "yDrJtO00qi22BUi4kWvDvGi4LSjnT4v7D1AyjspgGw4s",
    "muxAssetId": "QQKPx01XuWL1C00zZjBGCpTmkrsv5I7ATh6JisWWZY7t4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 437,
    "title": "Chaos Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:18",
    "muxPlaybackId": "Si6qSWviRBQNIKF0059e4K6J01GRARclwyA3Z02hada6Ls",
    "muxAssetId": "jJdp02WzsC6Q200rm4R9t5Adtu01sdLwf8kHucmqz00uUj4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 438,
    "title": "Drop Behind Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "OCidDeViU4MRxs99ZPQbFNY2dVodr5eXVg2G011jPZ5c",
    "muxAssetId": "kKTI01XXKlsdVszk9sF7cspLa0001tlC46ZwJA7DHN7fzw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 439,
    "title": "Elevate No Jump Alternating",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:40",
    "muxPlaybackId": "sonQI01VDy6HjDCS91WOethFii5gtTMPXTbF41arpeO8",
    "muxAssetId": "9I3g8DAPjt02OzfZCym8S02fDuEteNJcr8l014XU3hxMpQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 440,
    "title": "Feet Crossed Push Balance Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:13",
    "muxPlaybackId": "di6K01geK3S8XNnlwgbSUPcA7iiFvE5EbfuEbMZoLDCw",
    "muxAssetId": "HFfgK00300xC3mmVGkbzIm00QqoUmoeYl6NzeElaP7dlrA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 441,
    "title": "Follow The Leader Separation Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "mnncRMeuq3UZVWkqDRusgZ5cwxdrMs5qeTUytR8wHq4",
    "muxAssetId": "jwA9jF021gTb7hShfC6n9vnkDOjiAR00tP9ODHyEoUVWw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 442,
    "title": "High Release Calibration",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "2:09",
    "muxPlaybackId": "8QGwv1R2D1ge02Y5cZbaDPk00M1u9rlTBYh4e5XIyrmmg",
    "muxAssetId": "rlUt01wL4IB2NOeBCktc3uY01gxVlvI02CrVMnHvXipX2k",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 443,
    "title": "Hop 360 Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:13",
    "muxPlaybackId": "8LOX02yIgkcNEc00d5XqT00OlAOmMgMcyVlwD027OyERZUI",
    "muxAssetId": "dNx1p2ETGAWSVYgtMx3HcwciF301VWBjRQjWiEX00Ea2Q",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 444,
    "title": "Intro To DL Shooting Warmup",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "4:32",
    "muxPlaybackId": "duv6NAwUYxg13Z901DJ4M7iRab1eKk4Azg5BoSTMQtVY",
    "muxAssetId": "Oaw1ivSX00XtXrip3aYHVomssSz9q78b5niY00027VCfNs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 445,
    "title": "Manipulation Flow Series",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:39",
    "muxPlaybackId": "nXD9bQoItzk8wYKWkCyd01NY7ht9rgojcT8Q02TqJQYsQ",
    "muxAssetId": "A2bbKWDDt027E02sOiMF022gexgHiRrEdDOEHhqY6DK8K4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 446,
    "title": "270 Pivot Jumpers",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "nonJ00JM01301tagHseehUaD00fhjDfY6gaWM6lsM94U71A",
    "muxAssetId": "CVgTHnGI9y6hE7e3gXlQNpC9wO64H5OCzQRbskp57G8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 447,
    "title": "4D Leaning Balance Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "Vr02v1FXWMW500N01n00keYhfMmJ01EiTJfWMNHo3qPGjgD4",
    "muxAssetId": "9DRirBVw009zd01OAtwnzsfULObmvTYqN4ri17kisXF2c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 448,
    "title": "90 Degree Turn Touch Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "VG01jf8wJTEOTQOIQ2fWvMIROvIj701hQJ3ViKLLWv901c",
    "muxAssetId": "sO7P1BSwWVwjyduPeUJkB9EU6sFoYp7A6pNukAb014jQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 449,
    "title": "Exeggerated Low Jumpers",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "qrp51XMCBtl4WANMVrVwfrQcSy01IuWG3tdBPE1hkl02E",
    "muxAssetId": "aumH5apy02XvZK7mN8ihLpSeNRjrFBRjHNXHqA3hEzvI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 450,
    "title": "Float Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:14",
    "muxPlaybackId": "KFCuuObgvdnr00mRWf9G3amEbba36Iw0126TjxxAgvhMc",
    "muxAssetId": "7Kns8d02nT01y2WHO00Fzu025jpHNiEbwkz02YVefOAb5ktA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 451,
    "title": "Foot Cross Hip Control Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "olbluizv02d77q85sHifjiqJvx700v2aDFGghzuAuLC7Q",
    "muxAssetId": "dNSL9jAg7L4T5V00K900oaIO6rcFUCXuwxb00ELZrCp004Y",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 452,
    "title": "Max Elevation Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "5D01sEwMYGkDcva6ziSG7LT3YvfiXRwN9GAQpTYILzBg",
    "muxAssetId": "yuI01ikdr01jlrFcYvmD00SQO9702EFe5juD1kDHQtXRjkk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 453,
    "title": "Over The Backboard Touch Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:15",
    "muxPlaybackId": "02YPgo9kCn2gWmUkZW8ZmmB9qhIWAwII3pX01jzQSRS400",
    "muxAssetId": "200B00aY8VkyE8K4OFglsV02w01Qd02eSjECXsWMsLY5AfSE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 454,
    "title": "Pound Rhythm Jumpers",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "ymMC88PwwQOsC4KvdhVF9lCyHxIZZ00e0278WI4PV9SSE",
    "muxAssetId": "JcBoKKWUZ6TL402UW6CUpFUfZJ86O00lW1Oc7H3VOA2Jw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 455,
    "title": "Quick Draw Skip Flips",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:11",
    "muxPlaybackId": "gz9IsUnfr00oPcltrA00VO7VHL1ed8F3smMh00TLucLpKc",
    "muxAssetId": "lZARQkJEHkrE01ZVhyT3FM5MIPD9GgYALYd02z01702L02Pg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 456,
    "title": "Reach And Center Outside Frame",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "gZgDWXiTryE02Nw4E39owhjf2BbUxPPX01VDlL01LRaBKw",
    "muxAssetId": "Ye005u02FiTPTvUZTfm6QJ7o5RRKvjwces4oyxHhJ1miQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 457,
    "title": "Transition Toss Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:12",
    "muxPlaybackId": "a8t2K1yiXc1TV01YVDL5IQy9JmkJQt3YhhToQDsJTiVQ",
    "muxAssetId": "cGypnGCR7PXmqwSvmiA4jmuuYafbWwilnyQzz1dM95I",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 458,
    "title": "Two Step Outside Inside Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "aGF011lL4AQwJvQvQczH2ehfTw801NGScOxqAlwVssh4g",
    "muxAssetId": "6DBVxlTIWeyPGc4PD3DquSSmXnWfkcHNENWh3mKENh4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 459,
    "title": "Under The Legs Retreat Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "KIBmYUdf6wuamz6qMuxK9VCZt3UTZJYfZQd4tTcahVY",
    "muxAssetId": "aQSykKd01xWeoHHntU6huyhYd186pet92Iw00013Gz900lI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 460,
    "title": "Peripheral Catch Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:59",
    "muxPlaybackId": "DwxY0200NJvFVTFe9I6ZchsdpLdzUSNYquy01h6A026LUgE",
    "muxAssetId": "cGqwq5ZFGWDVqBqBfks5RM2vurAF3dkDcDGMD02nkdSQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 461,
    "title": "Random Wall Toss Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "cxrOmZTC00Gw1PsUeNa5bzD5h3b28FwirFqw3MXkacA00",
    "muxAssetId": "02xfeJkz01Y02cl1t9gY415C023mQl2z2brd2SfXCu2uWbs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 462,
    "title": "Sensory Chaos",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:06",
    "muxPlaybackId": "802TkhQesRUad00DPyY2qiFOA8wNmzFhHkbDFIAwJU5aQ",
    "muxAssetId": "EFe01gHh3TUQvHrI00AK7Ym5GQXQbGB00wKYAq7cn23OcE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 463,
    "title": "Shooting Footwork Rhythm",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:29",
    "muxPlaybackId": "IEpRXxhrJGfiqs02WmFKutARxLOsqdBUBrVFUFgp5DaE",
    "muxAssetId": "jK6knOVooi01f5gKNDg02aqr27aMSfN5w01ONEAjrD43hI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 464,
    "title": "Spin Shots With Wrap",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "BpI00xPCWbjHt7Q42i2tbho02iZzfY2xyPByskoV02YxN4",
    "muxAssetId": "ftmtmoO6qYlL5M6Tg6XlqphGcrvgA9IOPeLRerOIA9c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 465,
    "title": "Two Ball Quick Trigger Series",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "4:39",
    "muxPlaybackId": "hE02vj60001Q0121KuEmTFbZFnxPEvnbh6aK6LJDpW9bZS8",
    "muxAssetId": "uOVNuiQjXaVvIm6O3lp4cGdGGrhjp84Vnzi601MoBy6k",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 466,
    "title": "Vestibular System Shooting Drills",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "vTrBObF4Lmou5IhuzEYc1AEFaPZaN6cQc7wG02NNsf8Y",
    "muxAssetId": "rJHjLBeg3eiN33UQ01iXo99O202P801jPGbI6J4zmkkLQk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 467,
    "title": "One Hand Catch 2 Dribble Attack",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:55",
    "muxPlaybackId": "VXDx9Tu3og4G1Oa5Cz5218RorsdaSJGt6hwEmGSmWbw",
    "muxAssetId": "Stkwh5x4WEY1GysbfyWWPZQjJFe01vylTnjIV19F4i01Q",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 468,
    "title": "Pivot Knockout Handling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "JLtRx44A4TqT5iZSjmXSCUmIN00qKqYSxw6d1FzNFrL00",
    "muxAssetId": "ESQAjajk7HTuYCQbq3c9lNnpJFS4tUhSfyXpl1P02CT4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 469,
    "title": "Turn And Race Ballhandling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "PeYls3xns021CvJlX3x1dKW9EYw6RlNWdoshuiAimcyc",
    "muxAssetId": "d3YJwGy9tlRr019o1WfvtuRoCOFl7YlqsJxN3nAE0013s",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 470,
    "title": "Chase Down Floaters",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "5RP702jIdoulOkEgaXPcfzRN102ZrJYGhVv6pzSs5yhlo",
    "muxAssetId": "VWwM5k2CoivFNFi6wFQ1jFtbO8yglpxQCYa49VhyMdM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 471,
    "title": "Eyes Closed Pivot Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "ahP02LyTztOzb9z01G5inQh2lJquoLA1ziBzkuK3fKbII",
    "muxAssetId": "hsYNVTRPm5FN001opbIk6iJj1VW78CxObwtnfTpHrQbQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 472,
    "title": "Football Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:36",
    "muxPlaybackId": "01hR97LUtK702pM8FjCPoLRqk7tubLcL9jzUHgbsn46aI",
    "muxAssetId": "H8KigWSzO2VL01vLFUH02DcDt1m00DqcHeTiY7NHrl00Fko",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 473,
    "title": "Hands On Hips Floater Drill",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "Qrxtj2b729S8PA61YNa8jUDwzAUj2a3i5xME101nudSo",
    "muxAssetId": "CAkmD8g005ZxJnujKhBv5vLP26KnYHyzeo4y6ilUSNFs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 474,
    "title": "Last Step Finishing Into Help",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "xzBx201ryXq5nBFT8xsmQ008XpDud00NUcXyQDPaZ7tY01g",
    "muxAssetId": "yY7D6bMp7DUYDXMC9200nmxy12JR9we46E8itDnzwfDM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 475,
    "title": "Offset 1v1 Angle Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:15",
    "muxPlaybackId": "bBzXCStFdXri3ed7hdCj2aWUYJj7AnoshcYc7Id5Mn00",
    "muxAssetId": "3Wm401B3D01ZLmlyvF71US5h6idFLaPR00302BWoZug2wmI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 476,
    "title": "Quick Flip 1v1 Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:45",
    "muxPlaybackId": "B4sBJ4irgq00Bf8rEPhqZB4FrFQaJgVToCkFf8BI100dw",
    "muxAssetId": "sDkyrubopvudJlTe6oh01VIwCvKRi4msIKWsvgKVYVTs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 477,
    "title": "Race To Rim Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "sKs7EyKzPoKxd028NoA8VT01gT4soK2473B019TlMYqcAI",
    "muxAssetId": "k00lm002eKKJLzKuR024DJkUbMHqOPJAs00oRw00ju300jrZ8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 478,
    "title": "Advanced Quick Trigger Pickup",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:10",
    "muxPlaybackId": "5IbfIuG4c802ms95E028eXryLeEPMvdTIUtEBBWOKXM008",
    "muxAssetId": "Kmub1iO4009qHETE00BxZpyz9up7FteTDV8o5sipPOzPY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 479,
    "title": "Advantage Across Lane Jumper Or Kick",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:50",
    "muxPlaybackId": "IcOgmeD8up02Adq76Nez95Re9JtexjNROb7oyqhawq3Q",
    "muxAssetId": "Zuy8lYhMKBp8bh4GunlKH6TkMohqbNVyJYyFb8nJZj8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 480,
    "title": "Ball Circle Contested Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "mycbyXyMiDPirqGqHp2LOIASW19zGM3qvON1AnJJl2I",
    "muxAssetId": "vdWxCQyU6C8eLKa3vFDr2KnoqPmxdjA000001X1RJBCpGQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 481,
    "title": "Chasedown Contested 3s",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "FrGUKpJrdTwHHvDQLE029FtD00EpCuFu02R9lUxzdN1rFQ",
    "muxAssetId": "7ZgDi264jbOlxB3aTo3WKrjnNbWhQUl4XwogTmiYPMM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 482,
    "title": "Controlling Space On Pull Ups",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:55",
    "muxPlaybackId": "XcxqQVIqb01l35qeHsr2WDdynrx34IpXGU1kX01JxKU01c",
    "muxAssetId": "8c51lg02b01XTY6tnbL00qWuwOLvAUMsQ3veZg5L7SHRYk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 483,
    "title": "Drive And Kick Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "00VbBE01Q00g7z6Iua4UcNsRH01L784GVefgnfzVIyMAA1M",
    "muxAssetId": "LC00EIWkplXiRVRPZN9bt00n8CN1XDllPjRvGh7SEYDJo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 484,
    "title": "Game Winner Reps Into 1v1",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "2:37",
    "muxPlaybackId": "NrOj5W4kjPPjomnQZTA6pFgVd9zr8HdPHFGlq2vha3Q",
    "muxAssetId": "nhOyrf201SBz4G8kIoNE01aOhc2E00yQ2jjUEaeT6YVUsw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 485,
    "title": "Lob Pass Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "00q16XXFMYadkX001nyTdgnpxjQPmqhl02e9R6VRwW9T3c",
    "muxAssetId": "8F02IWgHBkn8Q3dRIhfkBcqvPIYo6wDa8QZKquxAdMyk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 486,
    "title": "Move On The Catch Drill",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "cENouUA01oCMoub15OH6let01IIDJdbqqcy8MDCZ301H4E",
    "muxAssetId": "nhWpdc6QeHTWVcCy343hk69TaDNujRvLHpgpOkg8WzY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 487,
    "title": "Pull Up To Opposite Turnaround",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "39awN100tearOwhn9OdSVRX5HcNqgQ1y4EWpCYOm013hE",
    "muxAssetId": "BPPdWEbXWqTN1Qa9cmCtplElEmuHtvoxTD6m3ucOJ5Y",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 488,
    "title": "Reactive Opposite Off The Dribble Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:04",
    "muxPlaybackId": "A4ZelEujecBmAG9dkcxvAt6NjAdoSCUcIruAADwIv3E",
    "muxAssetId": "GSEyr7yQ3NlcfQRwMSjRptjVVTkmDROHCAQGYrC1BJU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 489,
    "title": "Variable Space Pull Ups",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "LD9fLTw01BocIW3ekcdTIV8m75o8dswS9MgnhdJwrYNs",
    "muxAssetId": "sCf7CXDwcqhtiebNSHhj8tgf1Bt3Qjs7vmCgarqyOfc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 490,
    "title": "1v2 Give And Go",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:19",
    "muxPlaybackId": "01pYdRM00M102QddFRvnAMsQHZXjSRTbofU2GqguVZxJlo",
    "muxAssetId": "xaQy8E42ZBXjeMmftsDCBNNRSE8GG41ixg02ozLtIJEM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 491,
    "title": "2 Ball 3v1 Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "H2o6oKzvj5NG944LgnT9SYFv02NO3QUkU68Iqm2C3CqQ",
    "muxAssetId": "L029aRR1ZdXO24scrzgVefj6OcI5fYAHRB02TfvR2Lyjw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 492,
    "title": "2 Part Relocation Series",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:41",
    "muxPlaybackId": "UePMAzQDRo021Rm9HtZZZxXsaQrbXeb6mkTY02nxxqI68",
    "muxAssetId": "HvzDI6qqSSw00X6JXm1A7xT015jYR02h5ARIyXnUkvJJNI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 493,
    "title": "2v1 Attack With Point Incentives",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "v4KgiMhTsMByK8xjBeVOEioMZzUt1D8Ict1VjHbm2CI",
    "muxAssetId": "9ATGSu641MWB7H2U00YG4uiNDKxfotbDittMy5wh8FKY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 494,
    "title": "2v1 Cutting",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:35",
    "muxPlaybackId": "800lif2HPhdjlS8FnqOUJKlFgcj6RrYxo92tx4ZQMePg",
    "muxAssetId": "HgEdiIejAwmfsnosKLuMW5BB24b1yRXb7s2qszfy11c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 495,
    "title": "2v1 Pindown Intro",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "8R01MPovg3A2nBY01rjPPWad02MXFdzdK4bVrVOVRI2t1w",
    "muxAssetId": "NW6FfSjmCGHFGGe1UEyIn7iL00MTh8fcNPmhoOPqMPpU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 496,
    "title": "2v1 Recover Closeout",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:52",
    "muxPlaybackId": "lTIdmGQlhQeQWeF6mRmsT7SR3psqApmG1qTAa3FR7Qw",
    "muxAssetId": "JjvOK00v01NgpusTjBUEOTFCW5jYqn19cO4iSoTR8JeBU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 497,
    "title": "3v2 Chasedown Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:44",
    "muxPlaybackId": "aZMGRexZhgEzmpHMRfHWPSrv46BMdApDJn58RpNzPOI",
    "muxAssetId": "H1LX5yKtkEDIloN2NtZoV02n02M9hnRC029vV4RCtJbhT00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 498,
    "title": "3x3 Cut Constraint",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:02",
    "muxPlaybackId": "Q2bbbgSuGlZ4Zh01JIIh02902wECvC4gKM02eycepZvQYYM",
    "muxAssetId": "QHzCgeUpKovf7h6026j7Px9li02b7c02Zg5TRD9DSBSFC4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 499,
    "title": "Approach Downhill Decision Making",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:39",
    "muxPlaybackId": "z005VubLe02Vj1HwPq3oHpi4PqIX5qasMVN61wAPrunPQ",
    "muxAssetId": "OIHRbRaRtV00BVFadB83btC54YO7IMNk8GZp7xzfH8Ww",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 500,
    "title": "Controlling Pressure 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:56",
    "muxPlaybackId": "Km2LfS8ZiooaI5oUXN1tBUbhZZ9RX8I00BwgNe02vYhtI",
    "muxAssetId": "3qDEs02np7zHOE46LA7Ns7L4N8sqngmaYHZcmb012JzW8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 501,
    "title": "Drag Screen 3v3 Intro",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:12",
    "muxPlaybackId": "n82YBUFWX2Jj00YB01cded3mtyitvXa93jFE19uKTrUSY",
    "muxAssetId": "qgCxN02GswLT2n01EBYkY38nXsh7kEet003feQDIItPvlU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 502,
    "title": "Exit Screen Double Live Game",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:47",
    "muxPlaybackId": "S01yBQmDSW5Jv5Pt4c9Kevgq02qfOUB6WKKHZ199qNlo00",
    "muxAssetId": "cdeoEB00yu4F3ZO8Hh55Dfd1Q007jO3WW4IagUtTkrGiU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 503,
    "title": "Hot Potato Warmup",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "Zxebm015vBJgBhq34NMd9aalh7cuAXTRu1SFXQTIfL00A",
    "muxAssetId": "fBirDFw01n8CERNxaqsF1e5Tjtt8YY3w85ODrjBKjUKo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 504,
    "title": "Lift PnR 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "CLqQZ1ACVp02zkGGav85pesJguQOQYtqdqKLLz9uLwoE",
    "muxAssetId": "FR00onZGy69j2E02p26TTck6AoyKbmAgvAybXlkPd25Ps",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 505,
    "title": "Scoring With Gets Itro",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "3:35",
    "muxPlaybackId": "470101NmAr8ZqRofL8cQVzjC8Re02OA01PgkpiAqotmoKb8",
    "muxAssetId": "uq00EwCW7wzSxC8MKMQsxeBhuuD4pXA8vSj66uFSPuoI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 506,
    "title": "Short Roll Live 1v1",
    "category": "Attacking",
    "level": "All Levels",
    "duration": "0:46",
    "muxPlaybackId": "RSRH02qzLzff1a01meM7KmVWh4tdiPS6Rwv9KfHQDt02zA",
    "muxAssetId": "85p4Bt2YJ01e3KvfK1YwBFh01bkZd1ONNttuaLs5vVtjk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 507,
    "title": "Silent Assassin",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:36",
    "muxPlaybackId": "u7GM01h01uKugMNwfpbP3RHr201nZTDEUAZEY01EV1682r4",
    "muxAssetId": "AT3SYAF9cl1EBLyl6KAt6L2oQGx8ohilXzJ1XBjNWT8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 508,
    "title": "Simultaneous Passing W Defense",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "WbpckQm00d7iUEfCix5Bk00fcrLLqHPyEWcXSOednY01lw",
    "muxAssetId": "jwwDHSZxhwNBu7cv9xz6Lkh4RGExLhzjBFPrKs2FYA00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 509,
    "title": "Single Hand 1 Dribble Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:58",
    "muxPlaybackId": "mrm9tSBAEaRSZjHtDxRw6trSef7S19n8TtEi8008N7tE",
    "muxAssetId": "Y402B9xIbfPmsMt7tTyj02KA6mLy3zzRKuRdEx6Nq6ldA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 510,
    "title": "Tight Space 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:40",
    "muxPlaybackId": "EBPGS2w00v4Po8xDj02eWv9n4IDwXQvd00eDzeaimqoVQQ",
    "muxAssetId": "sikXxgC600YcuFGuy4JyoaVI5vf01Z1PGcNdsog4PF2gU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 511,
    "title": "Turn To Pass Or Finish",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "6YN3Ny200HpP2466b3ahndl4b9U6VStnA6WwTVKFeens",
    "muxAssetId": "gLkvdPHmMYIY3zFOtZ85s68AtW6MiLRzhQyluogGGwY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 512,
    "title": "Advanced Float Dribble Experimentation",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "miEZ6ceE1ZEy01xUN3Xt02DFGvgBv9q5PBfbf2Inx003rw",
    "muxAssetId": "ty1iyUwch9nJHTmPeS6iGgTzQFBKrrV11S6fsWMBxNo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 513,
    "title": "Ballhandling Accel Footwork Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:15",
    "muxPlaybackId": "yD5icbGkp9XUuFsi9hu01GByf9AJjvg02X00c2HhDF4TLA",
    "muxAssetId": "7fEaqW84gPX7DywDcpUFrkXfrPupDH3013s02i2dRwhW8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 514,
    "title": "Dynamic Inside Outside",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "nKVwx02T78022B1pKEYW00QLZ02uhGpdnHUGhGpm1ZdbaDk",
    "muxAssetId": "F7WXjh1hcKOsepRyyumM5lFaU2VdAFpqLDkt6xWiitU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 515,
    "title": "General Skill Ballhandling Warmup",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "qdVLJ01fJWV9pdHGDi2pffqXGZDOVFLW02X95wr6lEDIQ",
    "muxAssetId": "YteufyDty02lCD7Ij7j00WsIAntKkgEReIG8ZNZ1lPjxQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 516,
    "title": "High Skip Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "VTOPWLHjYM3Mgiqsp3byGW74oqpZwtOgSQVBgPPswVY",
    "muxAssetId": "bNi729KrR8M45Em00ugRO00blU201ZuJ02k136gxBJonD1g",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 517,
    "title": "Let Go Freestyle",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "sks42f9unIyTP5PQgzSkiGWvw00GuAZlJEAcvqAIlnGU",
    "muxAssetId": "5JizAHmqR7c4oGhYgDbCH5QzgVt00YgdayHm1hfOb00M8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 518,
    "title": "Mock Defense Explosion",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:18",
    "muxPlaybackId": "aLKBSRczsEFq63UzJTqmA02whs9EA8CFMbABb7Xv5DUI",
    "muxAssetId": "1TKgaTBk028smEuTdJXJ4fpa2AAjvEcKwTtaBvkV5Kng",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 519,
    "title": "No Dribble Fluid Freestyle",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:13",
    "muxPlaybackId": "Q8vo01yBAg8sSAJ00jfFTKhmFGQcsdUOubEudCwGzCB00I",
    "muxAssetId": "z5J01K3Tk3e12QR3rjRYR7uzddYKsaBlw6h6TJj3MU02w",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 520,
    "title": "No Dribble Swing Control",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "tDlehyBYKpWjMrkEmpFN5Uo0001Ac9ileYkFWeXteIsK00",
    "muxAssetId": "aKOmH9NbG1WEvyPJ4sA8CXO02VSCqlFLgkxdCAAlJy8Q",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 521,
    "title": "Pause Ballhandling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:36",
    "muxPlaybackId": "i6oTyG014g02lqqLzxg3j693a8xW7Gir2Rk3g31vvalBI",
    "muxAssetId": "FT8c6lUKhBdL9fCx8shlBXe9T1gSutFfs8H4mV8MAxE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 522,
    "title": "Recovery Handling",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "wwqDFVTBTPYQCMBa6s01cjjIj1PrgorMh3cTMgkm02Sbs",
    "muxAssetId": "O5VsKp02dS6k4iU02016PpMmSYXSav6V2MeC8THjRwZmiU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 523,
    "title": "Single Hand Freestyle",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:35",
    "muxPlaybackId": "l3k2T00ZzrBH9l024snqoiDmEUERu002Zsa017UG0101O02Kw4",
    "muxAssetId": "1B6zwGLiPJ5Oc5brvlMXLjoCtR6THXGOPG9qNz45Ncg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 524,
    "title": "Skater Timed Dribbles",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:04",
    "muxPlaybackId": "R5RKN5lKLfiVQEbkD028m9e2XldavkbGGIqOer21vCh8",
    "muxAssetId": "EEneYZgL6cgZUHSnoUARYvnhMbjwXGbiyU1wLc7B1KE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 525,
    "title": "Speed Change Exposure",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:44",
    "muxPlaybackId": "7L9RpKNiip9WvPdhU5jjwHXpZw59YtvQvAhPgQTq4sg",
    "muxAssetId": "k2Jcio5UyP01uKi02YmdnNXwrrf8LhwAfEcCCTEv2oD6s",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 526,
    "title": "Spin Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "0:49",
    "muxPlaybackId": "I4ZZgaZkwHEIt2Bx2bMu4p8M02gTDP2y01rF5BBf5vHF00",
    "muxAssetId": "PWmeWW6FLOn3LVnq8LnceI02xXPniortYTB7zcud7OB00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 527,
    "title": "Wide Skip Dribble Series",
    "category": "Ballhandling",
    "level": "All Levels",
    "duration": "1:32",
    "muxPlaybackId": "gSk8ricgKVrwPzjIRal7D00tIi3kPSUuQG1WtQ8CaAkw",
    "muxAssetId": "Kwp004tB7wZluLsclCnXsJSSUBnw8bon00yt4QZX8C00QY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 528,
    "title": "2 Ball Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:18",
    "muxPlaybackId": "EH02DCDy00eHSVcr7dQwuUFntXruckrKSTvjOPinswg00Q",
    "muxAssetId": "WQ02vxDWpovWPJozZw02cNVfNsX01kIV1AKdsekW2s6oVY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 529,
    "title": "3 Part 2 Foot Touch Progression",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:39",
    "muxPlaybackId": "C6gCqDrsbRfz7WQmJQo02mU9M01PgybMCyO02AEBNUYS100",
    "muxAssetId": "bNen6gr019GXB2xfvv02LNR00bdnfDlfFt027j02TpXWTh8I",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 530,
    "title": "Across Lane Extension",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "E94fNpzHbIDdCeKd3Mqd2002oT02MiqVos007iG01gOWCDM",
    "muxAssetId": "fpRIHA5p300mH8sKfI2W014RVKZSOlWCYAX4011OhrBiOo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 531,
    "title": "Advanced Touch Warmup",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:51",
    "muxPlaybackId": "hNff8CVmWLHDGEcGevPZD8jjcnQNsKLEMShu2PZzL00Y",
    "muxAssetId": "e302Owjkx11019b6XSqrK1bh2Tfhvz02PcqW564SqKu9IU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 532,
    "title": "Athletic Finishing 1 Leg Series",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:44",
    "muxPlaybackId": "Gx9xIX02ZbXuuO8grIDlGbR6EJBru78DoiepF01rWqK02A",
    "muxAssetId": "Sa1DXXCZ02aFM006LSZ4KSck01V4Z01H776ReCFbzg5bJZE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 533,
    "title": "Audio Cued Pickup Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "7cZMJtQKfbIL01dgtOWgIVON9AW4uHtoOkuBAZmY1GPs",
    "muxAssetId": "7sILOYpmDYlUPg78VnZO5YoBuuERObdMuj1iVhtWG01s",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 534,
    "title": "Between To First Step Finish",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:15",
    "muxPlaybackId": "vBDTln5wMZjCYoafzf01PsEizo5YTHXKFEqQDfIwGb7o",
    "muxAssetId": "3gEIr1PL01FNMbhB37jO9DHr9GMZU4wpCe3usB8DwCUo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 535,
    "title": "Chaos Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:41",
    "muxPlaybackId": "mHZmWW7jzm3hnfI2GQC6QoHoFunfaGpr4T9CLzsOWZU",
    "muxAssetId": "kAL9aL3X01iGN6pSLrExeRpiE2FtOOjB4Ds6wgQBzuN4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 536,
    "title": "Crazy Finishing Freestyle",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "jc100zFeyCTS9c7smsbOW4astxnY3tQAG01Qjn902leFeI",
    "muxAssetId": "4qE02r7girpIRoCk9V00E5JtFG2EGQeftLE7lqaWbLFak",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 537,
    "title": "Cross To First Step Scoop Across",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "h87ymN2AvIumJM3Il2urDCJMGtEFYJsuYiKh00KU7auc",
    "muxAssetId": "wEGvVWMbrupTpZPLB1ZoafttcGIZG6uN9W3ykrF2Kyo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 538,
    "title": "Dexterity Juggling Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "c6WdBt7bsXG02Kg4WzoTwHRlt4Ek6Xw34yIe00ENZtvjw",
    "muxAssetId": "RPM6A9Hp01bvqBTzUMy01BQDwxlVyhhFALn9kPzeTCynQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 539,
    "title": "Dr J Drill",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:49",
    "muxPlaybackId": "5EQYSM9CerzBKGjpNlrVgCoC02gwXPnVPjMoinssFOVw",
    "muxAssetId": "dbDVDszUM5gaB4sjDUlAGg35uoxgMO47eU00lngE3HgE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 540,
    "title": "Go Crazy Layup Drill",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "017B9mY15VAuSaR9dTYQ3Pe8NSeXWDAgVNXCslOuJWoI",
    "muxAssetId": "bX1RNG5WyPqcEyhOO802h6oHkXw6DMvlpITAG3d4iuaI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 541,
    "title": "Jump From Baseline Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "Jhy9RrIjhoQ02f02ZuOQVZXQt6rsmF01sLPc00Pen3ULVGc",
    "muxAssetId": "Z4PwtVUMALDWUl24rqtCP01XLQc9w502nLaU57qejF00eo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 542,
    "title": "Let The Ball Go Dexterity Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "nst01XlzmUgc6HrKFWPbeERdn4oF7LeI01c3S1Ye9ZDFM",
    "muxAssetId": "02nfcN5g3A1tgHNYVY159YQVNkG014yBqQ5z2Yzy02skN4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 543,
    "title": "Object Touch Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "LuggJ00ZIOacNHHeou91yUCQebFp3qJ02htEKWpdra2XA",
    "muxAssetId": "74faXO4azUmnyWO5m48qcTtnXe7Nnm2F7fkBc2hN9ms",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 544,
    "title": "Off Backboard Layups",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:30",
    "muxPlaybackId": "EeQOFfKZdIHScP02yoizcgLb3cGthx9bukpv5kKJo008o",
    "muxAssetId": "jsv0001IrvsUbDNPblzpxWiA2WFBPGSvS01NsWnt6CzXm00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 545,
    "title": "Outside Paint Finishing Challenge",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "7zOrFOi6Z9cHoUhh01XexFVXs01heGQXW63k5QLwYvlQo",
    "muxAssetId": "7tS73h9HdEVp7ZjltqbAXKUp5WbHRPqkggH702gFP2WQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 546,
    "title": "Over Hurdle Finishing Challenge",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "RoYAnR02S022xF2zcG3EyS6QdLy00k02HEA7uVOUp4YnvTo",
    "muxAssetId": "mrn1RyUJqZS00fBoSnogSSj00zfVQWdKG202ifX9bCmVJQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 547,
    "title": "Random Touch Shots",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "ZSqCJehNJIXN01pfqCACOhSN7ODX4nI46Ej4q9qhAIXY",
    "muxAssetId": "5ABFkU00hebaeZQ82fiV00N37FYJti017Z7ArLMO9cT301o",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 548,
    "title": "Reverse Touch Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "016eYDBB3Tzh4I9BMzl8onw4YeuOZ7ztnnaqsIhUoHZA",
    "muxAssetId": "h8psJ5pEbThuS77UcjWkI5WggUa21uFEXHUdsnZXkaU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 549,
    "title": "Right Angle Jump Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "nmsTvRoMiwpTdl02J2JK6vfXYtSE5fqW8oqR02SOVsxH4",
    "muxAssetId": "uu4n5q3Qy9TQmz3x5ADO02vdbEpcC01rHWzWvYhKmU01lU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 550,
    "title": "Speed Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "Pyy2B75YWXcqTHaLt5ycTKGDrUWD00uU0102DZ00G9MjIn4",
    "muxAssetId": "c00FRvMTfzcsLpwTo6j4SFzqwCErdr8XYrNBSfb8xVY4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 551,
    "title": "Spin Audio Cue Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "XzQ009fuXLQ2UhRhmqPxdsqFRAm01zLXaLIVYXi11004vg",
    "muxAssetId": "KmKgE23S64ih6D01nRQVs2uRhu7OvW1G3GBs9kYzA5ac",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 552,
    "title": "Two Ball Bounce Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "GsIwcNHsw3xB6pzQUQaSlBj275XZ84gtr00S3sLRRwnE",
    "muxAssetId": "bBeLijBwROwCFCcBV02V00HxjLaVgZsxOGcjAjF1xLZC00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 553,
    "title": "Variable Touch Shots",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "tsd1WKSrYOCYlW78FfTHKB2GBRyKvq00TWBgIH8GQHYc",
    "muxAssetId": "gWJFWQxFntiw5slYODjCs5OrjIvmr9x5gVclObzy438",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 554,
    "title": "Wrap To Tap Finish",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "LCaa42hlFQjo02PM3roAHCUwDSyKbKKEuMrqDnGCOheU",
    "muxAssetId": "QMKhcPm02rfQCBM4hbfr2b02Fq5SAG7k800gMgQfmKZ004s",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 560,
    "title": "Circle Random 2v1 Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "IuIhjLiGHhaUyrRsBTgRIzgRy5lbtKu4BqOoFnH02yhc",
    "muxAssetId": "6MT3Hosc24sTUxdDondsU1lMvnIlLgSVMrH2YAM028mw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 582,
    "title": "180 Bound Footwork",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:18",
    "muxPlaybackId": "lFn1tOy9ZxGhZdaVDfHBrWIsFfNqXbU8fv00lSNfVZZk",
    "muxAssetId": "F02eo77Gw2fMQwErvmsQKmygdtbf02UC1HuwcSeTA5mCo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 583,
    "title": "180 Turn Shots Into Live",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "VZsCxdF02y79tCruIhcV0178OLjEt4yqTzxKdX46S01aPI",
    "muxAssetId": "O4P4gDJ1iCbqiUK4Hffo00R92w01ZRjvFPaR5GE311sE4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 584,
    "title": "Audio Cue Quickdraw 3",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:51",
    "muxPlaybackId": "1jIcvCoGNBeKTX02RpiS6OskaVHjMNXo6495yLgDjfbU",
    "muxAssetId": "ZCfVNStKGPxkySaBOECQnIJWRAJw2PB7aBt1RsQ8Oxk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 585,
    "title": "Ball Roll Warmup",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:06",
    "muxPlaybackId": "M01FRcqWDkV7ESIeDX591XMWp00q1OO5sA701EHbAa7WpA",
    "muxAssetId": "UyTrnbt68jSvTUkxlHQl02bf2jVALHNusB7uZhtyESyI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 586,
    "title": "Bank Shots For Precision",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:42",
    "muxPlaybackId": "lLZoa5Tp7fg5fF7XwrY602GmBX02HBO702Ato1eY6J3Ob00",
    "muxAssetId": "Mnm84STPll2SGSupOkUWcm4477FDehbyaFDN77uNzQY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 587,
    "title": "Block And DL Shooting Sprinkle",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:16",
    "muxPlaybackId": "ihrBKOWOdlSBy6hfWqbrPICYpoRnWlJjNkr2EDFy3TA",
    "muxAssetId": "zhlZTlKaQr9NXZZilnvlClBNGGRBCcJq01y29m601LnPg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 588,
    "title": "Cold Range Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "JZqDzivJlXhFmR2f1wzeQo13A59Ep301aQ9DdRE2F91E",
    "muxAssetId": "pO7ZLMDOhNcTy44YItnrcnOkIrXvWh01jmuK3UMJtQJc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 589,
    "title": "Coordination Ballhandling Into Shot",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:34",
    "muxPlaybackId": "kPLwl9iHNvdTwecz7kyS00CI9feiu6SGxbPZAjaIXZ3g",
    "muxAssetId": "NaE5fkQ9GmgHaI4iFykEyWxyBZT1pax8ABuYBsushHg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 590,
    "title": "Countdown Curvilinear 3s",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:45",
    "muxPlaybackId": "DFFbY68AVdgr5BG01jVoUYBCsTsiNMJNo01SKTnOOmev00",
    "muxAssetId": "2zKrb02l9YglbTvJTBIn01mfm01lFKQrB7xr7zIv2HG4CA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 591,
    "title": "Countdown Dynamic Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:36",
    "muxPlaybackId": "ztUXG98aXLyf7i8nmCrVzjLYe8YEg5lnmjsyW3vJulU",
    "muxAssetId": "hnY1IkgLhjb4qMP7h8DQtZowwqvDDKl4TfOlUM9CXeI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 592,
    "title": "DL Warmup Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "3jjUfvDdNPJiu8v4CyfLsCHYaXrG5vBeRZ01qNkC1PGY",
    "muxAssetId": "CBD01pIJbM5gNNnY9gw2WULuVP3ON01irudd46oljipAo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 593,
    "title": "Double Hop 180 Flip",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:12",
    "muxPlaybackId": "BtklLDfAH76KOUDHImumljSRHsnYPnQFDMiTe8O8eOw",
    "muxAssetId": "02VcJgsmgbgxV012p00ZfJ300y9QihFeQWEDeGnNTcvOoG00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 594,
    "title": "Drift And Straight Up Contrast",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:49",
    "muxPlaybackId": "WMTW01j7eC1dkRSLMFGH0298k02NySpWHsdNShCb02SiYsM",
    "muxAssetId": "MGKWM301jB01oKnsnPzmMfDX0000IbxtGkaRPlHCh4bZdj8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 595,
    "title": "Dynamic Warmup Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "2:58",
    "muxPlaybackId": "9mc1TWQBVG9qdl7XYWWN2EdQJINpDVTCdSB7YXIRxBI",
    "muxAssetId": "nhbJf401tEiDt8XYFMLoRpMXcq00iLdJfx855B2ODkz7c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 596,
    "title": "Fluidity Shooting Series",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "6:01",
    "muxPlaybackId": "prHHB025R8PVhpijpmbEWLHjqL02jO6XnUIL1pEouLmNI",
    "muxAssetId": "fmiFnmdIOB48yW029v02AKMi31Cgr02Ys92ynFLrtbNLP00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 597,
    "title": "Freestyle Handle Deep Jumpers",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "BooBemR2n3UySx7KYw2ABHhrPnOYoUR00mxAkFXBuFFI",
    "muxAssetId": "01jWSg7fM6rslbOLXFmWIc5WUbAMzY2tPWoLQpoTcqBQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 598,
    "title": "Jump Catch Threes",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:13",
    "muxPlaybackId": "GH00GpeftftAVlYZbse3k96UIRaJG7Z00PtpxtqjGHLyI",
    "muxAssetId": "N5hYNLVqPFsQUpGgILtzf2kJQKP2GFwLtr9D9fL8ZWA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 599,
    "title": "Last Step Timing 3 Ball",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "yBD5RA6tKWTvlQ2DzWde5T25PKFbyjU200UiWZDGyopw",
    "muxAssetId": "KaVZ1CYxSzEAljMswyCHGtu7qasdi7F7pSElhOjbE02k",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 600,
    "title": "180 Pivot Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:10",
    "muxPlaybackId": "Te5y3ugSTXvloMK00J29o1PuovmFfqteG94eGHasFtfM",
    "muxAssetId": "AnR9s2kpqc01vzBhcvmcw01bppgRSiC39H5oQhWnwFWsY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 601,
    "title": "360 Pivot Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "Sn2zW1IpOU7OYoTGhKo3yDioT5CWRswOVTXW8Q02j6pU",
    "muxAssetId": "Yd02kkYM00dt2iWSMrDfkyRIVyu3kenz4UO01eZz3LSO7U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 602,
    "title": "In Place Skip Jumpers",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:12",
    "muxPlaybackId": "IjXzVg2wYmCcn800v7y02CK3om00GGoWEjl44KGwA4vZ5A",
    "muxAssetId": "02Dbavz701jRfRBQeAvS6eJnNJ01zqNtZbaHMPHhYmCGXc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 603,
    "title": "Last Step Inside Outside Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "021jZC02HWeDrGqxqnBK1eUscOk8vwjb4wxJDivASU00fc",
    "muxAssetId": "zjiMIUfS9kVZS2b024kIZvSKatzgXmxzUVkzM53v5xcM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 604,
    "title": "Move To Flip Jumpers",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:11",
    "muxPlaybackId": "Ea8GX2Q02hRXWvWz9xVA7LDJzNmR20202zsvHwmBV02T8bY",
    "muxAssetId": "r18GDad4c7ArnKeN029Hi00iZ02kytWI00nplkAhe2YcYGQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 605,
    "title": "Rhythm Arc Warmup Jumpers",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:13",
    "muxPlaybackId": "Shssbe55agt8467c2PJ402aNYD18lAvWzWxD00iwYeYok",
    "muxAssetId": "013BKpefF013i1tYq3MwdfTfHuY1uIsJ2rUwubofovr0000",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 606,
    "title": "No Rhythm Jumpers",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "iGUATQT3phLeVz3Jo3fWN65UhjDhFK3pliIB29v02lk8",
    "muxAssetId": "vUiDwyuBgNDWaB0100aMBUQUmfDtW9dXJu7xTLoL5lAVg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 607,
    "title": "Off Dribble Shooting Series",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:25",
    "muxPlaybackId": "500WT2PHyZ1p02jioAwqKfy8ZAL7kyBCkODpLZXqZXHqE",
    "muxAssetId": "6i01jyWEr1vSArauSku901CyLLkRmCf7EZkMB3wCpjpec",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 608,
    "title": "One Leg DL",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "cggDE54Hpw402YVS3SnHxVWQaYB1c01loJo1Yd00KgHKWQ",
    "muxAssetId": "8PRwmr8lMDchypOIV7lXLwH6900tGPlReY9c00iBbFJBk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 609,
    "title": "Partner Balance Shooting Series",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:36",
    "muxPlaybackId": "AIjNxGYWaulGBwcuMulUOfkIisVL3wvnWy00r8az8qLw",
    "muxAssetId": "9pmzuzLC02MSCX8xS5JLo1wBfrhMCbUh6SDFt3jsGsYk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 610,
    "title": "Partner Lateral Pull Drill",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "Ghg8UTbvqADqaBHo4eJL6N51MKdJ00zCj48oJ27LtNbw",
    "muxAssetId": "IDpLNkPhiHAmByD00lN3dmLpEun82j01RFNXQ5l3w8Kj4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 611,
    "title": "Partner Lightly Contested Reps Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:34",
    "muxPlaybackId": "9c00FfQ1FFcZ3xX3albZCDHxm01NqC02XcNQG00ANQx8mGk",
    "muxAssetId": "Bx2UHI4KAZC7OhxEQ1wSC00QZnfFY00dIbuTqDYEgdltQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 612,
    "title": "Pickup Hand Placement DL Shooting Series 1",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:06",
    "muxPlaybackId": "5ParWuRb3umxG3UWFMMQ8lP4BUN5EmseQxLF4xhR53Y",
    "muxAssetId": "qFhJ02pT4P01l9PzGA7NKQ2Ws00IdDI02UYSp66KxH66nSA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 613,
    "title": "Pull Down Energy Transfer Progression",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:40",
    "muxPlaybackId": "WpeD1A393wlfa3ndnN4n802pOmiOM2ydCQHbJYAenGPI",
    "muxAssetId": "bURSCBkQ52dhQDY022hm74Uk3UK7M9urdtPkSK26bx2g",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 614,
    "title": "Push Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:50",
    "muxPlaybackId": "dWjADssBO6nSyqcYWUMq8wCQR701Meu8F2YiFvoulYjw",
    "muxAssetId": "9HNsbwFFzPQ0238RVId7KT00GSPEA3yfAGBgIJ01WDP2yA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 615,
    "title": "Quick Flip Drill Progression",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:33",
    "muxPlaybackId": "tx1IhaE3UtbFG1OVWqgX01FNjbLdwB2FUZFeGEcCf5WI",
    "muxAssetId": "Q9vI009ndJxMKCk8opJJ00SPkQuMTb01DrSMIrm9dGzu02c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 616,
    "title": "Range Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:44",
    "muxPlaybackId": "p8afO5vBfw021V1pJTDuQeWcBn2trleueeOHpZLLOKvI",
    "muxAssetId": "n2OxrmR01lQCyaAayVMTJungruWqf9O1ND3CcOr02SyZw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 617,
    "title": "Reach Back Shooting With Backpedal",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "AKYa02g2fh00L4WM00PwHTDYWb8lDknkEQ9bXlAVrblx7E",
    "muxAssetId": "CT01qvMsi1qpu02SrCje01e8AOWcgdSkJTVHaUV4Tagpvs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 618,
    "title": "Rective Lift Path Pull  Static",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "HxQmxU1dnXXEVj2a702oPwQQ2nq02o00SHHZ2NwKuxav6k",
    "muxAssetId": "u8xojVlCs00Dgys00Y3HGeaGs99wRUQydTX01rV02nrv01yI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 619,
    "title": "Reps Shooting With Variability",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "leVlARQ2wVkc4COeg8t7TY01nErdpwJuaOR00Lv7h5RTA",
    "muxAssetId": "a00qSD4IVrU9YjT1bU5IB101Do35Lit2HsucvhiXAIp2s",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 620,
    "title": "Rhythm Re Creation Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:55",
    "muxPlaybackId": "eRXNajTF1FDtZjsK2BRFq01PXcQE00msQqYpomTDt3Rv4",
    "muxAssetId": "c8E7tiTnLxjAfIMWBfSEc3FQ2oKpCVU6b5hY02G4zACA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 621,
    "title": "Right Left Ball Circle Shots",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "bnAbj01eWlslv8pfOcHZeJpYyG5yPshzOpVLr4P39pCY",
    "muxAssetId": "DPtAxTi96QxPCNjoADj77ZpURAzUZ5ganJHeWWZ9RKE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 622,
    "title": "Run By Chaos Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "RU01339zFrTerOdbSWoxeL012u3YzXMPhkq9zazX9L32E",
    "muxAssetId": "7lb45T2bTY3CoIXVBX2X8LKr02xXrK9eRObfp4sNPjW4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 623,
    "title": "Second Side 2v2",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:35",
    "muxPlaybackId": "8B5RZIZhoJfyC8lm016QJFi8d1k01QtOS02guEBCx3ia024",
    "muxAssetId": "CD5I7bWIzYw7k1h3IUHEsW9gytYVOdWoEw749stf4G00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 624,
    "title": "Shooting Cold",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:58",
    "muxPlaybackId": "00hMPMHnWHbRPV9R00fSEGR7eARp1oY2Ic1025vPNLRjKk",
    "muxAssetId": "1DkyATbNLj4itunK8q1XryjnTrdiUOohZP75sCAdjWE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 625,
    "title": "Shooting Competition",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "jRSG6ktXDjyDHgmXuRujKs8l8B00d3acQ01QVa7DGcwLE",
    "muxAssetId": "NtiwQW01fk8iHwPkLOeTT5Iz2NCso8iccXeJlKRZiatU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 626,
    "title": "Simple Touch Tactical Interruption",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "tkZzjqiSBcarx9fJVqMrSr01IP02mxCOaJdumS02Tqbk2M",
    "muxAssetId": "y5ag02ShTEll3h801h9OEOajDu8vO7KxlfPvkuajpas8M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 627,
    "title": "Single Arm Pickup Coordination",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "PzqL00q2CXZDFtRS5TkG27WQzsjyqu7KZRvNM9GiWZGw",
    "muxAssetId": "029FsKWfOPdunQAy02hW9INE7yJAo01gyAJadWmgKjGBrA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 628,
    "title": "Skip 3 Balls",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "ja400svAvUjZH4wwZxgzo0158hLtyvT8TZFDe1DoR9syo",
    "muxAssetId": "00a0202xsqANUK89P6401sbR02JLN1cRnzub19bUXdJAqQmI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 629,
    "title": "Spot Shooting",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "f2Zd4n8z008OlgURsSoZzrCUeIT02a9a5jU023mbkeGOMs",
    "muxAssetId": "PbcjYmzPrFIKCMmN00dwSMKOySXdtFZepQHlDL8YDmWU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 630,
    "title": "Spot Up Shooting Variations",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "2:16",
    "muxPlaybackId": "fcVDGciECFIMFkQXv6Q5Ru5GEppJwoqYQZIPiM7h4uA",
    "muxAssetId": "yUWdif9OEkjOeakxVTlEGQLUl3317IXv02VbT8V2hP00g",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 631,
    "title": "Tap Dribble Audio Cued Pickups",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "NA0002AeBipci1kaxqnojs1c00QT8pI00lWyo02LS4EW6FjU",
    "muxAssetId": "CIsZLSvgC45c9Ui4UH402V61JhQOtOIRNKMXvBWajnzQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 632,
    "title": "Touch Half Court 3 Ball Reps",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "1:23",
    "muxPlaybackId": "wNlG8vHIIm02ko7ZbI1qVr9k4dBx2HrpaeGWOLSkcFR4",
    "muxAssetId": "rxbPk9026UPo8R8Q6UfNT3q238bWHxDgSlGj4mUT01IIw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 633,
    "title": "Unique Partner Shooting Drills",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:58",
    "muxPlaybackId": "hHjQ9qQT6CfwbYhaAG01Dl5Bqxe9Nydd2Dv4rrwARUs4",
    "muxAssetId": "ZQPN1MOeASjRE5E732TQ3Ku02ZE6xyzRU7khbJQSvcWY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 634,
    "title": "Quick Catch 2v1 Finishing",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "0:54",
    "muxPlaybackId": "5Ck2s200yBKRq2i11d8CHEid32faxR1kTGIZbjJlb01bQ",
    "muxAssetId": "700J4sQv01DN1hpCF5wAGvqcaQ02Q00OQvgedNCzE4Yx8uY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 635,
    "title": "Quick Trigger Flip Finishes",
    "category": "Finishing",
    "level": "All Levels",
    "duration": "1:46",
    "muxPlaybackId": "vu453vWHfvxZtsyabpZI4XGuNtxZM2oYyFE2x6Xzeu4",
    "muxAssetId": "WC00kVzb7U9RB63jPcd4g141jFYQLF7aXlh028102E6xDc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 636,
    "title": "2v2 + 1 Shooting Vol 2",
    "category": "Shooting",
    "level": "All Levels",
    "duration": "0:44",
    "muxPlaybackId": "gAC7kJiGUPVbH4U7HQvH011qxVPFYVUCHXHfbwuqu5qQ",
    "muxAssetId": "bp012iamONMIACshiq5WsJxz9n9rtTiTAnPSVqAfCNqk",
    "isNew": false,
    "publishAt": null
  }
];

export const TEAM_ITEMS = [
  {
    "id": 3,
    "title": "CLA Defensive Drills",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "lbKldiK3YxmnhohJ813fYlxYUTE8X9VydvwVvspEtjk",
    "muxAssetId": "I3Cq02sExBfZKQ8O1iFd1QDe5p7Mm2FG68sVOI3bjkI00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 4,
    "title": "Floor Touch Recovery",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:09",
    "muxPlaybackId": "PIQ3vJKGj00DbM3zofGTf4r5Opu1oJFaDmCsV4f2WGZM",
    "muxAssetId": "HKUn02FEqSNvNC21DKiVA27X700Lqr7wDB79grv7xb9HA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 240,
    "title": "1 Dribble BTB Passing W Defense",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:48",
    "muxPlaybackId": "od4Pt5vIFtJEJZjogrufDDUVqp73ihfe59JNwY01DxFo",
    "muxAssetId": "JqhfJ502faHpy01ZwwG732oUb5s1vNS6QUNa1jxQQwhpI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 241,
    "title": "1709730229173",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "hwvT49Mc4KkMB01vDnMCONxA6Rvqr6QjbDD435emqB9Y",
    "muxAssetId": "D3500StpEgbiohTSMn2VhITrXXfJ25CwahRx00zs02BwHU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 242,
    "title": "2 Ball Jump To Quick Decision Drill",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "OmP019vg47qQ00dPFD7YmxupPUHbHKdLDJstH71EuQ3KU",
    "muxAssetId": "dUatS02ZTr00RpfgjYglpxhe00hjtJdszsjrDg7qay1HIM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 243,
    "title": "2 Part Transition Precision Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:46",
    "muxPlaybackId": "G25DcKBqOi6KXGdidI016urVYWFzKXKMDm4qHz9TsyxM",
    "muxAssetId": "fJComg69RCL65u3Bp01gBWKuu6pXkzxkw7ocojAfdbqk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 244,
    "title": "2 Side Transition Drill And Concept",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:44",
    "muxPlaybackId": "2pOaQZ02EQJ6CjxtXDQMQe4AqF8rkzHwWBX7X7501pVhY",
    "muxAssetId": "jAYwk1VV11Qkw7sJTijHXxMMGmaWn1En8sj00nIba1s8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 245,
    "title": "2v1 DHO",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:47",
    "muxPlaybackId": "00fZn98f02x61x5WuN00gPRwE1he7BykASNFrg3GFN00JS4",
    "muxAssetId": "8H8Zgja00Ym1Iy99CBgm01CAE003YEnJNbIKDCvB6BkdiI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 246,
    "title": "2v1 Passing Progression",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:35",
    "muxPlaybackId": "EflkKwWpCzI6hloQ8rdElDLGPp00JtpRi3RZLUJtA02bI",
    "muxAssetId": "p2Qf8201ZppIj00tE6paUSbnDQWHHhNJyiNBSJs99sQuk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 247,
    "title": "2v1 Stack Dump Off Or Finsh",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:01",
    "muxPlaybackId": "N9683qMDvw1659b8YupE1QRfUbLaWJdpjubYCnUsDzs",
    "muxAssetId": "SYbN028q37GZQU8YBJBepa8MhWfdHArMeNKSkMNLJeo4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 248,
    "title": "2v1 Transition Oop Option",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:22",
    "muxPlaybackId": "M0092TFycNLiN6SfZqkybRGltAmtO7kFR602V7GzmsK0200",
    "muxAssetId": "JR00uG16w702j02y2HAvoPFG01t01dynFSzOe024yM0201SIjLY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 250,
    "title": "2v2 Chase",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "00ClkO2B86ax5Qp7R61Tiij02fwxFNftsrI4MdNqTw004o",
    "muxAssetId": "ntH4dQ45aUVasr3HkCX9YbR00kp0102S4d02zUV00j01bp00vQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 251,
    "title": "2v2 Get",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "LWX77100UrceGFJ6SH7pqYVNd13dnRKlsJdjujdDFuaM",
    "muxAssetId": "fG1U1QyzLWELnWrpBNQQfTzDDlOUEJgXODFnbKrUbAk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 252,
    "title": "2v2 Give And Go",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:15",
    "muxPlaybackId": "niKn2gNfcbD301wKgw8t802F01woG93hOyEm43sMzuQV800",
    "muxAssetId": "CGF1S601dPo5HaICljYqCS7PhX8GMRp3lHzrnatuli3I",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 253,
    "title": "2v2 Push Pull",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:18",
    "muxPlaybackId": "wLHjR9n1QaU01hnrnWDV01aY3x02sOY1MYk201hDKn5SkfY",
    "muxAssetId": "t3Kh9F6KaebasxE62CMroa3bxAtPDWo67ZFr1C7ENM00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 254,
    "title": "2v2 Switch With Big Simultation",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:42",
    "muxPlaybackId": "h01Sv02TRmQvJxdCz6dReo201NIJE02EOQsUuhJhAeDarE8",
    "muxAssetId": "ZT9ET42vjLFqstvcdXgWOYUwSY38rFTot4xYNwKvRbE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 255,
    "title": "3 Random Actions",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:01",
    "muxPlaybackId": "Si00CvlDKo2FmN0001HL602NZKlyyn2YUQJJyA2ygmNYT2s",
    "muxAssetId": "Gata5SnrE01nLx01AZ2d1TYCSpsBsP2ibQR958NF5h5uc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 256,
    "title": "3 Screens To Score",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:16",
    "muxPlaybackId": "l3WFl7nCeKt01xtlkbVnMnxY02oVS4c1keeEx5XWA202hQ",
    "muxAssetId": "B2oXfoQV8ewiiQFmAHbC9jKHPJQoMY02DqkcA6LPBy98",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 257,
    "title": "3v2 Attack Touch 3pt Line",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "egqeaWwuJ8K1Wx7gSX5dDxO28XmalM1020015WlVc600Sk",
    "muxAssetId": "XPZaOIEYfZFhFuYBVB2LudazPi60041cTLrHtgsTxtXo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 258,
    "title": "3v2 Circle Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:02",
    "muxPlaybackId": "lllFVGyRnQQN57frqGo6KpYmtCx16ukpt1nTMLlG2qY",
    "muxAssetId": "B1wUSRcWU4x3eaTDWdM0202Wy2TaxniQ95CKSSEJaGvB8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 259,
    "title": "3v2 Relocation And Passing Fundamentals",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:53",
    "muxPlaybackId": "02K2E02prMILdyagOtcY7AwcgbpK2uYnF8Ow00n9orFWfk",
    "muxAssetId": "Qy8vMEpUpKd2yejfC5Oy8ho101RqJWHiGmRQMVm42OsQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 260,
    "title": "3v2 Scramble",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:59",
    "muxPlaybackId": "NbtVz3i4ImYrUUG7ogOnWEz4hwFcXCeXl2zwaWcI1Mo",
    "muxAssetId": "JJ4Ks00ASF9jeBroo3sxXkLwfxhgAJJ6965dPCV8NNk4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 261,
    "title": "3v3 Exchange",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:21",
    "muxPlaybackId": "b3VlZ00KYtr7v7aRq78P0254FmbOyYCz14G5OCWiByuIU",
    "muxAssetId": "NLvU7wWt26zLJfzYBZ01019yuohpb7HkaIg9YIeh9gETQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 262,
    "title": "3v3 Horns",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:54",
    "muxPlaybackId": "Y4BPN00S2BQ9M86dFB502jdYCZjMRTT8aTH11MGQ2WNPI",
    "muxAssetId": "QclTWm1003sE019h3pTHvi5cofzmPq8nhdC8QPGEZqCH8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 263,
    "title": "3v3 Pistol",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "agmf2hqylocP00fW7vIT1GWdEhtzNp004kwd6nx5NciLs",
    "muxAssetId": "HoDIc9FQbM3yAzOoJMKsmEO1QyTw99BeLQME93HG6b00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 264,
    "title": "3v3 Screen Constraint",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:36",
    "muxPlaybackId": "xcXi645Q01700wPJJunCpLXumZQAt4KJGO02WWw6GuK81M",
    "muxAssetId": "S00Q2GqCeuTl6qlQot5pTJz6etMs3ZKlEUVWscsACQdY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 265,
    "title": "3v4 Paint Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "bHyFVqa9jcob7rVhiHI1vc01MDUe2gJCSRE200CRu7eUU",
    "muxAssetId": "nXvBTUzzJrsm3GLBlGGgbIPsErYXsH801EGomMYCZOAc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 266,
    "title": "4 Corners 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "xixSOoniK2rOTk5ochEQIdp1vxyPCkM6Lqtfp3PQKhI",
    "muxAssetId": "2KMpCynq02PIbDyJ3IVZNK1lJkDSHdnFqZtsYbh4VhaI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 267,
    "title": "45 Cut 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:23",
    "muxPlaybackId": "kYSDUvivQyLpvVamghzdY02CKBE4JahsJvekRVZReEMY",
    "muxAssetId": "fXOL2027X6DpknhN00ZQokhUZ0188WsawlKRYrb7LKW2Rc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 268,
    "title": "45 Cut Basics",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "To9LvXzU9wmDAFD16lrb006lg02qjAphoxcE1W6QQmORI",
    "muxAssetId": "5hJ45Kxo5YlDDR9o4o7kMlRW3e99Y01AxUJXSMVUkP00o",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 269,
    "title": "4v2 Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "so9dzsiD2U3q9oeYMNdEsENtn7FwIGFB011jyCpFFV4A",
    "muxAssetId": "CzFq3FwoV1FkY5fgSdU5FfUoPE98GcUvS74WxoMP201U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 270,
    "title": "Advantage Ball Screen Reps",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:53",
    "muxPlaybackId": "QddxguWDF4IsWkI9atiOygD019eUSw53owZQWvSPwMYc",
    "muxAssetId": "NYq6LEVhGhGqxyUYnn7CQs028ZqzycX4yEH2azl02cb7g",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 271,
    "title": "Advantage Scoring Out Of Trap",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:52",
    "muxPlaybackId": "BOARZbvNv7QYKavp9aRuuD3rkAos3nR02JiXBRTmjj00o",
    "muxAssetId": "XL5DI9N00H01RGnISjdsGVLC00k3GbrPnotdWh02S6ceJOc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 272,
    "title": "Advantage Start 4v4",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:47",
    "muxPlaybackId": "a9NN9ogk2QUP02YEvsI01zsjNEMP9ngQ5ElaulbYZz02IU",
    "muxAssetId": "502018d23Rz9BKI7YAt7vuv2FlWuGfudjoE01icwPAweRg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 273,
    "title": "Advantage Transition 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:24",
    "muxPlaybackId": "gYNHGXC2ISMHxY7NEH9FOMkDdzpMradn7kI48HARqSk",
    "muxAssetId": "T8tPT1Ek1Fn8gmyyhdifHKq201v4qSgEuf7ogKH9fUFo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 274,
    "title": "Basic 2v1 Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:18",
    "muxPlaybackId": "01DIkDTs02BbQ6PxP2qGn02ESgvsGvzv3xJ1P5AovywEfo",
    "muxAssetId": "3p00sNxOMcL01yUOxs009tTinYe8WtrgglrmZCaukuUDd8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 275,
    "title": "Basic One Hand Passing Warmup",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:56",
    "muxPlaybackId": "jEsOvljzpZZVLgW00FP8SpF7mVq6lK1KiMDyrda25HAg",
    "muxAssetId": "ND42P1WJ1GQ02NRIUla1bA00z5FVdutHb0102LEDI4jFjWQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 276,
    "title": "Basketball Futsal",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:35",
    "muxPlaybackId": "5yCOpupV8wS7HwC00BdHUg1wjJ3HW3xQ89WxALZgN202s",
    "muxAssetId": "SEza01uZ019HwY9VG00PonNKI2sXVHM00Az4BU13ZXl7I00c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 277,
    "title": "Blind 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "5r026bvo7oiQVT4tYEgVDvk00JxzeX8XXrCar02pdxRdVA",
    "muxAssetId": "4p01F00YD3KwdmRCtSqQyMRJbGwDZ00xRLumoEfuySPAuc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 278,
    "title": "Bounce Chaos 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:45",
    "muxPlaybackId": "BddWYxqOW5Rybfq01Ep5EpZqEq021HJwBuNqyr00NPhGNg",
    "muxAssetId": "C2Y4wVgaq5xQik00wMUcI1JqyT5QvSOlUD02U5L2QuyN4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 279,
    "title": "Call Out 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:54",
    "muxPlaybackId": "KEM5mVf6ZDkNUQh75I6aZqVAZ1x1webO7dtJeHnxXYQ",
    "muxAssetId": "uB2501FBLj6v1Ks34igjF7FI8vSPHiXCWwA65d8mM8lk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 280,
    "title": "Close Quarters Transition",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "tDMWTCI7kb8WaKsz76dy9QrP79dDxMQTszPki5ZFvy00",
    "muxAssetId": "CfMV00npjK62vI02WRS8hsVbw5LHHVX3x00abbDRWskW9U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 281,
    "title": "Cont Handoffs To Find A 3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:33",
    "muxPlaybackId": "t01zMtWNvwUrv01wbuAQ5MSC5HaGZa3RpT4Wi7PQwurAU",
    "muxAssetId": "bcSalx3njMO2xm14n00JBOEKn4q00EM6K02kDqH01LlC94M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 282,
    "title": "Contested Catches Drill",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "sFrOhST00tJ02t9vxm2MK7ImckurjMYqLLYsLRFkKOJAE",
    "muxAssetId": "CftYWJc2hYCWOf5oo74QqqJXn1cDXSGft00lRVZ2U9fg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 283,
    "title": "Continuous Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "xOMvmvZHPbjlcMSuj6SUDIQbmoJztTqK62bvW6zdTsU",
    "muxAssetId": "3Yc5T02piF6B6qqofHCJBlb8XeeOw1HNesqNA6H66r500",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 284,
    "title": "Corner 2v2 Attack",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "rlQptDCUROUCmRpLq55CnJ3PNJ01UvfJky2FDVe12Q400",
    "muxAssetId": "BbM6VpLrJChYFpaqVGLfVRg502nzluSRsX433yf01NQ600",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 285,
    "title": "Cut And Spot Up Off Baseline Drive",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:26",
    "muxPlaybackId": "RSjgn2qTbgwrqv2c7Grhaz01FTVcwPiXze00RAteUPAeU",
    "muxAssetId": "i00HoB02R92UCOot02C200OpzF4Gn9snv017D8DNTmTgD9jU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 287,
    "title": "DHO To Trap",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "97EF2W13nvgSm4cawvLWVpdjhXfr8MCRFhn3CYbCyoE",
    "muxAssetId": "zIOLLe0101T8cH7nA9nwcgbrkyHEEF62zKOEaTzJNGoxE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 288,
    "title": "Dealing With Traps",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:34",
    "muxPlaybackId": "z5EDGzzLzPt57ZzrnWxNypfvQ01II9ilksd01qPKDnisU",
    "muxAssetId": "M17MAK9rStRpJjfhaOx9KQNC1J38DCXKAQQTf7AIc6U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 289,
    "title": "Deep Corner Gap 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "iLu00mtf3Jsm44arp6g02aj9z4W1YU1yFMGf005Numa5008",
    "muxAssetId": "DDjW2FijHvhp8JH2OCiYwg602gXD009qgdc9VHLvSvz02Q",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 290,
    "title": "Defense Sprint Start 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "fEvytP62D6Bp003hiKS8oqrNBEPNFxIq0166SGuOTDFLE",
    "muxAssetId": "EJ01m02f7gT1K7Or00D185027txsG7zRz2MSAEsbgpeJtq4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 292,
    "title": "Dexterity 3 Man Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:59",
    "muxPlaybackId": "668WA9a5snBi02rNYur102kAVEjKWtiyDwUXvImhoLbdM",
    "muxAssetId": "Aqk3L33lQwKRaH3TSvMSQozX7gJ47w3dSswM00EYYpMA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 293,
    "title": "Downhill 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "3:11",
    "muxPlaybackId": "2AVM17Qa01b02c8uhDpwvk7endz7r7mr3LyE3kzSDW3Xc",
    "muxAssetId": "9tFadKS6KFpYMp2LNmx4lROtCf5BvVMQy7IqX2I5jo8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 294,
    "title": "Downhill DHO",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:41",
    "muxPlaybackId": "NC1qZn400ln00w6ccy2SCZltB9amZTRnyzCUnr8df402Qk",
    "muxAssetId": "DoFLT100qiEBtS45XJPsX9KaN9ZxYsgelgukNFOCaCFY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 295,
    "title": "Downhill Momentum Start 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "QwiPK6XgsHdIQ9zXmqIkH53uzNWx8a9YzWArpv1NtkE",
    "muxAssetId": "BEMyUNLEaO2ACnevnZmE56Og02WDO4YyZQNMYn02Goptw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 296,
    "title": "Drop Downhill Decision Making",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:40",
    "muxPlaybackId": "800501mOr4ANisqdMmPAk7MwtBl02TNv02zJq8Kqm6Y01tbk",
    "muxAssetId": "2Xe100hOOpzQeuYhRjHxOmWBiEo6jGMpAz77ZZIntY9Y",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 297,
    "title": "Elbow Catch To Backdoor",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "eDJYd023TlPog7aMRRRnJGyRqQeTNEkkGdlxxi4ukLOg",
    "muxAssetId": "brEArKxtR9ydj02UYZBPQRRjekY23u9EddnhizsIalvE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 298,
    "title": "Escape 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:44",
    "muxPlaybackId": "N1CoaIcWlwyvekebjXDZvsuKDfLgNNM7olBiwmAStL4",
    "muxAssetId": "7RvDLIeLThx02xF02hwcVtDbdE602pO01GaARydyzlcSFis",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 299,
    "title": "Exit Screen Drill",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:41",
    "muxPlaybackId": "pxcSfVG94soWHywAB9To6fvs00rlCGmp8Zr00pyZExjbY",
    "muxAssetId": "Nz00zzx49wu8CWR9IWqVeEIk7eFWg9lX00OPskpPkKS7Q",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 300,
    "title": "Face Cut Or Backdoor 1v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:33",
    "muxPlaybackId": "slExIoZZrYR4SsEY5wUMEHY95SRatuPU9Wt9M01qoyEo",
    "muxAssetId": "K9i7QeqyMexP4vntXhK12bLVHP7Vi1YR67tiRmuTk8M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 301,
    "title": "Find Passing Lane And Relocate 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:37",
    "muxPlaybackId": "FiqRJquCOWoyYWBbF17YHqdfMXV9glPg68KF6YSYKdA",
    "muxAssetId": "3DH7pbjLs1jlJEfLy7FUY02rXlj015vEcd02fJTPAycEjo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 302,
    "title": "Flare 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "8u3Qdin5Sh3hdS014BhhTo5g02w6Dl5TX02BJW5LmhMRmc",
    "muxAssetId": "02DAIUooA3zN9XMhLw5Ak00eNVeYF4sZmaG2DeAExkoaA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 303,
    "title": "Full Advantage 3v3 With Cut Incentive",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "TwjUQlCWgAt00AGANaJmz2T00TiRnYfF502oaMQBgEumaI",
    "muxAssetId": "BMbZ003AE7f4EVtkBxfWnymeTQYadNDbnnS6BUKya7dE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 304,
    "title": "Full Court Passing Copy",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "KIO7jDwlXEgIHDQG1HXOhLOjBQa8vNoTRsaDnb0101B8A",
    "muxAssetId": "KK01A4XurGl6wdwedxkuuCk7fAo006hX94SywI8m700b4A",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 305,
    "title": "Full Court Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:32",
    "muxPlaybackId": "s3EVBBcEabunmUhWEwEMV6tY8cGgEp2oh9RL02300hN1E",
    "muxAssetId": "nlo3qvSqCKX5oslT0102wXwaO01XAyQHens7i01RN02D00eYQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 306,
    "title": "Gap Tag",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "3:37",
    "muxPlaybackId": "EnaEozTp7mv01PWqqpq8tBHKcrVUImlJ01o02TNTslQoRw",
    "muxAssetId": "AwGkBUWRFteETTqwLPo4Ryq00oCKEbCATXT01sGZq7NBU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 307,
    "title": "Handle Pressure And Seal Warmup",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:57",
    "muxPlaybackId": "l1800pI016mOcKSUtLk35V4a2ZmXWvymjwie8gTna020202I",
    "muxAssetId": "ddWAl00AkmF02boTmumh8ADML78mEeZg2YHDEQRTBXvPo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 308,
    "title": "High Speed Gets",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:44",
    "muxPlaybackId": "w7sFRPhH8QAbbE29s7ERJchcMzSoxGHD8R5HKKuaE8g",
    "muxAssetId": "JPzILxwWJxq3cH1gEu01suujJ2rsoWSNzlPmP3wjFTRE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 309,
    "title": "Inbounds 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "rjJfNMU6EZzJgNACmhgOsE3EZRa501ZsyXtiuC00keTJ00",
    "muxAssetId": "4rzYgYZNcxheOue4ZCHA1i9qvnrsrLaF5iXj7T6RpgM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 310,
    "title": "Inside The Paint 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "00HCbr99kWYvt7O7hlPoXyET01js4qDYwdE02Y32E62Eo4",
    "muxAssetId": "vDEy2RHS1NS9tUpWectrWj01015bSwTmkx99gVRH8G3qY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 311,
    "title": "Interchange 3v3 To Scramble",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "fWipTY6yR0159wig9OgmNFhKnwjbLHHssTk5DSkxhMME",
    "muxAssetId": "mhCBeAXHfaTn8izV005Oyx00xpiGx2StaxLNDMnc2tno4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 312,
    "title": "Kick To Relocate",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:25",
    "muxPlaybackId": "moLBRYgSDGOOijV4krJpmi6K6cqg5hHcca802a202ccOE",
    "muxAssetId": "GUrFh101CuD7DzLNx5sjCUR1GgQwu3hUo16EqwDaWHJE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 313,
    "title": "Large Group Domino Setup",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:48",
    "muxPlaybackId": "p5vGtmWzTjfAF101GQ6QZJTV801gKHPJhNFm00Rh02XqHnA",
    "muxAssetId": "I2R02sKDkwxCZYzJFcrSox9nvM7uZzAwgykJDLNKAN01M",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 314,
    "title": "Middle Drive 2v2 With Hook",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:16",
    "muxPlaybackId": "RawPgx5JZcYlECXp3pMhe0152kuyqRIuCoMn02k202xmHs",
    "muxAssetId": "M15WM602gEmfIphjHuc1GC01mzsL2DnDDYdr702wQtMLmU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 316,
    "title": "Passing Through Pressure",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "00kVvEdp4z5KnEiJTtE01r602ZoIweCntohj29PBWQYicc",
    "muxAssetId": "yZk3XIGuBkSKSZSzvme01dmJmE6qNXYQ2BmMYvvEbK1U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 317,
    "title": "Physicality Off Ball",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "A0101GX3xbcK02jLTUpymw1eU0002Aq00otHdZzRxdilqfess",
    "muxAssetId": "uKvxogMTGc6e01x5CWEbMT9xRQ01B5cdDPnL00yDFlMtxg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 318,
    "title": "Pig 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "htVOdiBKJoa7P01NIAcr84V7Wfx007KDtiFCh008yIkvyk",
    "muxAssetId": "iFpzWkzOkOZYQY5TeQLy4AvTKxTUkfyX55yLameEd00Y",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 320,
    "title": "Pnr 45 Read",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "gAU355uIT9KPRU2402IV2eNvCCXsAGwd00VkWOapmq00b8",
    "muxAssetId": "s8P7WnAmwlDWKGPAMZ5bZw5w3eAmAq02f3cYXQhuEQ1U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 321,
    "title": "Pre Cued Constraint 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:02",
    "muxPlaybackId": "DKcDP13lBoTRgvdJxXP8SWz3Per5OOf2k5ngykqiZn4",
    "muxAssetId": "DOQ6Tjgc02TGNsjOX8UuJqD00Tl1KYgmO6UzyJdoO3lTA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 322,
    "title": "Relaxation Hard Hedge Read",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:03",
    "muxPlaybackId": "a00q7WN8E9zXQCsVnkW3rhHKfbnpfKe02NoVftbAqnhUc",
    "muxAssetId": "EJLbUJT2Y7VKsLIW3Vis5khFpOZdoHLBdq2nK8rmEyQ",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 323,
    "title": "Relocation 2v1 Copy",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:12",
    "muxPlaybackId": "hdzuAnxlfGHW0102aHJ7Mxy00tc902sgGvvTRmpF02zOToRQ",
    "muxAssetId": "02FGER6CgGXH00UuJqo01e5UCccXruJTaXqSsivRAEywzI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 324,
    "title": "Relocation 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:12",
    "muxPlaybackId": "Tn7oC00PEMOkYA89IlrGcJuR6CSyr00w02oNdhcK2n0200ww",
    "muxAssetId": "U00znVnW02n101UrDijkZcDttupYtCMrfTBY3a5xOgm01wE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 325,
    "title": "Relocation To Play 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "ZZXGiGzXAIm4hTyqXfIalbEUc79zGO22Z02e9IV4T00rw",
    "muxAssetId": "xWWr02d5014fv600kncOMs23YYDodaedGWDtvPR01RA8mHA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 326,
    "title": "Scramble Advantage 4v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:07",
    "muxPlaybackId": "Tb02BNOlNEanR8xxGzA3qRzkLc2YQNMOLHUKP01rVBy7U",
    "muxAssetId": "WWHS6gO701288PjNugw026heNAgOyt4dUXQ6kFf3X7GQE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 327,
    "title": "Seal Drill",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:18",
    "muxPlaybackId": "Q5SGYbXWIzXJ7O8Ej3cLyYYFwMHk29RAbmWRge023Yg4",
    "muxAssetId": "MCt02De2ZnvsUDuNglPsKq01L8OGsFKeQqk2R7hNp4KxM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 328,
    "title": "Short Roll FIBA 4s",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:34",
    "muxPlaybackId": "DOTgZ6F3wTefkC6YZSWebe34c4k02OMAPYIuY02DtS0001o",
    "muxAssetId": "LdoTdBt00D401xLfGjSjl01PT02pyQrDS5wXAuBrDggTn02U",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 329,
    "title": "Split 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:01",
    "muxPlaybackId": "zB00MBshiiQdlmB8bCVxBotgiPr6GuOIiE6scPnP1UdY",
    "muxAssetId": "YRSay3XSV5AZuMDRKVrZfnvehLSojVjuyqrRh01DsIFI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 330,
    "title": "Stacking Triggers",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "3:10",
    "muxPlaybackId": "mkAyHLqDjvq5jorJUu02GpztNuaJsGCGBkOn44NMk7fQ",
    "muxAssetId": "y4EGsEDLRI2USR41HZxb2O4kq5eNVb6mkEf1Pd01Z8s00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 332,
    "title": "Taps W Defender",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:01",
    "muxPlaybackId": "2cJiboe5G02kysjZsYxvKGGhl6iMsfGx02h00pHt2Tghwg",
    "muxAssetId": "zLxVUjlNmumUOuxxQVb4SWn4eK8EtYLjH9wZAYkz401c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 333,
    "title": "To Half Court No Dribbles With Trap",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:46",
    "muxPlaybackId": "noHoT1X9Skc5WhHFkBvmVuXSFwfVedcLpxePNHihzPM",
    "muxAssetId": "02a4ydeZY00r00nk012uCV00K6EWaO9PfRqlDYfN4qTlpFpI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 334,
    "title": "Toss Back 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "IVldljx3vAZrAJ02bZMpN5nTefCjHSnrkDt1veKiAiVI",
    "muxAssetId": "lbMCYQ02ir2hao8pmjxQvn02YN500DWsDXNkVJKXcAlUtY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 335,
    "title": "Transition 2v2 Face Cut",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "HIN2UTeOn5j02bz01TGyQh9kkIdnO2NbCj23Dx8Qly2NM",
    "muxAssetId": "S854uQ2w00uR4aONwdg2RTyD4viSA5Bb3oLhWtGMRRPY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 336,
    "title": "Transition Runway Tag",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:50",
    "muxPlaybackId": "KxUmB7mNIaeFFz8AV0000B6r8j9SBHAdq01gXXSlpgp3Qs",
    "muxAssetId": "cX402vQGWqtIoQm9QgT8LEpmge02q7Plhg1cHRUBH8I00Q",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 337,
    "title": "Trap No Dribble To Score",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "yR3V95M8rA3xgEBDG64BUnG02ClG13GyrM1TFd7mdnRw",
    "muxAssetId": "S00BXSiijOPClfXl6WjaKTrrxepvR34ECDAr2SVM7ULs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 338,
    "title": "Trap Start Full Court",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "T2emrXRJXWaWGg8Je931R1501tZLwtFfyXjq9YFkW4zE",
    "muxAssetId": "W9nRciQeR9HmurEr4n8TaepjQVfeRgSHyH94d01ANLE8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 339,
    "title": "Turn To Scramble 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:22",
    "muxPlaybackId": "oB01Msd027yHbGv8ajHNeNsxXwFDess76FcXkg8g8VyLQ",
    "muxAssetId": "uVvnCnlkOyI4Oryk1dLkfS6Cfaisg1MSsMkZdOjf5iY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 340,
    "title": "Weakside Distraction 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:52",
    "muxPlaybackId": "w9ccK01NHVsbRoRPf5SIB4T7U5AHRtRUlFJg6f4KwyyA",
    "muxAssetId": "Wd7vzQqgqERDIjQ757LILKTdjRCc6dd53Pz16AEWUdU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 341,
    "title": "Wing Pass Back To 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:42",
    "muxPlaybackId": "hDhyqC02q6CpVE3bYDV6ql94UeFHUQ5WC7DM1GEII4Yo",
    "muxAssetId": "hoZ00vEW3HCQjmeo2tAPwWmaDgB9289D59FW1zZDEyMk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 342,
    "title": "Zoom Advantage Focused 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:28",
    "muxPlaybackId": "WV00qEzMqntTzB9r018UFzartmjuyz1C00g60087D6CeKkU",
    "muxAssetId": "zpRsbUEbEZNcZTYnURTtlkSQ2RVybbqXiauQ8GZBgxw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 402,
    "title": "2v2 Around Two Passing Warmup",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:05",
    "muxPlaybackId": "MK02lMY7eug4Yl00ZatccagqgQkr29u28Lv7WCWLfB502w",
    "muxAssetId": "K6lrX1RJRCOCpLexjxPe7vcqJSUkl3DG5hQQG7okQVE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 490,
    "title": "1v2 Give And Go",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:19",
    "muxPlaybackId": "01pYdRM00M102QddFRvnAMsQHZXjSRTbofU2GqguVZxJlo",
    "muxAssetId": "xaQy8E42ZBXjeMmftsDCBNNRSE8GG41ixg02ozLtIJEM",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 491,
    "title": "2 Ball 3v1 Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "H2o6oKzvj5NG944LgnT9SYFv02NO3QUkU68Iqm2C3CqQ",
    "muxAssetId": "L029aRR1ZdXO24scrzgVefj6OcI5fYAHRB02TfvR2Lyjw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 492,
    "title": "2 Part Relocation Series",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:41",
    "muxPlaybackId": "UePMAzQDRo021Rm9HtZZZxXsaQrbXeb6mkTY02nxxqI68",
    "muxAssetId": "HvzDI6qqSSw00X6JXm1A7xT015jYR02h5ARIyXnUkvJJNI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 493,
    "title": "2v1 Attack With Point Incentives",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "v4KgiMhTsMByK8xjBeVOEioMZzUt1D8Ict1VjHbm2CI",
    "muxAssetId": "9ATGSu641MWB7H2U00YG4uiNDKxfotbDittMy5wh8FKY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 494,
    "title": "2v1 Cutting",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:35",
    "muxPlaybackId": "800lif2HPhdjlS8FnqOUJKlFgcj6RrYxo92tx4ZQMePg",
    "muxAssetId": "HgEdiIejAwmfsnosKLuMW5BB24b1yRXb7s2qszfy11c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 495,
    "title": "2v1 Pindown Intro",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:43",
    "muxPlaybackId": "8R01MPovg3A2nBY01rjPPWad02MXFdzdK4bVrVOVRI2t1w",
    "muxAssetId": "NW6FfSjmCGHFGGe1UEyIn7iL00MTh8fcNPmhoOPqMPpU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 496,
    "title": "2v1 Recover Closeout",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:52",
    "muxPlaybackId": "lTIdmGQlhQeQWeF6mRmsT7SR3psqApmG1qTAa3FR7Qw",
    "muxAssetId": "JjvOK00v01NgpusTjBUEOTFCW5jYqn19cO4iSoTR8JeBU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 497,
    "title": "3v2 Chasedown Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:44",
    "muxPlaybackId": "aZMGRexZhgEzmpHMRfHWPSrv46BMdApDJn58RpNzPOI",
    "muxAssetId": "H1LX5yKtkEDIloN2NtZoV02n02M9hnRC029vV4RCtJbhT00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 498,
    "title": "3x3 Cut Constraint",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "2:02",
    "muxPlaybackId": "Q2bbbgSuGlZ4Zh01JIIh02902wECvC4gKM02eycepZvQYYM",
    "muxAssetId": "QHzCgeUpKovf7h6026j7Px9li02b7c02Zg5TRD9DSBSFC4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 499,
    "title": "Approach Downhill Decision Making",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:39",
    "muxPlaybackId": "z005VubLe02Vj1HwPq3oHpi4PqIX5qasMVN61wAPrunPQ",
    "muxAssetId": "OIHRbRaRtV00BVFadB83btC54YO7IMNk8GZp7xzfH8Ww",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 500,
    "title": "Controlling Pressure 2v2",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:56",
    "muxPlaybackId": "Km2LfS8ZiooaI5oUXN1tBUbhZZ9RX8I00BwgNe02vYhtI",
    "muxAssetId": "3qDEs02np7zHOE46LA7Ns7L4N8sqngmaYHZcmb012JzW8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 501,
    "title": "Drag Screen 3v3 Intro",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:12",
    "muxPlaybackId": "n82YBUFWX2Jj00YB01cded3mtyitvXa93jFE19uKTrUSY",
    "muxAssetId": "qgCxN02GswLT2n01EBYkY38nXsh7kEet003feQDIItPvlU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 502,
    "title": "Exit Screen Double Live Game",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:47",
    "muxPlaybackId": "S01yBQmDSW5Jv5Pt4c9Kevgq02qfOUB6WKKHZ199qNlo00",
    "muxAssetId": "cdeoEB00yu4F3ZO8Hh55Dfd1Q007jO3WW4IagUtTkrGiU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 503,
    "title": "Hot Potato Warmup",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "Zxebm015vBJgBhq34NMd9aalh7cuAXTRu1SFXQTIfL00A",
    "muxAssetId": "fBirDFw01n8CERNxaqsF1e5Tjtt8YY3w85ODrjBKjUKo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 504,
    "title": "Lift PnR 2v1",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:28",
    "muxPlaybackId": "CLqQZ1ACVp02zkGGav85pesJguQOQYtqdqKLLz9uLwoE",
    "muxAssetId": "FR00onZGy69j2E02p26TTck6AoyKbmAgvAybXlkPd25Ps",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 505,
    "title": "Scoring With Gets Itro",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "3:35",
    "muxPlaybackId": "470101NmAr8ZqRofL8cQVzjC8Re02OA01PgkpiAqotmoKb8",
    "muxAssetId": "uq00EwCW7wzSxC8MKMQsxeBhuuD4pXA8vSj66uFSPuoI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 507,
    "title": "Silent Assassin",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "1:36",
    "muxPlaybackId": "u7GM01h01uKugMNwfpbP3RHr201nZTDEUAZEY01EV1682r4",
    "muxAssetId": "AT3SYAF9cl1EBLyl6KAt6L2oQGx8ohilXzJ1XBjNWT8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 508,
    "title": "Simultaneous Passing W Defense",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:57",
    "muxPlaybackId": "WbpckQm00d7iUEfCix5Bk00fcrLLqHPyEWcXSOednY01lw",
    "muxAssetId": "jwwDHSZxhwNBu7cv9xz6Lkh4RGExLhzjBFPrKs2FYA00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 509,
    "title": "Single Hand 1 Dribble Passing",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:58",
    "muxPlaybackId": "mrm9tSBAEaRSZjHtDxRw6trSef7S19n8TtEi8008N7tE",
    "muxAssetId": "Y402B9xIbfPmsMt7tTyj02KA6mLy3zzRKuRdEx6Nq6ldA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 510,
    "title": "Tight Space 3v3",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:40",
    "muxPlaybackId": "EBPGS2w00v4Po8xDj02eWv9n4IDwXQvd00eDzeaimqoVQQ",
    "muxAssetId": "sikXxgC600YcuFGuy4JyoaVI5vf01Z1PGcNdsog4PF2gU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 511,
    "title": "Turn To Pass Or Finish",
    "category": "Tactical & Passing",
    "level": "All Levels",
    "duration": "0:38",
    "muxPlaybackId": "6YN3Ny200HpP2466b3ahndl4b9U6VStnA6WwTVKFeens",
    "muxAssetId": "gLkvdPHmMYIY3zFOtZ85s68AtW6MiLRzhQyluogGGwY",
    "isNew": false,
    "publishAt": null
  }
];

export const INSIGHTS_ITEMS = [];

export const TEAM_INSIGHTS_ITEMS = [];

export const XO_ITEMS = [];

export const PLANS_ITEMS = [];

export const MOVEMENT_ITEMS = [
  {
    "id": 403,
    "title": "360 Spin Single Leg Landing",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:10",
    "muxPlaybackId": "KMR3jsPrVoV11CFBVuILMG02g01Hoj8JWBnDe02wPbId3Q",
    "muxAssetId": "f67zT7ez8XjrGx3maIJSDaGtqxA1LvYQadoZXZKyjHY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 404,
    "title": "Backpedal To Sprint Race",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:09",
    "muxPlaybackId": "Vs2qT4q6HIg026hGvY11utUbgb6haPR6eM02oVozZ5rmk",
    "muxAssetId": "fjtBUGPJ2oWaXKKrZC02iytRQnSAe4gkzioSeCVbJwXE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 405,
    "title": "Backwards Broads",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:10",
    "muxPlaybackId": "Xg7mkBpXqkj02UmfjgTBNvN00CprYBTeYDLzK00BP02t55Y",
    "muxAssetId": "jgpgb01Oc2Nzlh3ej2qyqq4Mpdj1SZbd3BMibo4WjfAc",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 406,
    "title": "Creative Drop Jumps",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "3kjmM1IGUCxg00iS4lxGounhZGXWozEtQH01I4uKlLnhw",
    "muxAssetId": "g3JhpMBp5p02hX3qwJlndZH6fNH16cfRnQ7A101xODe00c",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 407,
    "title": "Curvilinear Race Start Variations",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "tH4dMJ02NouaXZnfoPcoWk9yhHJBSie7suC02RRqiIiuM",
    "muxAssetId": "Pat00afqej5EOVohGKI1sbpnsHmCAhJqwBmUZMAaqbWw",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 408,
    "title": "Decreasing Limbo Mobility",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "7dZV6bcepv3qlZIw00JHgjxGXtLQ009uqTun8N1900rGPI",
    "muxAssetId": "jG01L9K024G8k01gYGmRIVBhKQlIvyV7AuOBoXf2UbHGzs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 409,
    "title": "Football Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:12",
    "muxPlaybackId": "vE3S39AWgaVxCSnOot5apVjQA01t02tpXT02JoBr00DSViQ",
    "muxAssetId": "JaYcYGdEdfKfbhMyeCvLSkX6IOj9mz01eJxYTci2rH2A",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 410,
    "title": "High Push Landings",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:11",
    "muxPlaybackId": "qlCX01EhA9vT02cfcrLSaz6cvMYBT9bJK01NxOej5l6006A",
    "muxAssetId": "Bqw1E3q4WldN27GksjZ8b5g4ZjLHERvSmcBW9c21KvI",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 411,
    "title": "Hop Mirror Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:07",
    "muxPlaybackId": "J1myvTlTrWo1CDHwGtMgT9Epgwsct6j9TRGEsYNIhDk",
    "muxAssetId": "z1IgvbBNhPJcpkEdi00pPhDFQ4901nuu3It5q1z8WHw18",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 412,
    "title": "Jumping Obstacle Course",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "rPMZsnK2UkGiUOW41IK2qEDSAgv8xR8OHKMKWb02CuNc",
    "muxAssetId": "j3hM62iyHcyQzFU8W6doDf00rjubZA01016UVmric9asHo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 413,
    "title": "Kneeling Start Mirror",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "43oakaLReO6ZfpmA00w8mmolzNrmJRaRsUStgwFq4dWI",
    "muxAssetId": "9i7Fd02qBLgN701Umn01zKhhy02ONvoAe7ErXrlpNhpR3NU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 414,
    "title": "Lateral Coordination Mirror Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:39",
    "muxPlaybackId": "NYZPAHkipfah01rSYyt200yLEsLaWZKfHaWrdlnPSwywY",
    "muxAssetId": "ZBVpHcs61VofV325JL00U1wbilD9HG3fGJx1zO1H7dJ00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 415,
    "title": "Lunging Overhead Push",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:11",
    "muxPlaybackId": "bj1m1RQ9I200wZplphTy00c1ftWBzWyNJIVyb0201lxNOUc",
    "muxAssetId": "VS8GTGuIRdTu1JO602oQIlbSzsdWZWChoiGb5SeIUbqs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 416,
    "title": "Manual Lunge Pull And Push Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "8sMfLik21Ro02XLc6yyJzzf8spWy5nc7KJJPquMqI8UQ",
    "muxAssetId": "wv1F374ntlI02VXV4ungAqrjOhOQb9DVazAxuPA8B008g",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 417,
    "title": "Med Ball Core Stability Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:12",
    "muxPlaybackId": "2raKeXkhKnFiq4ONHeP02MyCuyWrsXU4XHVXzaYOLKhs",
    "muxAssetId": "QLEiz2R7q01pbHSCzI101txst018g202sVB1TstQuBc4XEs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 418,
    "title": "Over Hurdle Quick Accel",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:13",
    "muxPlaybackId": "LsjocdSd1knYdXAPeXjC17rFe7McKS7lAJ8qrUdM7HY",
    "muxAssetId": "TxAkiwTIHZvNZW1ugXNvAy1xqk1oqvYvr2k9zs6016d4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 419,
    "title": "Plank Shoulder Tag",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:18",
    "muxPlaybackId": "02V1W86SLw3CKyY5kRwJrVbU2b1B5FEMHlcj79jfW00xU",
    "muxAssetId": "i8vCMxCqCGLJjvdZRLDmeseyT3Se1HkYQa3i8T2TlbU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 420,
    "title": "Purposeful Fall Landings",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:16",
    "muxPlaybackId": "fLF5nTb5jiDY6aekuO4xONIhBaqbwi7Ifdsm9pIfErc",
    "muxAssetId": "6xWlP9OHBYtxmACCJW5KUlTJUiNLSbd2TFuYTtPtNm00",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 421,
    "title": "Push Fun Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:19",
    "muxPlaybackId": "W9G23hvKOKCKXI0156ScmCXJRD01BYu7Fj4uYOInD00Dqo",
    "muxAssetId": "XnMgGpu0111WeVmf1fU2yxvRdvWvkjXLj02VsQloGka3Y",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 422,
    "title": "Reactive Hop Plyo",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "m4KXU38p4023jDcD5PAyQVS9NvIxNxFJmYekmxeSrH3Y",
    "muxAssetId": "dMx009XDILkvXBhlWMjQa7RYXx4L19S00d01JnrITgT3jU",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 423,
    "title": "Rotation Move Partner Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "1:00",
    "muxPlaybackId": "DzxIZet5sZ43n8iUyMw2Le00U1jfSaNfD4s02J8pPhrRI",
    "muxAssetId": "Z7HPLDz1yTrwTWDMWxrT6XBAHpedGbvD9Rc7tcuzSAo",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 424,
    "title": "SL Stance Handslap Stability",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "VWCpfSWHU2DaN5AplnAaBa6iqL3rmv5nLMOx8dp02A9Y",
    "muxAssetId": "fFgGx3101d02WbhVcBSxgcaZs5jyUHkCo9ByTancVkCQA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 425,
    "title": "Squat Walk Battle",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:25",
    "muxPlaybackId": "01ZJBgGN02moQco7UgVlrhO1yLB00cjHNIknhG01rWnQF8s",
    "muxAssetId": "c6HPndSOIzXOpzVwhPJ012X3ogGMmaFxWI6wq1Z4UEzs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 426,
    "title": "Stationary Arm Battle Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "1:32",
    "muxPlaybackId": "btfa7IMgobYaq4vt2T801pxBoZkZWGsSDckdxYIoVAoU",
    "muxAssetId": "vVMpuxEyWBkLjz00zXIOGWv01jekrCs02tiWElN4MXeemA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 427,
    "title": "Stay Centered Manual Pushes",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "7iFD88Xlnao81OqRvmTsbkToYUMNuXIILVEXVD5go94",
    "muxAssetId": "elRVadVBPbaKOSK9gpVMOWs9eGKmsQEogYVxJ100ECxE",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 428,
    "title": "Tight Curve Sprint",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:30",
    "muxPlaybackId": "lBPiP28FE9ClJ01GWoQbnotz1hXt02pmuX5oGlUxon02YU",
    "muxAssetId": "sdxUzc4q7JUqZ02XuPykxhGFzvv9bnYS4mlAIivP5MK4",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 555,
    "title": "Alley Push Outside The Paint",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "tKcBBqtPpKxUqdRVxEfJstf1PnjNXObTclmdaN6Uc014",
    "muxAssetId": "sFx0153ZHI9u6iQ6OiJgzDEiHZLOvYAYNro2fB91ToUA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 556,
    "title": "Boxing Warmups",
    "category": "Development",
    "level": "All Levels",
    "duration": "1:06",
    "muxPlaybackId": "hFwSzk94lwprXJbhUfyb01iAHYbRWW3B01y82McdpjUi8",
    "muxAssetId": "SaZ8qIc4Osqq43yuWD01fEFRr8L6MLHFAoEj1VHKSOyk",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 557,
    "title": "Broad Jump Dunks",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "7b6an419nVxlI5ZgmXpMDyl8y7d2OH02UYqgeDGrVjnM",
    "muxAssetId": "02RYqrEjuD02pxc9TvjjLqpRdCI52b4021q4Fp88wbQU7k",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 558,
    "title": "Choose Your Physicality Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "2:33",
    "muxPlaybackId": "tO7Uagzq3q5BDvb00c1kjTPJ8HWOOI02Jt2plUXDMXZtM",
    "muxAssetId": "02ILHtR5EVDVrdZ3ZQoV73a66nkF00WiqE2TxuONHm6Ys",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 559,
    "title": "Circle Physicality Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:10",
    "muxPlaybackId": "BLpLmc2GYQ00vMEutuWSFV01nryZEaLRd1OD4thZ5FL00M",
    "muxAssetId": "H4NrhI1DWYlt01fT33hjBKjLPWX4nhYozy9L6nTFozas",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 561,
    "title": "Deep Tier Ground Touch",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:14",
    "muxPlaybackId": "BfFyOzm00D01obhHwonoWw01Jai01miW75AWsOD16PFCg5o",
    "muxAssetId": "P02cBjYEj44koH2YsOYa02K5A2xNH9qMetM2EfGeow5h8",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 562,
    "title": "Get Up And Go Race To Rim",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:11",
    "muxPlaybackId": "Cf79lFWhQTaLZHTw00DTa92WgX00siyeNGfI4Qq00mGEMc",
    "muxAssetId": "00HjJh5hmXaNMYzjx00nQQnLP7fCPiiuKTJ004wfNRUYFg",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 563,
    "title": "Ground Based Evasion Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:26",
    "muxPlaybackId": "A4CzDB8KKiyUz02bO7X9IuWQtQxEs4sqwcFoX8XlHyDI",
    "muxAssetId": "01a6bUvI5NV6gfdf4c02aCGEQEYCV4wbvnnuZUb3b3dIY",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 564,
    "title": "High Low Problem Solving",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:29",
    "muxPlaybackId": "LZHR00REk00tC89I01niUzXeNElcFRD5Ky02uHoy1tw02mts",
    "muxAssetId": "Jw5r025mi7dSuQc02CPmLytbAvXlC8qmtENSH2aIEeGOs",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 565,
    "title": "Hurdle Races",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:13",
    "muxPlaybackId": "mG4Fjp02xY9qWidPGpnRnirG8poxN5uMSBRqgLm01rjQY",
    "muxAssetId": "00Xaz00h7LyxN6WAlJO25j01A2N4IVHvDrUMZhCdlh33ks",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 566,
    "title": "Lunging Dowel Rod Fight",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "SVmvp91Yc01Y5aL2Od5mkK00O02W8XdvY7NNcPd016D38DA",
    "muxAssetId": "LkKWTByYRFcZHFFlnLM01ACAKNjFRpyyqcGwnJtvVRdA",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 567,
    "title": "Med Ball Stability Tosses",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:09",
    "muxPlaybackId": "Jq6kHXQhT9kyiNei01x2tYHTOC7WsFa8TiSNGIXtThY8",
    "muxAssetId": "ruoQH5tXWzoryc01V9EkZdDt5efHJo6vNTSatk85YH01I",
    "isNew": false,
    "publishAt": null
  },
  {
    "id": 568,
    "title": "Mid Air Push Landings",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "pXbU7Exv6xl00NK5QIOrJ3IDkwgVsM5004OrzK3utOf9A",
    "muxAssetId": "013iIT5O9QfLIiQ01pl6b9JL1aAr3podbSWkZsMNKdOTo",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 569,
    "title": "Mirror Mobility",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:13",
    "muxPlaybackId": "7pGE4i01BT2vtltO55IzbTUMVhVG5so6FiMTLmW001Dq8",
    "muxAssetId": "5G801ssxjDg32aLF5cnk9tkJZDiA5d8q02ZR6Llc4FLFE",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 570,
    "title": "Over Under Warmup",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:14",
    "muxPlaybackId": "9y9EmxZW153jdEH01op01l2x027JaywvWqNQ01QD1sPS2JU",
    "muxAssetId": "mYWrrXSRTkia3dyDyLe2iJCn4g00bXzwwL4hiKJJqrx00",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 571,
    "title": "Partner Assisted Squat",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:09",
    "muxPlaybackId": "g01KTQKd003mFkFATusDqTGtIMGzuFMn0202LMUBsVkw6Xw",
    "muxAssetId": "DjMpI4mQ3sci9YGKCVHz02yjtio02OW3BkgY1qghtmIIU",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 572,
    "title": "Pivot Foot Battle",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:21",
    "muxPlaybackId": "chI3mU8V1jZoKXYjG3Dv47CkI5iSCr01fRPcx9cC402uc",
    "muxAssetId": "GO3MlX6WdyRG00xw3LJ00bciAMOFdmqkSVj6hX2723HK4",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 573,
    "title": "Push Dunks",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:27",
    "muxPlaybackId": "YOr02w8jbtqZw7tsIvmuR1yldjHGzkwz500h4TmdMvAUw",
    "muxAssetId": "cELklySfYGSaoixZNMYQOBWTr02bLx65RcEgadPxqUTs",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 574,
    "title": "Quadruped Body Battle",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:17",
    "muxPlaybackId": "emqRW5z9M1BLR0202IUGuHWJ2iUZlTEXB02n2Ms84qOHps",
    "muxAssetId": "uTyWYJhWWyiWe32yLnBJGrusahHAUn89DYXJD01maPmY",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 575,
    "title": "Race To Corner Variations",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:23",
    "muxPlaybackId": "EOeOjUbTXL00S9602FGGtYvH4clsB7KIYNJsj4ROgapKc",
    "muxAssetId": "KH7cmzRXRJ1kheIwcNF3Szb1KET0200pROWrRIop014bI00",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 576,
    "title": "Reactive First Step Series",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:55",
    "muxPlaybackId": "iYdy3p4pad2qWY902B5BqOafQAKoHVzW7gvDW00ViTzCI",
    "muxAssetId": "ap2a02Ao4GrTePXoh00PGpddUowgtd44SVdanF464MhJU",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 577,
    "title": "SL Bound Races",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:20",
    "muxPlaybackId": "Km9d97j01gdLGE9DRwEDwjGmXpWpY8E2c75qFZUvf628",
    "muxAssetId": "pEBQ1iggwl1vw00aWyQcekQbba9jywB01BMOaieXuZ5dc",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 578,
    "title": "Squat Walks",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:08",
    "muxPlaybackId": "ID02j5RHyN6mA4PCCfsnbUnjnYEbH8ojWOCMfigG9xxg",
    "muxAssetId": "c41LeGbxiGk4Asjjnvtm4PvUcZ01wDbAEi8DWOBqkGdY",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 579,
    "title": "Stability Basketball Pushes",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:13",
    "muxPlaybackId": "cIJQskcZb5kZPZuvnFgnsPK2GMcD9ntRy236Jr4nOR4",
    "muxAssetId": "jiaJeF9GH8Wl43z3nC5HldpDEKUiSIEsw7zQN3lpGJs",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 580,
    "title": "Under Hurdle To Rim",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:09",
    "muxPlaybackId": "EXNy62xl8Vtu9MufczuwW00ZokKzGq871CGPmahdsQ2U",
    "muxAssetId": "J5PQ1FWH4IT005IHw9MGBNfFzb2MjlVCBs8ikSuSZ5g8",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 581,
    "title": "Variable Distance Broad Jumps",
    "category": "Development",
    "level": "All Levels",
    "duration": "0:31",
    "muxPlaybackId": "M00TF2ow5jI9Amn7aglQDUev02FgqgqdnfJzXe6dCHebI",
    "muxAssetId": "J2fN01d9W2MJoxWIcym02RWu01rdcgSgRoMJ7tHGQOb1I8",
    "isNew": true,
    "publishAt": null
  }
];

export const WORKOUTS_ITEMS = [
  {
    "id": 637,
    "title": "Group Defense Workout  High School",
    "category": "Group",
    "level": "All Levels",
    "duration": "6:45",
    "muxPlaybackId": "nhnowdZE8Zrvs6sxD004SJDyo2xRRHvHT0100aft4SZJ02A",
    "muxAssetId": "kSEyntpbjX010029nPKLnv02EkuLzsKOzp01BUIx8L4J300s",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 638,
    "title": "Two Person Overall Workout  High School Level",
    "category": "Group",
    "level": "All Levels",
    "duration": "9:51",
    "muxPlaybackId": "79gBr89KCVrX9At901vs2dqmZVGMhHz7G5zvU8VPTAjM",
    "muxAssetId": "Q7vrcXN8ceR2MtDET2mJPJXrfHp53Crp4qnjUuEEA4E",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 639,
    "title": "Individual Athletic Shooting Workout  High School Level",
    "category": "Individual",
    "level": "All Levels",
    "duration": "4:22",
    "muxPlaybackId": "8WZuJP5W6cLlX2Ti3r6ZPVifroGUpZqUKGk455RXhuA",
    "muxAssetId": "H94NQFmvPpZniuo79VgzMxqDqwBR00M01GTcRP6MLjx4k",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 640,
    "title": "Individual Dynamic Shooting Workout  College",
    "category": "Individual",
    "level": "All Levels",
    "duration": "14:41",
    "muxPlaybackId": "Uy3uaD021XNGBPwd500A4Y02l1NPvDSHCe4JmIwmHTDlJ8",
    "muxAssetId": "700HWaxCSar24qQeDQNztuFuRu1tR2sE101OKB5zVYUQs",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 641,
    "title": "Individual Finishing Workout  High School Level",
    "category": "Individual",
    "level": "All Levels",
    "duration": "23:46",
    "muxPlaybackId": "AaqIFjDMijRJ02sU015XIvhccb02t16LV0001lLUROVK4Uzs",
    "muxAssetId": "hmbncO01nmXNEAtsuX6GmqSojY02xHn00HpjJQH9G6pybQ",
    "isNew": true,
    "publishAt": null
  },
  {
    "id": 642,
    "title": "Intro To How To Train Shooting  All Ages",
    "category": "Individual",
    "level": "All Levels",
    "duration": "22:17",
    "muxPlaybackId": "kpCSgwG74WJaZaQqvWaZD02z8R00KupWu00QZRtZiardyQ",
    "muxAssetId": "eM02kx01W5G01hOqoBDVuYf28LLFNMZNjuS7QQuEYG00wH8",
    "isNew": true,
    "publishAt": null
  }
];

export const MASTER_ITEMS = [
  {
    // Six two-foot finishing drills as a mini module. Built from the drill
    // transcripts; the drills themselves are referenced by title through
    // `drillCollection`, so they play inside the reader without needing to
    // be published into Drills & Games first.
    //
    // Live again 2026-10-21 (Coleman: "let's make it live"), after the
    // Explore, Add, Test rewrite. It was held behind comingSoon from
    // 2026-10-04 while that was worked out.
    id: 9012,
    type: "module",
    moduleKey: "two-feet-on-the-move",
    title: "Introducing Two-Foot Finishes Through Small-Sided Games",
    sub: "Explore. Add. Test. A simple approach to developing two-foot finishing through small-sided games.",
    desc: "Developing two-foot finishing is about much more than a jump stop. Explore what players can already find, Add new strategies and movement options (timing and deception, speed, acrobatic finishes), then Test whether they can select and execute them when winning matters, using Require, Reward, Remove. Three training intentions to move between, not levels to pass.",
    tag: "Player Development",
    level: "All",
    duration: "10 drills",
    // A frame of Hands on Hips Two-Foot Sparring (a finish at the rim), from its Mux video.
    thumb: "https://image.mux.com/HXXVMcP5pxlIJwATaS86z025h00gCPSRsRXB9UodNdYIg/thumbnail.jpg?width=640&time=4",
    keyPoints: [
      "Simple jumpstops are great, but they are not enough. Jumping in-stride is the level above.",
      "Explore, Add, Test: three training intentions to move between, not levels to pass.",
      "Explore first and do not coach much, so you can see what they avoid and what they reach for.",
      "Handicap the defense on purpose so the offense reliably reaches the situation you want them solving.",
      "Score the thing you want to see: a point when the defense leaves the floor first.",
    ],
    isNew: true,
    date_added: "2026-09-30T12:00:00Z",
  },
  {
    // Members only, and released to every coach on 2026-10-05. It sat behind
    // `comingSoon` while the copy was being rewritten, which showed everyone a
    // locked Coming Soon card and let allowlisted admins preview the reader.
    // To pull it back, re-add `comingSoon: true`, or schedule a future release
    // with `availableAt: "<ISO>"`.
    //
    // Separate from "The Art of Passing" on purpose. That one is the whole
    // skill as a perception-action loop; this one goes deep on one part of it
    // and shares no copy, no graphics and no components with it.
    //
    // `thumb` is only the fallback: the module sets `coverVideoId`, so the
    // card pulls a real frame from that clip (see masterclass/coverArt.js).
    id: 9013,
    type: "module",
    moduleKey: "passing-accuracy",
    // Renamed 2026-10-05. The moduleKey stays passing-accuracy: it keys every
    // coach's progress and saved answers in localStorage, so renaming it would
    // orphan all of it for no gain.
    title: "Building Precise Passers: A Deep Dive",
    sub: "Where the ball arrives decides what your teammate can do next. The eight things that break passing accuracy, and the six ways to build it back.",
    desc: "A members-only masterclass on the part of passing that actually changes a teammate's next action: where the ball arrives. Starts with the strike zone and why a catchable pass can still cost a shooter a move, then works through the eight factors that break accuracy in games, from the two defenders and the two kinds of movement to unpredictability, the pickup, the eyes and fatigue. Then six pillars for building it, including how to get hundreds of extra passing reps out of shooting drills you already run.",
    // Team Coaching rather than Player Development: the piece is about what
    // a pass does to the next action, which is a team problem.
    tag: "Team Coaching",
    level: "All",
    duration: "~30 min read · 22 clips",
    thumb: "/images/mc-art-passing.svg",
    keyPoints: [
      "A catchable pass can still be a bad one: it costs the receiver a move before they can shoot.",
      "Accuracy is not accuracy of movement, it is accuracy under changing information.",
      "Eight factors break it: two defenders, two kinds of movement, unpredictability, the pickup, the eyes, fatigue.",
      "Leading a moving target is a timing problem. Passing on the move is a body problem. Same missed pass, opposite fix.",
      "Release point and ball path are two choices, so train the grid rather than a handful of named passes.",
      "Judge the arrival, not the catch. Those two standards produce completely different practices.",
    ],
    isNew: true,
    date_added: "2026-10-05T12:00:00Z",
  },
  {
    // Members only. No `free`/`publicSlug`, so it stays behind the member
    // dashboard. Graphics-forward: the whole masterclass is organized around
    // the perception-action passing LOOP (see it, choose it, deliver it, keep
    // it sharp), with a hand-drawn SVG panel in nearly every subcategory
    // (PassingGraphics.jsx).
    // NOTE: thumb reuses the point-guard cover as the closest-fit placeholder
    // until a passing cover art is made.
    id: 9011,
    type: "module",
    moduleKey: "the-art-of-passing",
    // Off the shelf, 2026-10-04. Passing Accuracy covers this ground more
    // precisely, and two passing masterclasses with the same cover art was
    // the shelf's problem rather than its offer. Shelved rather than
    // deleted: the card copy, the key points and passingModule.js are all
    // intact, so putting it back is removing this one line.
    shelved: true,
    // Private / coming soon, no release date set yet. Everyone sees a
    // "Coming Soon" card (no countdown, no date) and cannot open it;
    // allowlisted admins (ADMIN_BETA_ALLOWLIST) bypass and preview the
    // reader now. When ready to ship, remove `comingSoon` (drops live) or
    // swap it for `availableAt: "<ISO>"` to schedule a dated drop.
    comingSoon: true,
    title: "The Art of Passing",
    sub: "Passing is not a throw, it is the end of a read. The whole skill broken into one loop you can see, choose, and deliver, with a graphic for nearly every idea.",
    desc: "A members-only masterclass that treats passing as a perception-action loop instead of a throw. See it: vision, fast and slow reads, timing, reading momentum and coverages. Choose it: the look-off vs the no-look, scoring gravity, and releasing on time before the window closes. Deliver it: the full vocabulary, touch, spin off the floor, cancelling your own momentum, power from the ground, and creating the lane. Then how to keep the whole loop sharp. Illustrated throughout.",
    tag: "Player Development",
    level: "All",
    duration: "~35 min read",
    thumb: "/images/mc-art-passing.svg",
    keyPoints: [
      "Passing is a loop: see it, choose it, deliver it, and the pass opens the next window.",
      "See it: soft eyes and wide periphery, the fast read fed by the slow read, and reading momentum to tell a stunt from a real commit.",
      "Choose it: the look-off that moves a defender vs the no-look that only decorates, plus releasing on time before the window closes.",
      "Deliver it: a real vocabulary, touch as perceive-then-place, cancelling your own drift, and power from the ground up.",
      "Keep it sharp: touch erodes and calibrates fast, so train the loop inside live reads, not on air.",
    ],
    isNew: true,
    date_added: "2026-07-24T12:00:00Z",
  },
  {
    // Members only, drops July 3. Talk-style masterclass with the time-synced
    // videoLessons player (video + lessons that follow along). Allowlisted
    // admins bypass the date gate. No program/player names per privacy.
    id: 9010,
    type: "module",
    moduleKey: "let-the-task-teach",
    availableAt: "2026-07-03T13:00:00Z",
    title: "Let the Task Do the Teaching",
    sub: "A live talk to a Division I women's program on the constraints-led approach: building problem solvers by letting the game teach the skill.",
    desc: "A 38-minute talk on the constraints-led approach, presented live to a Division I women's program, with time-synced lessons that follow along as you watch. Covers the three signs of a good practice (dosage, driver, distribution), designing games so the lesson is the easiest way to win, reading individual constraints, implicit learning and the 20 percent rule, IQ versus feel, the development ladder and the 40 to 60 percent zone, and four ways to constrain the defense.",
    tag: "Coaching Concepts",
    level: "All",
    duration: "38 min + lessons",
    thumb: "/images/mc-art-task.svg",
    keyPoints: [
      "The three signs of a good practice: dosage, driver, distribution.",
      "Design the game so the skill is the easiest way to win.",
      "Build problem solvers, not solution reciters.",
      "Implicit learning and the 20 percent rule: hold your tongue two reps longer.",
      "Four ways to constrain the defense, the hardest side to coach.",
    ],
    isNew: true,
    date_added: "2026-07-03T13:00:00Z",
  },
  {
    // Members only. No `free`/`publicSlug`, so it stays behind the member
    // dashboard. Graphics-forward: the four balance jobs, the stability dial
    // map, and the specific-to-general spectrum bar. Video slots fill in
    // when the clips land.
    id: 9009,
    type: "module",
    moduleKey: "balance-and-shooting",
    // Released 2026-06-29 and live to every coach since. The `availableAt`
    // that held it back is removed rather than left to sit in the past,
    // where it reads like a gate that is still doing something.
    title: "All About Balance Shooting",
    sub: "Widening what balance means for a shooter, so you train the part that actually shows up in a game.",
    desc: "A members-only shooting masterclass on balance. It widens the definition past standing still, sorts real balance work from decoration, breaks balance into the four jobs a shooter has to do, and shows how to train them with the stability dial. Plus how to read drifts and the physical qualities underneath it all, including the spatial sense that ties them together. Illustrated throughout.",
    tag: "Player Development",
    level: "All",
    duration: "~30 min read",
    thumb: "/images/mc-art-balance.svg",
    keyPoints: [
      "A working definition of balance built around launching a shot that holds together.",
      "The two filters that separate real balance work from decoration.",
      "The four balance jobs: find it, hold it, shoot without it, give it up on purpose.",
      "The stability dial: difficulty crossed with explore vs anchor.",
      "Reading drifts by the upper body, and the physical qualities underneath it all.",
    ],
    isNew: true,
    date_added: "2026-06-28T12:00:00Z",
  },
  {
    id: 9008,
    type: "module",
    moduleKey: "rethinking-the-warmup",
    free: true,
    publicSlug: "tyler-clark",
    title: "Rethinking the Warm-Up",
    sub: "Coach Tyler Clark on turning the warm-up into a tool for connection, readiness, and culture.",
    desc: "A free clinic from Coach Tyler Clark at the San Diego retreat. He runs a traditional warm-up, then a connection-based one, and lets the room feel the difference. Covers contact and trust, competitive and reactive prep, matching the warm-up to the day, designing within your constraints, and using the warm-up to build culture. The full clinic plus 8 lesson cards.",
    tag: "Coaching Concepts",
    level: "All",
    duration: "Full clinic",
    thumb: "/images/mc-art-warmup.svg",
    keyPoints: [
      "Why the warm-up is doing more than physical prep.",
      "Contact builds trust: the free-throw study, and how to engineer it.",
      "Make it competitive and reactive to wake up the brain.",
      "Match the warm-up to the day, high or low.",
      "Build a great warm-up in any space, with any constraints.",
    ],
    isNew: true,
    date_added: "2026-06-03T12:00:00Z",
  },
  {
    id: 9006,
    type: "module",
    moduleKey: "science-in-practice",
    title: "Showing the Science in Practice",
    sub: "A live clinic on how skill acquisition actually looks on the court, not the way it reads in a textbook.",
    desc: "Filmed live at the San Diego retreat. A walk through how skill acquisition actually looks on the court: the study of transfer, the general to specific spectrum, situations to decisions to skills, whole-part-whole, setting constraints instead of cues, and the lens of affordances. The full session plus 10 lesson cards that pull the ideas out in order.",
    tag: "Coaching Concepts",
    level: "All",
    duration: "1h 13min",
    thumb: "/images/mc-art-science.svg",
    keyPoints: [
      "The three questions every drill has to pass.",
      "General versus specific transfer, and when to use each.",
      "Start with the whole, then break out the rate limiting factor.",
      "Set a constraint instead of giving a cue.",
      "Affordances, and why players do not make the read.",
    ],
    isNew: true,
    date_added: "2026-06-03T12:00:00Z",
  },
  {
    id: 9007,
    type: "module",
    moduleKey: "building-better-shooters",
    title: "Building Better Shooters",
    sub: "A live shooting clinic. The four types of shooting work, how to balance them, and how to coach young shooters.",
    desc: "Filmed live at the San Diego retreat. Building a shooter broken into four types of work: exploration, anchor, stress, and groove. Plus how to balance them, what really breaks down under fatigue, setting difficulty by the percentage, and how to coach young shooters. The full session plus 9 lesson cards.",
    tag: "Player Development",
    level: "All",
    duration: "37 min",
    thumb: "/images/mc-art-shooters.svg",
    keyPoints: [
      "The four types of shooting work: exploration, anchor, stress, groove.",
      "Why it is the sequencing, not the legs, that breaks down when tired.",
      "Set the difficulty by the percentage, not by feel.",
      "How to coach a growing shooter without locking in a technique.",
      "Cue for feel, then let them watch and imitate good shooters.",
    ],
    isNew: true,
    date_added: "2026-06-03T12:00:00Z",
  },
  {
    // Lead magnet — free for all subscribers + gated email capture for
    // public/non-registered users (Phase 2). Card 1 visible to public,
    // Cards 2-14 require email submission.
    id: 9005,
    type: "module",
    moduleKey: "modern-point-guard",
    free: true,
    publicSlug: "modern-point-guard",
    title: "Building the Modern Point Guard",
    sub: "A diagnostic-driven system for developing point guards at every stage",
    desc: "A 13-chapter walkthrough of how to develop a point guard with intention. Identify the rate limiters that cap their game, recognize the superpowers that make them dangerous, place them in one of four modern archetypes, then run a four-pillar development plan tuned to their stage. The Card 5 diagnostic is the one most coaches end up bookmarking. Free to read, no fluff.",
    tag: "Player Development",
    level: "All",
    duration: "~45 min",
    thumb: "/images/mc-art-pointguard.svg",
    keyPoints: [
      "The 4 rate limiters every PG has to clear (and why pressure-handling is the silent killer)",
      "The 8 superpowers that separate functional from dangerous",
      "The 4 archetypes of the modern PG (Quarterback, Downhill Creator, Shot-First, Floor Architect)",
      "The diagnostic worksheet you can run on the player on your roster today",
      "Stage-specific development for under-14, 14-18, and 18+",
    ],
    isNew: false,
    date_added: "2026-04-15T12:00:00Z",
  },
  {
    // Drops Thursday May 22, 2026 at 9am ET (13:00 UTC, EDT). Card
    // shows a "Drops May 22" pill before that timestamp; clicking
    // before the date lands on a countdown view instead of the reader.
    id: 9003,
    type: "module",
    moduleKey: "simplifying-the-science",
    availableAt: "2026-05-22T13:00:00Z",
    title: "Simplifying the Science",
    sub: "An exclusive coaches webinar on what the research actually says, and how to use it.",
    desc: "A 2-hour webinar that pulls the most useful research on motor learning, decision training, and constraint design into language you can run with on Monday. Plus a slide-by-slide breakdown of the lines worth keeping.",
    tag: "Coaching Concepts",
    level: "All",
    duration: "1h 56min",
    thumb: "/images/mc-art-simplifying.svg",
    keyPoints: [
      "What the research actually says about practice design.",
      "How to use constraints without overcomplicating drills.",
      "The decision-training lens, in plain English.",
      "What to keep, what to ignore, what to test on your team.",
    ],
    isNew: false,
    date_added: "2026-05-22T13:00:00Z",
  },
  {
    // Drops Thursday June 5, 2026 at 9am ET. Two weeks after the first
    // webinar so coaches have time to digest before the next one lands.
    id: 9004,
    type: "module",
    moduleKey: "truths-of-coaching",
    availableAt: "2026-06-05T13:00:00Z",
    title: "Truths of Coaching I Wish I Knew 10 Years Ago",
    sub: "A short, direct talk on the lessons that took the longest to learn the hard way.",
    desc: "27 minutes of the truths every coach eventually learns, told in advance so you don't have to learn them the same way. Slide-by-slide breakdown follows the video.",
    tag: "Coaching Concepts",
    level: "All",
    duration: "27 min",
    thumb: "/images/mc-art-truths.svg",
    keyPoints: [
      "The mistakes worth making and the ones that cost you years.",
      "What to stop doing immediately.",
      "What only experience teaches, and how to shortcut some of it.",
    ],
    isNew: false,
    date_added: "2026-06-05T13:00:00Z",
  },
  {
    id: 9002,
    type: "module",
    moduleKey: "rikki-broadmore-clinic",
    free: true,
    publicSlug: "rikki-broadmore",
    title: "Rikki Broadmore - Coaches Clinic",
    sub: "Full clinic - free preview of the platform",
    desc: "A full coaches clinic from Rikki Broadmore, made available free as a preview of By Any Means Coaches. Shareable on a public link so prospective members can watch the whole thing without creating an account.",
    tag: "Team Coaching",
    guest: true,
    level: "All",
    duration: "Full clinic",
    thumb: "/images/mc-art-rikki.svg",
    keyPoints: [
      "Full coaches clinic from Rikki Broadmore",
      "Free to watch - no account required",
      "Shareable preview link for prospective members",
    ],
    isNew: false,
    date_added: "2026-05-11T12:00:00Z",
  },
  {
    id: 9001,
    type: "module",
    moduleKey: "aau-dev-first",
    title: "The Development-First AAU Model",
    sub: "How to build players, teams, and culture inside the chaos of AAU",
    desc: "An 8-chapter interactive guide for coaches and directors running AAU or club programs. Built from our years at ADAPT Academy, it walks through structured speed, advantage flow, spacing, defense, practice design, skills training, PDPs, and culture. Includes 6 embedded film clips, self-assessments, and a personalized program audit at the end.",
    tag: "Team Coaching",
    level: "All",
    duration: "~45 min",
    thumb: "/images/mc-art-aau.svg",
    keyPoints: [
      "Structured speed - organizing transition without killing it",
      "Advantage flow - creation, maintenance, and finishing",
      "Spacing principles - triangles, make them choose, let them see you",
      "Practice design for limited time + a safe-to-fail coaching style",
      "Player Development Plans and culture that holds up under AAU chaos",
    ],
    isNew: false,
    date_added: "2026-04-25T12:00:00Z",
  },
];

export const EXPANDED_MEMBERS = [];
export const EXPANDED_MEMBER_PINS = [];
export const EXPANDED_POPUP_DATA = [];
export const EXPANDED_POSTS = [];
export const EXPANDED_PLAYBOOKS = [];
export const EXPANDED_LEADERBOARD = [];
